export default {
  "bcase": {
    "header": {
      "tooltip": {
        "save": "Save",
        "edit_enable": "Enable editing",
        "edit_disable": "Disable editing",
        "maximize": "Maximize",
        "minimize": "Minimize",
        "attachments": "Attachments"
      }
    }
  },
    "oauth2_consent": {
        "title": "Allow {application} to access Liftbase?",
        "intro": "Review what this application will be able to access before you continue.",
        "application": "Application",
        "client_id": "Application ID",
        "callback": "Callback destination",
        "identity_notice": "The application name comes from the connecting app. Verify the callback destination before allowing access.",
        "permissions": "Permission",
        "duration": "Access duration",
        "token_lifetime": "Token lifetime",
        "token_lifetime_value": "{accessMinutes} minutes",
        "renewal": "Renewal without prompt",
        "renewal_value": "up to {authorizationDays} days",
        "readonly": "Read only",
        "notice": "Access remains limited by your existing Liftbase permissions and applies only to this application.",
        "allow": "Allow access",
        "deny": "Deny",
        "submit_error": "Could not start the authorization. Please try again.",
        "submit_error_invalid_request": "This authorization request expired or is invalid. Start the connection again from the application.",
        "submit_error_invalid_redirect": "The application callback destination is invalid. Start the connection again.",
        "error_title": "The authorization request is invalid",
        "error_description": "Return to the application and start the connection again.",
        "unverified_title": "Unverified application",
        "unverified_warning": "This application has not been verified by Liftbase as a trusted third-party provider. The displayed name may come from another provider. Check the redirect URL carefully before allowing access.",
        "scope": {
            "mcp": {
                "title": "Read permitted Liftbase data",
                "description": "Procurements, invoices, contracts, workflows, bank statements and liquidity planning — read only, no write access."
            }
        }
    },
    "administration": "Administration",
    "master_data": "Master Data",
    "admin_page": {
        "no_permission": "You do not have permission to access the administration area.",
        "confirm_before_delete_msg": "Do you really want to remove this entry? (ID #{id})",
        "confirm_before_delete_from_db_msg": "Do you really want to delete this entry? (ID #{id})",
        "confirm_before_delete_from_db_title": "Delete Permanently",
        "confirm_before_delete_from_db_btn": "Delete",
        "block_user_msg": "Do you really want to block {name}? The person will then be unable to log in.",
        "block_user_title": "Login Block",
        "block_user_btn": "Block",
        "unblock_user_msg": "Do you really want to unlock {name}? The person will then be able to log in again.",
        "unblock_user_title": "Unlock Login",
        "unblock_user_btn": "Unlock",
        "tour": {
            "menu_title": "Sections",
            "menu": "Here you can see the sections of the administration area where you can manage and edit master data and settings.",
            "client_menu_title": "Manage Companies",
            "client_menu": "Here you can add, view, or edit all companies.",
            "client_list": "Here you can see all companies.",
            "new_client": "Click here to set up a new company.",
            "view_mode": "<p>Here you can switch from list view to table view to set up multiple entries at once or to have a better overview.</p> Table view can also be used for data export or import. Don't forget to save the table after editing."
        }
    },
    "version": "Version",
    "yes": "Yes",
    "no": "No",
    "recommended": "Recommended",
    "never": "Never",
    "add": "Add",
    "edit": "Edit",
    "delete": "Delete",
    "save": "Save",
    "cancel": "Cancel",
    "apply": "Apply",
    "next": "Next",
    "back": "Back",
    "finish": "Finish",
    "ok": "Ok",
    "open": "Open",
    "dashboard": "Dashboard",
    "dashboards": "Dashboards",
    "einvoice_dashboard": "E-invoice Dashboard",
    "invoice_dashboard": "Incoming Invoice Dashboard",
    "outgoing_invoice_dashboard": "Outgoing Invoice Dashboard",
    "overview": "Overview",
    "operator": "Operator",
    "profile": "Profile",
    "help": "Help",
    "logout": "Logout",
    "tenant_switcher": {
        "error": "The tenant could not be changed.",
        "error_passkey": "Tenant switching is not available for passkey sessions.",
        "error_saml": "This tenant cannot be opened from the current SSO session."
    },
    "list_view": "List View",
    "table_view": "Table View",
    "archive": "Archive",
    "active": "Active",
    "email": "Email",
    "name": "Name",
    "tax": "Tax (%)",
    "value": "Amount",
    "number": "Number",
    "currency": "Currency",
    "actions": "Actions",
    "system": "System",
    "from": "From",
    "of": "Of",
    "until": "until",
    "up_to": "up to",
    "show_more": "Show more",
    "refresh": "Refresh",
    "calculate": "Calculate",
    "calc_brutto_from_net": "Calculate Gross from Net",
    "calc_net_from_brutto": "Calculate Net from Gross",
    "cost_center_id": "Cost Center",
    "cost_centers": "Cost Centers",
    "budget_id": "Budget",
    "budgets": "Budgets",
    "branch_id": "Branch",
    "branches": "Branches",
    "employee_id": "Employee",
    "employees": "Employees",
    "vehicles": "Vehicles",
    "financial_dimension_id": "Financial Dimension",
    "financial_dimensions": "Financial Dimensions",
    "tax_group_id": "Sales Tax Group",
    "tax_groups": "Sales Tax Groups",
    "tax_item_group_id": "Sales Tax Item Group",
    "tax_item_groups": "Sales Tax Item Groups",
    "profit_center_id": "Profit Center",
    "profit_centers": "Profit Centers",
    "client_id": "Company",
    "clients": "Companies",
    "ai_prompts": "Prompts",
    "ai_prompt": {
        "description": "Prompt",
        "title": "Title",
        "slug": "Slug",
        "category": "Category",
        "active": "Active",
        "is_published": "Published",
        "changelog": "Changelog",
        "system_prompt": "System Prompt",
        "developer_prompt": "Developer Prompt",
        "user_prompt_tpl": "User Prompt Template",
        "output_format": "Output Format",
        "output_schema": "Output Schema",
        "preview": "Preview",
        "context_json": "Context JSON",
        "output_json": "Output (JSON)",
        "highlighted_preview": "Highlighted Preview",
        "apply_placeholders": "Apply Placeholders",
        "available_objects": "Available objects",
        "search_objects": "Search objects and fields",
        "suggestions": "Suggestions",
        "fields": "Fields",
        "relations": "Relations",
        "execute": "Execute",
        "execute_prompt": "Execute Prompt",
        "simulated_result_message": "This is a simulated result of the prompt execution.",
        "test_data_selection": "Test Data Selection",
        "click_to_see_result": "Click on \"{action}\" to see the result.",
        "tab_general": "General",
        "tab_content": "Content",
        "tab_test": "Test",
        "page": {
            "new": "New Prompt",
            "validation": {
                "title_required": "Please enter a title.",
                "slug_required": "Please enter a slug."
            }
        }
    },
    "department_id": "Department",
    "departments": "Departments",
    "d365_branch_id": "Branch",
    "d365_employee_id": "Employee",
    "d365_department_id": "D365 Department",
    "d365_area_id": "D365 Area",
    "d365_labor_wert_id": "D365 Labor Value",
    "d365_project_id": "D365 Project",
    "d365_sales_channel_id": "D365 Sales Channel",
    "d365_vehicle_id": "Vehicle",
    "d365_branches": "Branches",
    "d365_employees": "Employees",
    "d365_departments": "D365 Departments",
    "location_id": "Location",
    "consignee_id": "Receipt of Goods",
    "address_id": "Delivery Address",
    "cost_type_id": "Cost type",
    "incoming_revenue_type": "Revenue type",
    "incoming_revenue_type_id": "Revenue type",
    "lb_user_id": "Person",
    "users": "People",
    "task_group_id": "Task Group",
    "task_groups": "Task Groups",
    "user_task_group": "User/Task Group",
    "user_task_groups": "Users/Task Groups",
    "product": "Product",
    "products": "Product Catalog",
    "product_group_id": "Product Group",
    "product_groups": "Product Groups",
    "supplier_id": "Supplier",
    "business_partner_id": "Business Partner",
    "suppliers": "Suppliers",
    "business_partners": "Business Partners",
    "procurement_id": "Purchase Order",
    "procurements": "Purchase Orders",
    "contract_id": "Contract",
    "contracts": "Contracts",
    "user_select_product_id": "Person 'Product Selection'",
    "user_send_order_id": "Person 'Order Placement'",
    "user_clearing_id": "Person 'Procurement Clearing'",
    "user_consignee_id": "Person 'Receipt of Goods'",
    "user_invoice_manual_check_id": "Person 'Manual Check (Invoice)'",
    "user_invoice_clearing_id": "Person 'Accounting Clearing'",
    "user_accounting_id": "User 'Accounting'",
    "user_contract_clearing_id": "Person 'Contract Clearing'",
    "ledger_account_id": "Ledger Account",
    "ledger_accounts": "Ledger Accounts",
    "posting_key_id": "Posting Key",
    "posting_keys": "Posting Keys",
    "permission_id": "Permission Group",
    "permissions": "Permission Groups",
    "invoices": "Invoices",
    "invoice_id": "Invoice",
    "outgoing_invoice_id": "Outgoing invoice",
    "outgoing_invoices": "Outgoing invoices",
    "configurations": "Settings",
    "marketplace_id": "Marketplace",
    "provider_id": "Marketplace Provider",
    "notes": "Note",
    "search": "Search",
    "no_data": "No entries found",
    "months": "Months",
    "select_valid_option": "Select a valid entry.",
    "price_restricted": "Price information is currently disabled.",
    "procurement_line": {
        "description": "Product",
        "item_number": "Item Number",
        "is_cost_center_fixed": "Fixed Preset",
        "image_url": "Image URL",
        "webshop_url": "Shop URL",
        "offer_number": "Offer Number",
        "offer_date": "Offer Date",
        "include_tax": "incl. {tax} VAT",
        "offer_msg": "According to offer {offer_number}",
        "offer_date_msg": "on {offer_date}",
        "delivery_completed": "Line completed",
        "total_price_brutto": "Total gross",
        "total_price_netto": "Total net",
        "type_total_price_brutto": "currency",
        "type_price_brutto": "currency",
        "type_total_price_netto": "currency",
        "type_price_netto": "currency"
    },
    "product_catalog": {
        "description": "Item",
        "alias": "Description for search",
        "add_product_btn": "Add Product",
        "item_number": "Item Number",
        "is_cost_center_fixed": "Fixed Assignment",
        "image_url": "Image URL",
        "webshop_url": "Shop URL",
        "offer_number": "Offer Number",
        "offer_date": "Offer Date",
        "type_price_netto": "currency",
        "type_price_brutto": "currency",
        "form_sequence": "name,item_number,product_group_id,supplier_id,location_id,cost_center_id,is_cost_center_fixed,tax,price_netto,price_brutto,unit,image_url,webshop_url,offer_number,offer_date",
        "page": {
            "new": "New Product",
            "supplier_tooltip": "Select a supplier from your master data or add a new one by typing a new name.",
            "supplier_new_tooltip": "This supplier will be saved in your master data when adding the product.",
            "should_save": "Save in Product Catalog",
            "sections": {
                "basic": "Basic information",
                "supplier": "Classification and supplier",
                "pricing": "Pricing and tax",
                "accounting": "Accounting",
                "media_offer": "Media and offer",
                "permissions": "Permissions"
            },
            "validation": {
                "name_required": "Please enter a name.",
                "supplier_required": "Please select a supplier or add a new one.",
                "image_url_invalid": "Please enter a valid URL.",
                "webshop_url_invalid": "Please enter a valid URL.",
                "tax_invalid": "Please enter a valid tax rate."
            },
            "tour": {
                "name": "Provide a significant name for the product.",
                "number": "Here, you can enter the product's item number.",
                "product_group": "Choose the product group to which the product belongs.",
                "supplier": "Choose the product's supplier from which it should be ordered.",
                "price": "Specify a tax rate and a net or gross price. The other price will be calculated using the tax rate.",
                "unit": "Indicate the unit in which the product is measured, e.g. \"items\", \"kg\", or \"liters\".",
                "url": "You can add an image URL to the product here. Additionally, if available, you can add a link to the product's page on the shop.",
                "offer": "If there is an offer for the product, you can enter the offer number and date here to display them on the order PDF.",
                "btn_save": "Save the product in the product catalog once you've added all the information."
            }
        }
    },
    "product_group": {
        "form_sequence": "name,description,user_select_product_id",
        "page": {
            "new": "New Product Group",
            "no_product_group": "Without item group",
            "validation": {
                "name_required": "Please enter a name."
            },
            "tour": {
                "name": "Provide a meaningful name for the product group.",
                "btn_save": "Once you've provided all the information, add the product group."
            }
        }
    },
    "procurement": {
        "description": "Purchase Order",
        "order_description": "Order",
        "name": "Name",
        "number": "Bestellnummer",
        "order_number_formatted": "Bestellnummer",
        "contract_number": "Contract number",
        "creator_id": "Created by",
        "created_at": "Created Date",
        "delivery_date": "Delivery Date",
        "delivery_address_id": "Delivery Address",
        "billing_address_text": "Billing Address",
        "status": "Status",
        "show_notes_pdf": "Show in order PDF",
        "open_value": "Open order value",
        "open_value_recurring": "∞ dKueZ",
        "open_value_exceeds_with_invoice": "This invoice exceeds the order value.",
        "total_brutto": "Total Gross",
        "total_netto": "Total Net",
        "total_netto_abbr": "-Net",
        "payment_in_advance": "Payment in advance",
        "has_invoices": "Invoice recorded",
        "invoice_count": "Invoices (quantity)",
        "completely_invoiced": "Completely invoiced",
        "is_fully_allocated": "Completely invoiced",
        "payment_timing": "Payment type",
        "usage_type": "Frequency",
        "type": "Order Type",
        "type_options": {
            "single_invoice": "eKuez with single invoice",
            "recurring_invoice": "dKuez with single invoice",
            "recurring_contract": "dKuez with recurring invoice"
        },
        "statuses": {
            "open": "Product Selection",
            "approved": "Order Placement",
            "ordered": "Waiting for Delivery",
            "declined": "Declined",
            "completed": "Completed",
            "historical-imported": "Historically imported",
            "approval": "Approval",
            "clearing": "Procurement Clearing",
            "draft": "Draft"
        },
        "page": {
            "ai_fill_menu": "Fill order with AI",
            "completely_invoiced_auto_tooltip": "Marked automatically by the system because the allocated invoice amount is equal to or higher than the order value.",
            "completely_invoiced_final_invoice_tooltip": "Marked as completely invoiced by {invoices}.",
            "completely_invoiced_final_invoice_tooltip_prefix": "Marked as completely invoiced by ",
            "completely_invoiced_final_invoice_tooltip_separator": ", ",
            "completely_invoiced_final_invoice_tooltip_suffix": ".",
            "ai": {
                "title": "Procurement Assistant (AI)",
                "months": "Period (months)",
                "products_limit": "Products (count)",
                "suppliers_limit": "Suppliers (count)",
                "contracts_limit": "Contracts (count)",
                "order_without_template_btn": "Order without template",
                "or_create_based_on_existing_msg": "or create a new order based on the following existing orders or contracts:",
                "recent_products": "Your recently ordered products",
                "top_products": "Top products",
                "top_suppliers": "Top suppliers",
                "orders_count": "{n} orders",
                "active_contracts": "Active contracts",
                "contract_end_date": "End date",
                "procurements_count": "{n} orders",
                "loading_text": "Processing your AI suggestion…",
                "processing_title": "Creating your order with AI",
                "processing_subtitle": "This may take 15–20 seconds. Please keep this page open.",
                "invoices_count": "{n} invoices",
                "msg_success": "Order data has been prefilled automatically",
                "msg_not_found": "No matching order found",
                "msg_failed": "AI suggestion failed",
                "msg_not_possible": "AI prefill not possible",
                "magic_order": {
                    "label": "Create order based on recent purchase habits",
                    "tooltip": ""
                }
            },
            "new_from_contract": "Order from contract",
            "no_delivery_address": "No Delivery Address",
            "no_budget": "No budget",
            "new": "New Purchase Order",
            "create_btn": "Start Purchase Order",
            "copy_btn_tooltip": "Copy Purchase Order",
            "magic_suggestions_btn_tooltip": "Get smart suggestions based on dynamic criteria (recent purchases, suppliers, contracts).",
            "magic_suggestions_no_data": "No AI suggestions found for the selected criteria.",
            "magic_suggestions_applied": "AI suggestions applied.",
            "magic_suggestions_dialog": {
                "title": "Suggestions for this purchase order",
                "message": "Select the fields you want to fill based on AI suggestions.",
                "info_based_on_last_order": "This suggestion was generated by AI based on your most recent order.",
                "no_data": "No suggestions found for this purchase order."
            },
            "offer_document": {
                "add_from_document": "Add from offer document",
                "dialog_title": "Import lines from offer",
                "loading_text": "Recognizing offer...",
                "upload_info1": "Drag the offer PDF here <br>or <br> <em>select file</em>.",
                "upload_info2": "PDF files up to 30MB.",
                "preview_message": "Select the lines that should be added as products.",
                "no_lines": "No offer lines found.",
                "new_upload": "Discard & upload new",
                "retry": "Try again",
                "retry_wait": "or wait a few more seconds",
                "file_invalid": "Please upload PDF files only.",
                "file_too_large": "Please upload files up to 30MB only.",
                "extract_failed": "The offer could not be recognized.",
                "file_save_failed": "The offer PDF could not be saved.",
                "lines_applied": "Offer lines added.",
                "supplier_required": "Please select a supplier before importing the lines.",
                "supplier_recognized": "Recognized supplier: {supplier_name}.",
                "supplier_missing": "Please select or create a supplier.",
                "create_supplier": "Create \"{supplier_name}\"",
                "create_supplier_confirm_title": "Create supplier",
                "create_supplier_confirm_message": "Do you want to create \"{supplier_name}\" as a new supplier?",
                "create_supplier_confirm_btn": "Create",
                "create_supplier_success": "Supplier created.",
                "create_supplier_failed": "The supplier could not be created.",
                "supplier_note_website": "Website",
                "supplier_note_contact": "Contact",
                "supplier_note_extra_ibans": "Additional IBANs"
            },
            "delivery_date_tooltip": "The delivery date will be printed on the order PDF and can then be sent to the supplier.",
            "order_sender": "Order Placement",
            "product_selector": "Product Selection",
            "product_search": "Search Products",
            "before_leave_msg": "Your purchase order has not been saved. Are you sure you want to leave the page?",
            "confirm_without_approval_limit_msg": "None of the selected individuals have the necessary approval limit for the value of this order. Additional approvals can be added later. Are you sure you want to proceed?",
            "confirm_without_approval_limit_title": "Approval Limit",
            "confirm_product_selection_without_product_msg": "You haven't selected any product. Are you sure you want to proceed?",
            "confirm_product_selection_without_product_title": "No Product Selected",
            "no_approval_limit_msg": "Your approval limit is not sufficient for this order. Please add another person with an adequate approval limit for approval.",
            "no_approval_limit_title": "Approval Limit",
            "product_group_missing_msg": "All products must be assigned to a product group. Go to the 'Product Groups' tab above the product list and assign a product group to each product.",
            "product_group_missing_title": "Assign Product Group",
            "product_group_missing_btn": "Understood",
            "min_approval_one_person": "1 Person",
            "min_approval_qty": "{qty} different persons",
            "min_approval_error_msg": "The approval is not sufficient for this purchase order. Please add another person for approval. This purchase order must be approved by <b>at least {min_approval_msg}</b>.",
            "min_approval_error_title": "Insufficient Approval",
            "order_not_completed_msg": "You haven't placed orders for all products or confirmed them. Make sure you have ordered all products in the product list and confirm them if necessary to proceed.",
            "order_not_completed_title": "Complete Orders First",
            "order_not_completed_btn": "Understood",
            "confirm_delivery_not_completed_msg": "You haven't confirmed all receipts of goods. Are you sure you want to complete the purchase order? <br> <i>This action cannot be undone</i>.",
            "confirm_delivery_not_completed_title": "Outstanding Receipts of Goods",
            "confirm_delivery_not_completed_btn": "Complete",
            "default_confirm_btn": "Continue",
            "budget_exceeded_msg": "Budget Exceeded",
            "approval_limit_exceeded_msg": "Approval Limit Exceeded",
            "external_order_number_msg": "Enter the external order number.",
            "external_order_number_title": "Enter External Order Number",
            "no_edit_permission": "You lack the permission to edit the data. Please submit the purchase order for clearing via actions to make changes to the data.",
            "add_invoice_after_order_message": "You can create an invoice after starting the purchase requisition.",
            "no_invoice": "No invoices have been recorded for this purchase requisition yet.",
            "tabs": {
                "lines": "Items",
                "invoices": "Invoices"
            },
            "delivery_dialog": {
                "title": "Confirm Receipt of Goods",
                "confirm_btn": "Confirm",
                "message": "Enter the quantity received recently.<br> {missing_qty} of {quantity} {unit} are missing.",
                "qty_exceeded_msg": "The missing quantity must not be exceeded.",
                "qty_must_be_greater_msg": "The quantity must be greater than 0.",
                "invalid_format": "Use a valid numeric format."
            },
            "order_sender_dialog": {
                "title": "Role Defaults for Order Placement",
                "info": "The person in the 'Order Placement' step is determined based on the role defaults for the department, the company, global role defaults, and the person who created the purchase order. The person at the top of the list is preselected for the task."
            },
            "consignee_dialog": {
                "title": "Role Defaults for Receipt of Goods",
                "info": "The person in the 'Receipt of Goods' step is determined based on the role defaults for the department, the company, global role defaults, and the person who created the purchase order. The person at the top of the list is preselected for the task."
            },
            "select_product_dialog": {
                "title": "Role Defaults for Product Selection",
                "info": "The person in the 'Product Selection' step is determined based on the role defaults for the department, the company, global role defaults, and the person who created the purchase order. The person at the top of the list is preselected for the task."
            },
            "marketplace_change_dialog": {
                "title": "Order will be canceled",
                "info": "A change in the company has been detected. However, there is an order in the marketplace {marketplace_name} that is not linked to the new company {client_name}. If you proceed, this order will be canceled.",
                "btn_confirm": "Cancel order"
            },
            "dialog_assignment": {
                "department_form": "Department in Form",
                "department_creator": "Department of Ordered-by Person",
                "client_form": "Company in Form",
                "client_creator": "Company of Ordered-by Person",
                "no_selection": "Not Yet Selected",
                "no_action": "Not Applicable",
                "configuration": "Global Role Default"
            },
            "draft": {
                "title": "Draft",
                "save": "Save Draft",
                "delete": "Delete Draft",
                "confirm_before_delete_msg": "Are you sure you want to delete this draft permanently?",
                "confirm_before_delete_title": "Delete Draft",
                "confirm_before_delete_btn": "Delete"
            },
            "punchout": {
                "pending_msg": "There are pending products from Punchout.",
                "error_title": "Punch-out Error",
                "error_msg": "An error occurred. Please check the Punch-out settings or contact a person with administrator rights.",
                "error_start_url_msg": "No start URL provided, Punch-out cannot be initiated.",
                "error_invalid_domain_msg": "The credentials are invalid. Please check the punch-out configuration or contact your administrator.",
                "error_invalid_credentials_msg": "{provider} rejected the login for the email \"{email}\" because the domain \"{domain}\" is not enabled in the {provider} account. Therefore, the punch-out cannot be started.",
                "no_config": "Please set up the configuration first to use Punch-out.",
                "no_config_by_client": "This supplier is not allowed for the currently selected company. <br>Please choose a compatible company or adjust the settings.",
                "pending_dialog": {
                    "title": "Pending Products from Punchout",
                    "add_products": "Add to Order",
                    "add_all_products": "Add All to Order",
                    "delete_products": "Remove Products"
                },
                "log_dialog": {
                    "title": "{supplier_name} Request",
                    "request": "Request",
                    "response": "Response",
                    "no_log": "No Log",
                    "url": "Url",
                    "header": "Header",
                    "method": "Method",
                    "body": "Body"
                },
                "delete_dialog": {
                    "title": "Remove Products from {supplier} #{index}",
                    "info1": "Do you really want to remove all the following products from {supplier} #{index}?",
                    "info2": "This action cannot be undone.",
                    "delete_btn": "Remove"
                },
                "loading": "Please complete your product selection in the opened pop-up. If no pop-up appears, you need to allow it first.",
                "can_not_edit": "Punch-out products cannot be edited. Please perform Punch-out again or delete the entire shopping cart.",
                "no_provider_found": "Unfortunately, the selected Punch-out provider is not yet supported."
            },
            "download_pdf": {
                "title": "Download PDF",
                "confirm_btn": "Confirm",
                "title_confirm_save_changes": "Save Unsaved Data",
                "text_confirm_save_changes": "Do you want to save the unsaved data and apply it to the purchase document?",
                "invalid_form": "Please fill in all required fields in the form before proceeding with the action."
            },
            "lines": {
                "no_line": "No products selected, please add products.",
                "add_lines_from_contract": "Add all items from the contract",
                "show_all_info": "Advanced View",
                "invoice": {
                    "title": "Invoice",
                    "created_at": "Recorded",
                    "date": "Invoice Date",
                    "created_by": "Created By"
                },
                "automatic_order": "Send Electronically",
                "automatic_ordered": "Electronically Sent",
                "supplier_connect_order": "Send via SupplierConnect",
                "manual_order_confirmation": "Confirm manually",
                "confirm_order": "Confirm Order",
                "finish_order": "Finish Order",
                "order_finished": "Order Completed",
                "confirm_order_tooltip": "Please note that you need to <b>send the order to the supplier via email</b>, the order will <b>not be transmitted electronically.</b>",
                "ordered_at": "Transmitted",
                "ordered_by": "By",
                "confirm_receipt": "Confirm receipt of goods",
                "no_cost_center": "No Cost Center",
                "include_taxes": "incl. VAT",
                "budget": "Budget",
                "no_budget": "No Budget",
                "no_product_group": "No Product Group",
                "no_ledger_account": "No ledger account",
                "select_product": "Product Selection",
                "quantity_to_show": "received: <b>{quantity_received}/{quantity}</b>",
                "delivery_completed": "Line completed",
                "from": "from",
                "item_number": "Item No. #",
                "delete_msg": "Are you sure you want to remove this product?",
                "delete_title": "Remove Product",
                "delete_btn": "Remove",
                "automatic_order_dialog": {
                    "confirm_order": "Send Order",
                    "confirm_order_btn": "Send",
                    "finish_order": "Finish Order",
                    "finish_order_btn": "Finish",
                    "info1": "Do you want to <span style=\"font-weight: bold\">electronically submit</span> this order to the supplier <span style=\"font-weight: bold\">now</span>?",
                    "info2": "This action cannot be undone."
                },
                "order_dialog": {
                    "confirm_order": "Confirm Order",
                    "confirm_order_btn": "Confirm",
                    "finish_order": "Finish Order",
                    "finish_order_btn": "Finish",
                    "info1": "Have you transmitted the order to the supplier? (e.g., via email or fax)",
                    "info2": "This action cannot be undone."
                },
                "more_actions": {
                    "delete_products": "Remove Products",
                    "add_external_id": "Add External Order Number",
                    "download_pdf": "Order (PDF)",
                    "download_pdf_with_attachments": "Order including PDF attachment",
                    "write_email": "Compose Email",
                    "email_with_pdf": "E-Mail with PDF",
                    "show_cxml": "Show Punchout CXML"
                },
                "file": {
                    "open_btn": "Open PDF",
                    "add_btn": "Add PDF",
                    "upload_info1": "Drag and drop here <br>or <br> <em>select file</em>.",
                    "upload_info2": "PDF files up to 30MB.",
                    "delete_msg": "Do you really want to remove this document?",
                    "delete_title": "Remove Document",
                    "delete_btn": "Remove",
                    "delete_error_msg": "The document could not be removed."
                }
            },
            "validation": {
                "delivery_date_format": "Please enter a delivery date.",
                "client_id_required": "Please select a company.",
                "department_id_required": "Please select a department.",
                "department_id_required_client_missing": "First select company.",
                "cost_center_id_required": "Please select a cost center.",
                "cost_center_id_required_filters_missing": "First select company and department.",
                "cost_center_id_required_department_missing": "First select department.",
                "cost_center_id_required_client_missing": "First select company.",
                "ledger_account_id_required": "Please select a ledger account.",
                "consignee_id_required": "Please select a responsible person.",
                "delivery_address_id_required": "Please select a delivery address.",
                "billing_address_text_required": "The billing address is missing in the company data.",
                "usage_type_required": "Please select a rhythm.",
                "payment_timing_required": "Please select a payment type."
            },
            "tour": {
                "main": {
                    "description": "In the first fields, specify a name for the purchase request, as well as your company and the department for which the order is to be made. The department is filtered based on the company, and the cost center is filtered based on the department.",
                    "organization": "Specify the company, department, and cost center for the purchase order. The list of departments is filtered by the selected company and the list of cost centers is filtered by the selected department.",
                    "address": "The delivery address will be provided to the supplier. You can choose from the company's addresses, the person in charge of receiving the goods, and your own addresses.",
                    "total": "Here, you can see the total value of your purchase order, which is the sum of the selected products.",
                    "delivery_date": "The delivery date can be recorded after the receipt of goods for documentation purposes. It will not be sent to the supplier.",
                    "product_selector": "This shows who is responsible for product selection in the next step. It depends on various role defaults, for more detail click the info icon.",
                    "order_sender": "This shows who is responsible for order placement, which depends on various role defaults. For more detail click the info icon.",
                    "consignee": "Select the person who will receive the goods and confirm the receipt in the final step of the purchase order to complete the process.",
                    "approvers": "Here, you see if approval has been set up for the selected cost center. You can also add people for approval.",
                    "product_search": "Here, you can search for a product in the internal product catalog and add it to the purchase order.",
                    "punchout": "Here, you can select products from integrated marketplaces like Amazon or Mercateo. The product selection can be transmitted electronically to the marketplace after the approval.",
                    "new_product": "If your desired product is not in the product catalog, you can add it to the purchase order here.",
                    "save_btn": "When you have entered all the required information, you can start the purchase order process and proceed to the next step."
                },
                "product": {
                    "pdf": "Here you can add documents to the product.",
                    "remove": "You can also remove products from the selection by clicking here.",
                    "more_actions": "You can document the external order number here upon receipt.",
                    "tabs": "Here, you can group the view of your products by supplier, cost center, or product group.",
                    "expand_view": "Here, you can show or hide advanced settings for the products and select a cost center, delivery address, or product group."
                },
                "new_product": {
                    "name": "Provide a meaningful name for the product.",
                    "number": "You can also enter an item number for the product.",
                    "supplier": "Select the supplier from which the product is offered or from which it should be ordered.",
                    "price": "Specify a tax rate and a net or gross price. The other price will be calculated using the tax rate.",
                    "unit": "Specify the unit of measurement for the product, such as \"items\", \"kg\", or \"liters\".",
                    "url": "You can add an image URL for the product and a link to the product's page on the shop, if available.",
                    "offer": "If there is an offer for the product, you can enter the offer number and date here to display them on the order PDF.",
                    "should_save": "Here, you choose to add the created product to the product catalog. This ensures that this specific product will be available for future orders.",
                    "save_btn": "Add the product to the purchase order when you have entered all the information."
                },
                "cost_center_view": "Cost centers can also be assigned to individual products in a purchase order. The delivery addresses associated with the cost center can then be selected for the product.",
                "product_group_view": "Each product can be assigned to a product group. The person responsible for the product group will receive a task in the timeline to edit or confirm the product selection.",
                "send_order": {
                    "send_btn": "In the order confirmation step, you can electronically send the order or confirm the order made via email with the supplier.",
                    "more_actions": "In the options for the selected supplier, you can generate an order PDF or an email with or without an order PDF for the supplier. This way, you can place the order with the company or make a query via email."
                },
                "delivery_btn": "If you have received a partial delivery or the entire order, you can indicate it here. Line items can also be marked as completed here. The confirmed receipt of goods will also be noted in the timeline."
            }

        }
    },
    "quantity": "Quantity",
    "price_netto": "Net Price",
    "price_brutto": "Gross Price",
    "unit": "Unit",
    "default_unit": "Item",
    "tenant": {
        "tab_general": "General",
        "description": "Tenant",
        "main_language": "Fallback Language",
        "show_invoices": "Show invoices menu",
        "monthly_document_limit": "Documents per month",
        "base_price": "Base price",
        "price_extra_document": "Price of each additional document",
        "monthly_procurement_limit": "Purchase Orders per Month in Basic Price",
        "monthly_invoice_limit": "Invoices per Month in Basic Price",
        "base_price_procurement": "Purchase Orders Base Price",
        "base_price_invoice": "Invoices Base Price",
        "price_extra_procurement": "Price for Each Additional Purchase Order",
        "price_extra_invoice": "Price for Each Additional Invoice",
        "invoice_recognition_unit_price": "Invoice recognition price per document",
        "invoice_recognition_custom_field_unit_price": "Price per document with Custom Fields",
        "ai_validation_unit_price": "AI validation including scoring price per document",
        "easybill_id": "Easybill ID",
        "bank_account": "Account Number",
        "bank_account_owner": "Account Holder",
        "bank_bic": "BIC",
        "bank_country": "Bank Country",
        "bank_code": "Bank Code",
        "bank_iban": "IBAN",
        "bank_name": "Bank Name",
        "address": "Billing Address",
        "sepa_agreement": "SEPA Direct Debit Agreement",
        "sepa_agreement_date": "SEPA - Mandate Entry Date",
        "sepa_mandate_reference": "Mandate Reference",
        "automatic_billing": "Automatically Generate Billing",
        "automatic_billing_mail": "Automatically Send Billing via Email",
        "bank": "Bank Connection",
        "datev": "DATEV",
        "billing_address_name": "Company",
        "billing_address_consignee_name": "Name of Recipient",
        "billing_address_street": "Street and No.",
        "billing_address_zipcode": "Postal Code",
        "billing_address_city": "City",
        "billing_address_state": "State",
        "billing_address_country": "Country",
        "billing_address_phone": "Phone Number",
        "contact_email": "Contact Email",
        "billing_email": "Billing Email",
        "contact": "Contact Information",
        "sepa": "SEPA Direct Debit",
        "add_sepa": "Add SEPA Direct Debit",
        "remove_sepa": "Revoke SEPA Direct Debit",
        "import_invoice_email": "Automatically import invoices via email",
        "send_email_notifications": "Send email notifications",
        "storage_usage": "Storage usage",
        "storage_current": "Current usage",
        "storage_included_gb": "Included storage (GB)",
        "storage_price_per_gb": "Price per additional GB",
        "storage_free_included": "Included free volume",
        "storage_billable": "Billable GB",
        "storage_billable_price": "Monthly extra cost",
        "storage_billing_hint": "The first {included} GB are free. Each additional started GB is charged at {price}.",
        "tab_mailbox": "Mailboxes",
        "debit_credit_reverse": "Swap account/counter-account",
        "default_decimal_places": "Default decimal places",
        "tab_sso": "Single Sign-On (SAML)",
        "sso_saml_enabled": "Enable SAML login",
        "sso_saml_provider_label": "Login button label",
        "sso_saml_entity_id": "Identity Provider Entity ID",
        "sso_saml_sso_url": "Identity Provider SSO URL",
        "sso_saml_x509_cert": "Identity Provider X509 certificate (PEM)",
        "sso_saml_sp_entity_id": "Service Provider Entity ID (optional)",
        "sso_saml_attr_email": "Email attribute name (optional)",
        "sso_saml_help": "Enable this only after values from your identity provider have been provided.",
        "sso_saml_validation_required": "Please fill all required SAML fields."
    },
    "datev_access": {
        "description": "DATEV Integration",
        "label_log": "DATEV Company (datev_client_id)",
        "label_log_fields": "datev_client_id",
        "connected_info": "Connection with DATEV has been established.",
        "disconnected_info": "Connection with DATEV has been removed.",
        "connected_client_info": "Connection with DATEV company {datev_client_id} has been established.",
        "disconnected_client_info": "Connection with DATEV company {datev_client_id} has been deactivated."
    },
    "ms365_access": {
        "description": "D365 Integration",
        "connected_info": "Connection to D365 established.",
        "disconnected_info": "Connection to D365 removed.",
        "data_loaded_info": "Data from D365 manually loaded.",
        "journal_created_info": "The D365 journal has been added.<br>Journal Name: {journal_name} <br>Org URL: {org_url}.",
        "journal_edited_info": "The D365 journal name has been edited: {journal_name}."
    },
    "client": {
        "description": "Company",
        "alias": "Company alias",
        "tab_invoice_recognition_prompt": "Custom prompt",
        "min_approval": "Minimum Number of Approvers",
        "branch_required": "The branch is required for the invoice form.",
        "department_required": "The department is required for the invoice form.",
        "cost_center_required": "The cost center is required for the order form.",
        "client_number": "Number",
        "consultant_number": "Consultant Number",
        "ledger_account_length": "Ledger Account Length",
        "vat_number": "VAT ID",
        "address_name": "Name",
        "consignee": "Name of Recipient - Billing Address",
        "dropoff_location": "Name of Drop-off Location - Billing Address",
        "address": "Street and No. - Billing Address",
        "address_complement": "Street 2 - Billing Address",
        "country": "Country - Billing Address",
        "zipcode": "Postal Code - Billing Address",
        "city": "City - Billing Address",
        "phone_country_code": "Phone Country Code - Billing Address",
        "phone_number": "Phone Number - Billing Address",
        "can_delete_document_directly": "Documents can be deleted without clearing.",
        "default_product_tax": "Standard tax rate (%)",
        "default_product_currency": "Default currency",
        "default_product_unit": "Default unit",
        "invoice_recognition_prompt": "Custom prompt for invoice recognition",
        "form_sequence": "name,email,client_number,currency,min_approval,user_select_product_id,user_send_order_id,user_clearing_id,user_consignee_id,user_invoice_manual_check_id,user_invoice_clearing_id",
        "page": {
            "tab_general": "General",
            "tab_bank_data": "Bank Data",
            "tab_billing_address": "Billing Address",
            "tab_shipping_address": "Shipping Addresses",
            "tab_default_roles": "Default Roles",
            "tab_communication_signature": "Communication Signature",
            "tab_permissions": "Permissions",
            "tab_departments": "Departments",
            "tab_cost_centers": "Cost Centers",
            "tab_ledger_accounts": "Ledger Accounts",
            "tab_required_fields": "Mandatory Fields",
            "tab_datev_csv": "DATEV CSV Export",
            "new": "New Company",
            "invoice_recognition_prompt_placeholder": "E.g. apply these instructions when recognizing invoices for this company.",
            "select_logo": "Select Logo",
            "select_logo_tooltip_content": "Add a logo that will be printed on the order documents of your approved orders. It's best to use an image file with transparent background.",
            "communication_signature_html": "Supplier communication signature",
            "communication_signature_html_hint": "This HTML signature is automatically prefilled in the external supplier communication of a document. HTML formatting is supported.",
            "communication_signature_editor_visual": "Visual",
            "communication_signature_editor_html": "HTML",
            "communication_signature_editor_visual_disabled_hint": "The visual editor is disabled for this HTML source to preserve its formatting.",
            "communication_signature_placeholders": "Placeholders",
            "communication_signature_placeholders_hint": "Click a placeholder to insert it at the current cursor position in the HTML editor.",
            "communication_signature_placeholder_first_name": "First name",
            "communication_signature_placeholder_last_name": "Last name",
            "communication_signature_placeholder_name": "Employee name",
            "communication_signature_placeholder_email": "Employee email",
            "communication_signature_placeholder_company_name": "Company name",
            "communication_signature_placeholder_company_email": "Company email",
            "communication_signature_preview": "Signature preview",
            "communication_signature_preview_hint": "Uses sample employee data and current company data when available.",
            "communication_signature_preview_empty": "Add a signature above to see the preview here.",
            "select_letterhead": "Select letterhead",
            "select_letterhead_tooltip_content": "Add a letterhead that will be printed on the order document of your approved orders.",
            "billing_address": "Billing Address",
            "state_placeholder": "Select state/region",
            "state_tooltip_content": "Used to calculate holidays.",
            "roles": "General Role Defaults",
            "user_clearing_id_tooltip_content": "For clearing in order processes.",
            "user_invoice_clearing_id_tooltip_content": "For clearing during invoicing.",
            "bank_accounts_title": "Bank Accounts",
            "bank_accounts_hint": "You can maintain multiple company bank accounts here. IBAN and BIC are validated when entered.",
            "bank_accounts_empty": "No additional bank accounts have been added yet.",
            "add_bank_account": "Add Bank Account",
            "bank_account_label": "Label",
            "bank_account_holder": "Account Holder",
            "bank_account_bank_name": "Bank Name",
            "bank_account_iban": "IBAN",
            "bank_account_bic": "BIC",
            "no_selection": "No specific company has been chosen, hence it is shared among all.",
            "validation": {
                "name_required": "Please enter a name.",
                "name_max_length": "Must not exceed 50 characters.",
                "email_invalid": "Please enter a valid email address.",
                "iban_invalid": "Please enter a valid IBAN number.",
                "bic_invalid": "Please enter a valid BIC.",
                "bank_account_iban_required": "Please enter an IBAN for this bank account.",
                "bank_account_iban_duplicate": "This IBAN has already been added.",
                "bank_accounts_invalid": "Please review the bank accounts section.",
                "client_number_invalid": "Please enter a valid number.",
                "min_approval_invalid": "Please enter a valid number.",
                "address_incomplete": "Please complete the mandatory address data.",
                "delivery_address_missing": "Add at least one delivery address.",
                "error_address_incomplete": "Please complete the required data for the delivery address."
            },
            "tour": {
                "name": "Start by entering the name of your company.",
                "email": "Enter the email of your company to which, for example, the invoice delivery should be sent.",
                "timeline_assignment": "You can optionally pre-assign responsible individuals for the various steps of purchase orders for the company. For example, if there is always a person responsible for approving orders.",
                "billing_address": "The billing address is required for the order and may be sent to the supplier with the order.",
                "shipping_address": "Here you can enter one or more delivery addresses which can be selected in a purchase order.",
                "btn_save": "After entering all required information, add the company."
            }
        }
    },
    "client_form_config": {
        "field": "Field",
        "form": "Form",
        "required": "Mandatory",
        "not_available_for_d365": "The configuration of mandatory fields for invoices is not available because, for the D365 integration, D365 validation rules are used."
    },
    "department": {
        "description": "Department",
        "code": "Number",
        "form_sequence": "name,code,client_id,user_select_product_id,user_send_order_id,user_clearing_id,user_consignee_id",
        "page": {
            "new": "New Department",
            "tab_general": "General",
            "tab_clients": "Clients",
            "tab_cost_centers": "Cost Centers",
            "tab_approvers": "Approvers",
            "tab_permissions": "Permission Groups",
            "tab_employees": "Employees",
            "tab_assignment": "Role Assignments",
            "validation": {
                "name_required": "Please enter a name.",
                "email_required": "Please enter a valid email address."
            },
            "tour": {
                "name": "Start by entering the name of the department.",
                "client": "If you assign the department to a company, the department can only be selected within that company when creating a purchase order.",
                "timeline_assignment": "You can designate responsible individuals for the various steps of purchase orders for the department. For example, if one specific person is always responsible for receiving goods for each department.",
                "cost_centers": "Here, you can assign existing cost centers to the department. If you don't assign any cost centers, when creating purchase orders for the department, only cost centers that are not assigned to any department can be selected.",
                "employees": "You can add different individuals who are part of this department. When individuals from this department create purchase orders, the department will be pre-filled.",
                "btn_save": "Once you've provided all the information, add the department."
            }
        }
    },
    "permission": {
        "description": "Permission Group",
        "name": "Name",
        "page": {
            "new": "New Permission Group",
            "validation": {
                "name_required": "Please enter a name."
            },
            "tour": {
                "name": "Here you can create a permission group. You can then assign this group to various entities (departments, products from the product catalog, product groups etc.). You can also assign one or more permission groups to individuals. If an entity should not have any permission restrictions, do not assign a group."
            },
            "no_selection": "No permission selected, therefore visible to everyone."
        }
    },
    "task_group": {
        "description": "Task Group",
        "name": "Name",
        "priority_approval_limit": "Priority level of approval limit",
        "page": {
            "new": "New Task Group",
            "validation": {
                "name_required": "Please enter a name."
            },
            "tour": {
                "name": "Here you can create a task group. You can then assign tasks to this group."
            },
            "no_selection": "No Task Group Selected"
        }
    },
    "budget": {
        "description": "Budgets",
        "label_log": "value€ (start - end)",
        "label_log_fields": "value,start,end",
        "value": "Amount",
        "type_value": "currency",
        "start": "Valid from",
        "end": "Valid until",
        "add_foreach_ledger_account": "Insert all ledger accounts",
        "component": {
            "validation": {
                "end_date_before_start_date": "The end date cannot be before the start date.",
                "end_date_required": "The end date cannot be empty here.",
                "time_overlap": "Budgets cannot overlap in time.",
                "field_missing": "Please enter all the information."
            }
        }
    },
    "address": {
        "description": "Delivery Address",
        "description_plural": "Delivery Addresses",
        "address_name": "Name",
        "consignee": "Consignee Name",
        "dropoff_location": "Drop-off Location Name",
        "address": "Street and No.",
        "address_complement": "Street 2",
        "complement": "Street 2",
        "country": "Country",
        "zipcode": "ZIP Code",
        "city": "City",
        "phone_country_code": "Phone Country Code",
        "phone_number": "Phone Number",
        "component": {
            "new": "New Delivery Address",
            "copy_btn": "Copy Billing Address",
            "required_field": "Please complete the required fields of the address.",
            "phone_required": "Please enter both pieces of information.",
            "no_address": "No Delivery Address"
        }
    },
    "cost_center": {
        "name": "Name",
        "number": "Number",
        "free_budget": "Available Budget",
        "description": "Cost Center",
        "label_log": "cost_center_name",
        "budgets": "Budgets",
        "form_sequence": "name,number",
        "page": {
            "new": "New Cost Center",
            "department_tooltip_content": "Which departments are allowed to use this cost center.",
            "tab_general": "General",
            "tab_budgets": "Budgets",
            "tab_shipping_address": "Shipping Addresses",
            "tab_approvers": "Approvers",
            "tab_permissions": "Permissions",
            "tab_departments": "Departments",
            "tab_clients": "Clients",
            "validation": {
                "name_required": "Please enter a name.",
                "number_required": "Please enter a number.",
                "number_length": "Must be at most 36 characters long and can only have spaces in the middle.",
                "number_exists": "The number already exists."
            },
            "tour": {
                "name_number": "Provide a name and a unique number for the cost center.",
                "budget": "You can assign various budgets to your cost center and also allocate the budgets to a ledger account.",
                "approver": "Define here who should approve purchase orders with this cost center. Additional approvers can be added when creating purchase orders.",
                "department": "Here, you can define in which departments the cost center can be used. If you don't add any departments here, the cost center can be selected in all departments.",
                "btn_save": "Once you've provided all necessary information, add the cost center to the database."
            }
        }
    },
    "bank_statement": {
        "abbr": "BS",
        "description": "Upload bank statement",
        "transactions_menu": "Bank statement transactions",
        "page": {
            "upload": {
                "title": "Upload bank statement",
                "info": "Upload a structured bank statement.",
                "client_hint": "The selected company will be assigned to the uploaded bank statement and its transactions.",
                "client_required": "Please select a company before uploading.",
                "supported_hint": "Supports camt.052/.053/.054 XML and MT940 text files.",
                "error_invalid": "Supported formats are camt.052, camt.053, camt.054 XML and MT940 text bank statements.",
                "abort_upload": "Abort upload",
                "processing_in_background_notice": "The bank statement was saved. {count} entries are now being processed in the background.",
                "large_statement_notice": "The bank statement with {count} entries was uploaded. Automatic matching was skipped for this large upload so the upload would not block.",
                "account_identifier_match_notice": "The uploaded statement contains only the account identifier {identifier}, not a valid IBAN. No new company bank account was created. The identifier belongs to the existing IBAN {iban}.",
                "account_identifier_only_notice": "The uploaded statement contains only the account identifier {identifier}, not a valid IBAN. No new company bank account was created for this upload.",
                "update_client_iban": "Add IBAN as new account",
                "continue_without_update": "Continue without adding account",
                "continue_upload": "Continue upload",
                "statement_account_title": "Account in the uploaded statement",
                "statement_account_hint": "This IBAN was detected in the uploaded bank statement.",
                "client_accounts_title": "Active company bank accounts",
                "client_accounts_count": "{count} active",
                "client_accounts_table_label": "Label",
                "client_accounts_table_bank": "Bank",
                "client_accounts_table_account_holder": "Account holder",
                "client_accounts_table_bic": "BIC",
                "client_accounts_table_iban": "IBAN",
                "client_iban_missing_title": "Company bank account missing",
                "client_iban_missing_intro": "No matching active company bank account is stored yet in the master data for {clientName}.",
                "client_iban_mismatch_title": "Company bank account differs",
                "client_iban_mismatch_intro": "The IBAN in the bank statement differs from the active company bank accounts stored in the master data for {clientName}.",
                "client_iban_document": "Bank statement IBAN: {iban}",
                "client_iban_masterdata": "Existing company bank account: {iban}",
                "client_iban_masterdata_empty": "No active company bank account is stored yet in the master data.",
                "client_iban_update_question": "Do you want to add this IBAN as a new company bank account before uploading?",
                "client_iban_readonly_hint": "You can continue the upload without creating a new company bank account."
            },
            "form": {
                "title": "Bank statement",
                "back_to_upload": "New upload",
                "delete": "Delete bank statement",
                "delete_confirm_title": "Delete bank statement",
                "delete_confirm_message": "Do you really want to delete this bank statement? Existing matches will be detached and bank-statement-based paid markers will be reset if they only come from this statement.",
                "delete_success": "The bank statement was deleted.",
                "delete_error": "The bank statement could not be deleted.",
                "download": "Download file",
                "format": "Format",
                "status": "Status",
                "account_iban": "Account",
                "account_owner": "Account holder",
                "period": "Period",
                "matched_entries": "Auto matched",
                "processing_title": "Bank statement is being processed",
                "processing_notice": "The upload has already been saved. {inserted} of {count} entries have already been imported; the rest is still being imported and matched in the background. Use the refresh button whenever you want to check the current progress.",
                "processing_matching_title": "Entries imported, matching still running",
                "processing_matching_notice": "All {count} entries have already been imported and are now being matched in the background. So far, {matched} entries have been matched automatically. Use the refresh button whenever you want to check the current progress.",
                "processing_refresh": "Refresh status",
                "processing_finished_notice": "Bank statement processing has finished.",
                "entries": "Entries",
                "entry_index": "No.",
                "booking_date": "Booking date",
                "value_date": "Value date",
                "amount": "Amount",
                "counterparty": "Counterparty",
                "reference": "Reference",
                "match_status": "Match status",
                "matched_invoice": "Matched invoice",
                "status_labels": {
                    "processing": "Processing",
                    "processed": "Processed",
                    "partial": "Partially processed",
                    "failed": "Failed"
                },
                "match_status_labels": {
                    "unmatched": "Unmatched",
                    "matched": "Matched",
                    "ambiguous": "Ambiguous",
                    "ignored": "Ignored"
                }
            },
            "list": {
                "identifier": "Identifier",
                "uploaded_at": "Uploaded at",
                "empty": "No uploaded bank statements yet."
            },
            "transactions": {
                "title": "Bank statement transactions",
                "subtitle": "Central overview of all bank statement entries. Select a company first; the supplier filter is optional.",
                "clear_filters": "Reset filters",
                "client_required_notice": "Please select a company first to display transactions.",
                "empty": "No transactions found.",
                "no_permission": "You do not have permission to open this view.",
                "active_filters": "Active filters",
                "transaction_date": "Transaction date",
                "direction": "Type",
                "incoming": "Incoming",
                "outgoing": "Outgoing",
                "client": "Company",
                "supplier": "Supplier",
                "account_filter": "Account",
                "statement": "Open bank statement",
                "amount_filter": "Amount type",
                "transaction_type": "Transaction type",
                "text_search": "Text search",
                "text_search_placeholder": "Search in selected columns",
                "text_search_columns": "Search columns",
                "text_search_columns_placeholder": "Choose columns",
                "export": "Export XLSX",
                "export_success": "The XLSX export was created.",
                "export_error": "The XLSX export could not be created.",
                "export_empty": "There are no transactions available for the current filters.",
                "export_end_balance": "Closing balance",
                "export_adjustment_type": "Balance adjustment",
                "export_adjustment_description": "Balance adjustment for missing statement coverage ({from} - {to})",
                "export_gap_description": "Missing statement coverage ({from} - {to})",
                "transaction_type_labels": {
                    "transfer": "Transfer",
                    "direct_debit": "SEPA direct debit",
                    "card": "Card payment",
                    "standing_order": "Standing order",
                    "fee": "Fee",
                    "cash": "Cash",
                    "refund": "Refund"
                },
                "description": "Description",
                "coverage_gap_alert_title": "Missing bank statement coverage detected",
                "coverage_gap_alert_summary": "{days} day(s) in the selected period are not covered by any uploaded bank statement.",
                "coverage_gap_row_label": "Missing coverage: {from} - {to} ({days} day(s))",
                "coverage_gap_row_context_between": "Gap between {previous} and {next}.",
                "coverage_gap_row_context_before_first": "No earlier statement in the selected period. Next available statement: {next}.",
                "coverage_gap_row_context_after_last": "No later statement in the selected period. Last available statement: {previous}.",
                "coverage_gap_row_context_unknown": "No neighboring bank statements found for this gap.",
                "coverage_gap_closing_balance_difference": "Closing balance difference A/B: {previous} -> {next} ({difference}).",
                "coverage_gap_closing_balance_difference_unavailable": "Closing balance difference A/B unavailable for one or both statements.",
                "manual_match": {
                    "action": "Actions",
                    "assignment": "Assignment",
                    "details": "Details",
                    "open": "Match",
                    "edit": "Edit",
                    "dialog_title": "Manually match payment",
                    "dialog_title_single": "Assign transaction",
                    "dialog_title_split": "Split payment",
                    "eyebrow": "Manual payment matching",
                    "single_option": "Match single..",
                    "split_option": "Split across invoices",
                    "bulk_actions_select": "Bulk Actions ({count})",
                    "bulk_action": "Assign cost type ({count})",
                    "bulk_dialog_title": "Assign cost type in bulk",
                    "bulk_dialog_text": "Assign the selected cost type directly to {count} selected transactions. Existing manual assignments will be replaced.",
                    "bulk_save": "Assign cost type",
                    "incoming_revenue_bulk_action": "Assign revenue type",
                    "revenue_bulk_dialog_title": "Assign revenue type in bulk",
                    "revenue_bulk_dialog_text": "Assign the selected revenue type directly to {count} selected incoming transactions. Existing manual assignments will be replaced.",
                    "revenue_bulk_save": "Assign revenue type",
                    "filtered_batch_action": "Batch assign filtered ({count})",
                    "filtered_batch_incoming_action": "Assign filtered incoming ({count})",
                    "filtered_batch_outgoing_action": "Assign filtered outgoing ({count})",
                    "filtered_batch_empty": "There are no filtered transactions available for batch assignment.",
                    "filtered_batch_direction_warning": "Filtered results contain both incoming and outgoing transactions. Please refine the filters before using batch assignment.",
                    "filtered_batch_load_error": "The filtered transactions could not be prepared for batch assignment.",
                    "transaction_total": "Transaction total",
                    "allocated_total": "Allocated total",
                    "remaining_difference": "Remaining difference",
                    "ready_to_save": "Total matches.",
                    "remaining_message": "Remaining: {amount}",
                    "allocations_title": "Split across invoices",
                    "allocations_subtitle": "Select one or more invoices and enter the amount from this transaction that belongs to each invoice.",
                    "add_invoice": "Add invoice",
                    "outgoing_invoice": "Outgoing invoice (customer payment)",
                    "cost_type": "Cost type",
                    "cost_type_bulk_action": "Assign cost type",
                    "invoice_gross": "Invoice gross",
                    "match_amount": "Match amount",
                    "use_transaction_total": "Use transaction total",
                    "use_invoice_gross": "Use gross",
                    "use_remaining": "Use remaining",
                    "clear_matches": "Remove match",
                    "save": "Save match",
                    "alerts": {
                        "invoice_conflict_title": "Invoice already linked to another transaction",
                        "invoice_conflict_message": "At least one selected invoice is already assigned to another bank transaction.",
                        "invoice_conflict_hint": "Open the existing match first and adjust the split there, or remove it, before saving this transaction."
                    }
                }
            }
        }
    },
    "supplier": {
        "address": "Address",
        "alias": "Supplier alias",
        "external_id": "DATEV ID",
        "supplier_number": "Supplier Number",
        "client_number": "Customer number",
        "delivery_in_days": "Delivery time in working days",
        "delivery_terms": "Delivery Terms",
        "payment_terms": "Payment Terms",
        "vat_number": "VAT ID",
        "city": "City",
        "iban": "IBAN",
        "bic": "BIC",
        "bank_country": "Bank Country",
        "bank_account": "Account Number",
        "bank_code": "Bank Code",
        "bank": "Bank",
        "discount_percentage": "Discount 1 - percentage",
        "discount_days": "Discount 1 - days",
        "discount_percentage2": "Discount 2 - percentage",
        "discount_days2": "Discount 2 - days",
        "invoice_recognition_prompt": "Custom prompt for invoice recognition",
        "form_sequence": "name,email,city,address,external_id,delivery_terms,payment_terms,iban,bic,vat_number",
        "payment_method": "Payment method",
        "payment_method_info": "Invoices from supplier companies with the payment method SEPA direct debit or credit card are marked as paid directly",
        "page": {
            "new": "New Supplier",
            "department_tooltip_content": "Which departments are allowed to use this supplier.",
            "delivery_in_days_tooltip_content": "The estimated delivery time serves for the receipt of goods task email.",
            "notes_tooltip_content": "This note is displayed internally on liftbase only and is not printed on the order PDF.",
            "external_id_tooltip_content": "The ID of the supplier from a third-party system you've integrated.",
            "client_number_tooltip_content": "Number assigned to you by this supplier (optional).",
            "supplier_number_tooltip_content": "Number you have assigned to this supplier.",
            "delivery_terms_tooltip_content": "The agreed-upon payment and delivery terms with the supplier will be displayed on the purchase order PDF.",
            "payment_terms_tooltip_content": "The agreed-upon payment and delivery terms with the supplier will be displayed on the purchase order PDF.",
            "vat_number_tooltip_content": "The value-added tax (VAT) ID is relevant for assigning an imported invoice to the delivering company.",
            "name_tooltip_content": "To assign an imported invoice, specify the name of the delivering company exactly as it appears on the invoice.",
            "tab_general": "General",
            "tab_delivery_info": "Delivery Information",
            "tab_payment_info": "Payment Information",
            "tab_permissions": "Permission Groups",
            "tab_departments": "Departments",
            "tab_approvers": "Approvers",
            "tab_clients": "Company-specific IDs",
            "tab_invoice_recognition": "Defaults for invoice recognition",
            "tab_invoice_recognition_prompt": "Custom Prompt",
            "invoice_recognition_prompt_placeholder": "E.g. please use the \"ticket code\" as the invoice number.",
            "default_clients_ids": "If a company is not listed in this table with specific IDs, <br>the following default IDs will be used: <br>DATEV ID: {external_id} <br>Client number: {client_number}.",
            "no_default_id": "No default ID available.",
            "validation": {
                "name_required": "Please enter a name.",
                "name_length": "Must be at most 50 characters long.",
                "email_invalid": "Please enter a valid email address.",
                "supplier_number_invalid": "Please enter a valid number.",
                "vat_number_invalid": "Can contain numbers, uppercase and lowercase letters, dots, spaces, and underscores. Must be at most 15 characters long.",
                "iban_invalid": "Must be at least 15 and at most 34 characters long. Cannot contain spaces. Begins with two uppercase letters, followed by 2 numbers, and then 11 to 30 alphanumeric characters.",
                "bic_invalid": "Must be at least 8 and at most 11 characters long, and only contain uppercase letters and numbers. The first six characters must be letters.",
                "external_id_length": "The DATEV ID must contain only whole numbers and cannot be less than 10000."
            },
            "tour": {
                "name": "Enter the name of the supplier.",
                "email": "The email address of the supplier is used, for example, for preparing email messages for order placement.",
                "address": "Here, you can provide the address of the supplier.",
                "external_id": "The external ID is the supplier's number as stored in an external system. This number is used in the API.",
                "terms": "Enter the agreed-upon payment and delivery terms with the supplier. This information will be displayed on the purchase order PDF.",
                "btn_save": "Once you've entered all the information, save the supplier here."
            }
        }
    },
    "business_partner": {
        "address": "Address",
        "business_partner_number": "Number",
        "delivery_in_days": "Delivery time in working days",
        "delivery_terms": "Delivery Terms",
        "payment_terms": "Payment Terms",
        "vat_number": "VAT ID",
        "city": "City",
        "iban": "IBAN",
        "bic": "BIC",
        "bank_country": "Bank Country",
        "bank_account": "Account Number",
        "bank_code": "Bank Code",
        "bank": "Bank",
        "discount_percentage": "Discount 1 - percentage",
        "discount_days": "Discount 1 - days",
        "discount_percentage2": "Discount 2 - percentage",
        "discount_days2": "Discount 2 - days",
        "payment_method": "Payment method",
        "payment_method_info": "Documents with the payment method SEPA direct debit or credit card can be marked as paid directly.",
        "page": {
            "new": "Add Business Partner",
            "delivery_in_days_tooltip_content": "The delivery time is stored as master data information for this business partner.",
            "notes_tooltip_content": "This note is shown internally in liftbase only.",
            "business_partner_number_tooltip_content": "Number you have assigned to this business partner.",
            "delivery_terms_tooltip_content": "Here you can store the delivery terms agreed with the business partner.",
            "payment_terms_tooltip_content": "Here you can store the payment terms agreed with the business partner.",
            "vat_number_tooltip_content": "The VAT ID helps assign documents to this business partner.",
            "name_tooltip_content": "Enter the business partner's name exactly as it should appear on documents.",
            "tab_general": "General",
            "tab_delivery_info": "Delivery Information",
            "tab_payment_info": "Payment Information",
            "tab_permissions": "Permission Groups",
            "tab_clients": "Companies",
            "import_legacy_suppliers_button": "Import suppliers as partners",
            "import_legacy_suppliers_title": "Import suppliers as business partners?",
            "import_legacy_suppliers_confirm": "For each supplier in your tenant that is not yet linked to a business partner, this creates a partner (with legacy supplier reference), copies bank accounts, client links and permission groups, and updates outgoing invoices to use the partner. Suppliers that were already imported are skipped. You can run this again safely.",
            "import_legacy_suppliers_run": "Start import",
            "import_legacy_suppliers_loading": "Importing suppliers…",
            "import_legacy_suppliers_success": "Import finished. New partners: {inserted}. Skipped (already linked): {skipped}. Bank accounts added: {bankAccounts}. Outgoing invoices updated (main / recognized): {invoicesBp} / {invoicesRec}. Client links: {clients}. Permissions: {permissions}.",
            "tab_invoice_recognition": "Defaults for invoice recognition",
            "validation": {
                "name_required": "Please enter a name.",
                "name_length": "Must be at most 50 characters long.",
                "email_invalid": "Please enter a valid email address.",
                "vat_number_invalid": "Can contain numbers, uppercase and lowercase letters, dots, spaces, and underscores. Must be at most 15 characters long.",
                "iban_invalid": "Must be at least 15 and at most 34 characters long. Cannot contain spaces. Begins with two uppercase letters, followed by 2 numbers, and then 11 to 30 alphanumeric characters.",
                "bic_invalid": "Must be at least 8 and at most 11 characters long, and only contain uppercase letters and numbers. The first six characters must be letters."
            },
            "tour": {
                "name": "Enter the name of the business partner.",
                "email": "The business partner's email address can be used for communication and document processes.",
                "address": "Here, you can store the business partner's address.",
                "terms": "Enter the payment and delivery terms agreed with the business partner here.",
                "btn_save": "Once you've entered all the information, save the business partner here."
            }
        }
    },
    "user": {
        "name": "Name",
        "client_id": "Main Company",
        "approval_limit": "Approval Limit",
        "priority_approval_limit": "Priority level of approval limit",
        "show_tour": "Show all tours from Liftbase",
        "tooltip_edit_master_data_permission": "With this permission, master data can also be modified outside of the administration area via the following features:<br>" +
            "- Add suppliers directly when creating a product<br>" +
            "- Modify/add bank details, payment method, and VAT ID during invoice processing",
        "roles": {
            "user-admin": "Administrator",
            "user-price": "View prices",
            "user-dashboard": "View all dashboards",
            "user-procurement-dashboard": "View procurement dashboard",
            "user-invoice-dashboard": "View incoming invoice dashboard",
            "user-outgoing-invoice-dashboard": "View outgoing invoice dashboard",
            "user-einvoice-dashboard": "View e-invoice dashboard",
            "user-change-order": "Edit order after approval",
            "user-see-orders": "See orders:",
            "user-see-all-orders": "All companies",
            "user-see-all-orders-belonging-to-accessible-companies": "All accessible companies",
            "user-see-all-orders-belonging-to-own-company": "Own company",
            "user-see-all-orders-belonging-to-own-department": "Own department",
            "user-see-orders-from-involved-invoices": "View orders from involved invoices",
            "user-see-own-orders-and-involved": "Own and with involvement",
            "user-see-contracts": "View contracts:",
            "user-see-all-contracts": "All companies",
            "user-see-all-contracts-belonging-to-accessible-companies": "All accessible companies",
            "user-see-all-contracts-belonging-to-own-company": "Own company",
            "user-see-all-contracts-belonging-to-own-department": "Own department",
            "user-see-own-contracts-and-involved": "Own and with involvement",
            "user-see-all-invoices": "All Companies",
            "user-see-all-invoices-belonging-to-accessible-companies": "All accessible companies",
            "user-see-invoices": "View Invoices:",
            "user-see-all-invoices-belonging-to-own-company": "Own Company",
            "user-see-invoices-from-own-orders": "View invoices from own orders",
            "user-see-own-invoices-and-involved": "Own and Involved",
            "user-can-change-invoices": "Edit Invoice Afterwards",
            "user-see-outgoing-invoices": "View outgoing invoices:",
            "user-see-all-outgoing-invoices": "All companies",
            "user-see-all-outgoing-invoices-belonging-to-accessible-companies": "All accessible companies",
            "user-see-all-outgoing-invoices-belonging-to-own-company": "Own company",
            "user-see-own-outgoing-invoices-and-involved": "Own and involved",
            "user-can-change-outgoing-invoices": "Edit outgoing invoice afterwards",
            "user-bank-statement-transactions": "View bank statement transactions",
            "user-liquidity-planning": "Open liquidity planning",
            "user-supplier-dashboard": "View supplier dashboard",
            "user-ai-dashboard": "AI-Stats (operators only)",
            "user-see-client-addresses": "See all company addresses",
            "user-export-invoice": "Export invoices to {export_name}",
            "user-can-delete-document-directly": "Cancel/decline documents without clearing",
            "user-can-insert-product": "Save in product catalog",
            "user-can-insert-supplier": "Modify master data indirectly",
            "masterdata-edit-clients": "Edit companies",
            "masterdata-edit-cost-centers": "Edit cost centers",
            "masterdata-edit-posting-keys": "Edit posting keys",
            "masterdata-edit-departments": "Edit departments",
            "masterdata-edit-suppliers": "Edit suppliers",
            "masterdata-edit-business-partners": "Edit business partners",
            "masterdata-edit-products": "Edit product catalog",
            "masterdata-edit-product-groups": "Edit product groups"
        },
        "blocked": "Login Blocked",
        "token_issued_at": "API token issued at",
        "form_sequence": "name,email,client_id,department_id,cost_center_id,location_id,approval_limit,roles,blocked",
        "page": {
            "tab_general": "General",
            "tab_roles": "Permissions",
            "tab_roles_general": "General Permissions",
            "tab_roles_dashboards": "Dashboards",
            "tab_roles_procurement": "Purchase Requests",
            "tab_roles_invoice": "Invoices",
            "tab_roles_outgoing_invoice": "Outgoing invoices",
            "tab_roles_bank_statements": "Bank Statements",
            "tab_roles_masterdata": "Master Data",
            "tab_roles_block": "Blocks",
            "tab_permissions": "Permission Groups",
            "tab_addresses": "Delivery Addresses",
            "tab_task_groups": "Task Groups",
            "tab_communication_contacts": "Contacts",
            "tab_passkeys": "Passkeys",
            "tab_oauth_permissions": "App access",
            "oauth_permissions": "Granted application access",
            "oauth_permissions_description": "Applications listed here were explicitly authorized to access Liftbase on behalf of this user.",
            "oauth_permissions_empty": "No application access has been granted.",
            "oauth_application": "Application",
            "oauth_redirect_uri": "Redirect URL",
            "oauth_unverified": "Unverified",
            "oauth_permission": "Permission",
            "oauth_scope_mcp": "Read permitted Liftbase data",
            "oauth_granted_at": "Granted",
            "oauth_expires_at": "Expires",
            "oauth_status": "Status",
            "oauth_status_active": "Active",
            "oauth_status_expired": "Expired",
            "oauth_revoke": "Revoke",
            "oauth_revoke_title": "Revoke application access",
            "oauth_revoke_confirm": "Revoke access for {application}? Refresh access will stop immediately; an access token already issued may remain valid for up to 15 minutes.",
            "oauth_revoked": "Application access revoked.",
            "communication_contacts_description": "Manage the e-mail contacts suggested only for your supplier communication. You can rename saved contacts or remove them so they are no longer suggested.",
            "communication_contacts_empty": "No saved contacts yet.",
            "communication_contact_name": "Name",
            "communication_contact_name_placeholder": "Optional display name",
            "communication_contact_email": "E-mail",
            "communication_contact_last_used": "Last used",
            "communication_contact_saved": "Contact updated.",
            "communication_contact_deleted": "Contact removed.",
            "communication_contact_delete_confirm": "Do you really want to remove the saved contact \"{email}\"?",
            "accessible_companies_title": "Accessible companies for this user",
            "accessible_companies_empty": "No companies derived from current permissions.",
            "new": "New User",
            "block_btn": "Block User",
            "unblock_btn": "Unblock User",
            "login_as_btn": "Login As",
            "no_permission": "No permission group selected.",
            "task_group_permissions": "Permissions from My Task Groups:",
            "approval_limit_tooltip_content": "Define here the final approval limit for this person. <br> Higher amounts can be approved, but they must also be finally approved by another person with a higher approval limit.",
            "approval_limit_placeholder": "Unlimited",
            "upload_signature_label": "Signature (image)",
            "upload_signature_btn": "Select Signature",
            "upload_signature_tooltip_content": "Add a signature that will be printed on the order document of your approved purchase orders. <br/> We recommend using an image file with a transparent background.",
            "email_signature_html": "E-mail signature",
            "email_signature_html_hint": "This signature is prefilled in supplier communication for the first message of a document.",
            "api_token_btn": "Generate API Token",
            "api_token_dialog_title": "Generate API Token",
            "api_token_dialog_content": "API tokens are required for integrating third-party applications and allow access to data on behalf of the respective user.",
            "api_token_dialog_date_placeholder": "Token Expiry Date",
            "api_token_dialog_generate_btn": "Generate",
            "api_token_dialog_copy_btn": "Copy",
            "api_token_dialog_copy_info": "Please copy and paste the following API token into the third-party application:",
            "api_token_dialog_copied": "Copied!",
            "language": "Language",
            "role_dashboard_tooltip": "Allows access to all dashboards.",
            "role_ai_dashboard_tooltip": "AI-Stats can only be accessed by operators.",
            "role_supplier_dashboard_tooltip": "Allows access to the supplier dashboard only. This permission is independent of \"View dashboard\".",
            "passkey": "Passkey",
            "passkeys": "Passkeys",
            "passkey_name": "Name",
            "passkey_last_login": "Last Login",
            "passkey_dialog": {
                "title": "Add Passkey",
                "info1": "<b>What are Passkeys?</b><ul><li>Login without waiting for an email</li><li>With fingerprint, your face, or PIN</li><li>Secure and convenient</li></ul>",
                "info2": "<b>Set up in 3 steps now:</b><ol><li>Enter name e.g. \"Home Office PC\" or \"Notebook\"</li><li>Click \"Next\"</li><li>Follow instructions from your browser / operating system</li></ol>",
                "info3": "Step-by-step instructions <a href=\"https://liftbase.de/handbuch/anmeldung/passkeys/\" target=\"_blank\">can be found in the manual</a>",
                "name_input_label": "Passkey Name",
                "name_input_placeholder": "e.g. 'Home Office PC' or 'Notebook'",
                "added_msg": "Passkey has been added.",
                "deleted_msg": "Passkey has been deleted.",
                "exist_msg": "You already have a passkey on this device, try with a different device."
            },
            "validation": {
                "name_required": "Please enter a name.",
                "name_exists": "The name already exists.",
                "email_required": "Please enter an email address.",
                "email_invalid": "Please enter a valid email address.",
                "email_exists": "The email address already exists.",
                "approval_limit_length": "The approval limit must be either greater than 0 or empty."
            },
            "tour": {
                "name": "Enter the name of the user, preferably first and last name.",
                "email": "Enter the email address through which the user can log in.",
                "organization": "Assign the user to a company, department, and cost center. This information will be pre-filled in the purchase order form.",
                "approval_limit": "You can define an approval limit for the user here. If a purchase order has a higher total amount, it must also be finally approved by a person with a higher approval limit. If no limit is defined, the user can finally approve all amounts.",
                "signature": "You can add the user's signature here. When the user approves a purchase order, their signature will be added to the purchase order PDF.",
                "roles": "Permissions for the person can be set here, for example, whether and which processes or information can be viewed or edited. There is also the option to block the person if they have, for example, left the company.",
                "roles_price": "Specify whether the user can view product prices.",
                "role_change_order": "You can grant a trusted user permission to edit purchase orders after approval, without sending them back for clearing and thereby avoiding re-approval. This can be useful, for example, to adjust delivery addresses or product prices afterwards.",
                "admin": "Choose whether this person should have access to the administration area, for example, to add more users, master data, or settings.",
                "block": "Select this option if you want to prevent a user from logging into liftbase, e.g., if they have temporarily left the company.",
                "api_token": "API tokens are required for integrating third-party applications and allow access to data on behalf of the respective user.",
                "addresses": "You can add personal delivery addresses for the user, for example, if they work from home and want products to be delivered there.",
                "btn_save": "Save the user and associated information.",
                "profile_signature": "You can upload your signature here. When you approve purchase orders, your signature will be added to the purchase order PDF.",
                "profile_addresses": "You can add personal delivery addresses for the user, for example, if they work from home and want products to be delivered there.",
                "profile_btn_save": "Save the associated information."
            }
        }
    },
    "lb_user": {
        "description": "User"
    },
    "posting_key": {
        "name": "Name",
        "tax": "Tax Rate (%)",
        "number": "Key",
        "form_sequence": "name,number,tax",
        "page": {
            "new": "New Posting Key",
            "validation": {
                "name_required": "Please enter a name.",
                "number_required": "Please enter a valid number.",
                "number_length": "Can contain up to 9-digit numbers starting from 1."
            },
            "tour": {
                "name": "Enter the key and its associated tax rate."
            }
        }
    },
    "ledger_account": {
        "name": "Name",
        "description": "Description",
        "form_sequence": "name,number,description",
        "page": {
            "new": "New Ledger Account",
            "validation": {
                "name_required": "Please enter a name.",
                "number_required": "Please enter a valid number.",
                "number_length": "Can only contain numbers and cannot start with 0.",
                "tax_required": "Please enter a valid tax rate.",
                "tax_length": "Percentage value can only have two digits with a comma and at most two decimal places."
            },
            "tour": {
                "name": "Enter the number and name of the ledger account."
            }
        }
    },
    "profit_center": {
        "name": "Name",
        "form_sequence": "name,number",
        "page": {
            "new": "New Profit Center",
            "validation": {
                "name_required": "Please enter a name.",
                "number_required": "Please provide a valid number.",
                "number_length": "Should only contain numbers and not start with 0 for multiple digits.",
            },
            "tour": {
                "name": "Specify the number and name of the profit center."
            }
        }
    },
    "tax_group": {
        "code": "ID",
        "name": "Name",
        "form_sequence": "name,code,client_id",
        "page": {
            "new": "New Sales Tax Group",
            "validation": {
                "name_required": "Please enter a name.",
                "code_required": "Please enter an ID.",
                "client_required": "Please select a client.",
            },
            "tour": {
                "name": "Specify the ID and name of the sales tax group."
            }
        }
    },
    "financial_dimension": {
        "code": "ID",
        "name": "Name",
        "form_sequence": "name,code",
        "page": {
            "new": "New Employee",
            "validation": {
                "name_required": "Please enter a name.",
                "code_required": "Please enter an ID.",
                "client_required": "Please select a company."
            },
            "tour": {
                "name": "Enter the ID and name of the employee."
            }
        }
    },
    "tax_item_group": {
        "code": "ID",
        "tax_code": "Tax ID",
        "name": "Description",
        "form_sequence": "name,code,tax_code,client_id",
        "page": {
            "new": "New Tax Item Group",
            "validation": {
                "name_required": "Please enter a name.",
                "code_required": "Please enter an ID.",
                "tax_code_required": "Please enter an Tax ID.",
                "client_required": "Please select a company.",
            },
            "tour": {
                "name": "Enter the ID and description of the value-added tax group."
            }
        }
    },
    "approver": {
        "description": "Approval",
        "label_log": "lb_user_name",
        "table_log": "lb_user",
        "approver_required": "Please select an approver.",
        "is_required": "Required",
        "is_required_info": "Must also approve even if previous approvers already have the necessary approval limit.",
        "conversion_info": "The approval amount was converted into the document's currency at the current ECB exchange rate.",
        "max_approvers": "Max. number of approvers",
        "max_approvers_placeholder": "optional",
        "max_approvers_info": "Optional. When set, only the highest N approvers (by approval limit) must approve. Mandatory approvers count toward the maximum and may exceed it. Empty = current rule (all matching approvers).",
        "test_order_value": "Test order value",
        "test_order_value_placeholder": "e.g. 5000",
        "test_order_value_info": "Enter a fictional order value to preview which approvers would be required with the current settings.",
        "test_preview_section_title": "Test approval",
        "test_preview_title": "Required approvers",
        "test_preview_empty": "No approvers for this value.",
        "test_preview_required_overflow_short": "{requiredCount} mandatory > max {max}"
    },
    "invoice": {
        "grouped_sum_tax": "Sum {tax}% tax",
        "description": "Invoice",
        "name": "Name",
        "creator_id": "Uploaded by",
        "created_at": "Uploaded on",
        "number": "Invoice Number",
        "invoice_prefix": "Invoice prefix",
        "is_final_invoice": "Mark linked purchase order as completed",
        "is_final_invoice_short": "Close PO",
        "is_final_invoice_info": "If this option is enabled, the linked purchase order is automatically marked as completed. After that, no further invoices can be linked to this order.",
        "invoice_prefix_options": {
            "RE": "regular invoice",
            "AZ": "advance payment request / pro forma invoice",
            "VK": "prepayment invoice",
            "SR": "final invoice",
            "GS": "credit note"
        },
        "invoice_number_formatted": "Internal RE Number",
        "due_date": "Due Date",
        "delivery_date": "Delivery Date",
        "invoice_date": "Invoice Date",
        "vat_due_date": "Date of VAT register",
        "tax": "Tax Rate %",
        "total_brutto": "Total Gross",
        "total_netto": "Total Net",
        "total_netto_abbr": "-Net",
        "document_discount_amount": "Document discount amount",
        "document_discount_base_amount": "Document discount base",
        "document_discount_percentage": "Document discount %",
        "document_discount_tax_percentage": "Document discount VAT %",
        "document_discount_percentage_tooltip": "Percentage of the document-level discount applied to the base amount (EN 16931 BT-94).",
        "document_discount_amount_tooltip": "Absolute amount of the document-level discount (EN 16931 BT-92).",
        "document_discount_base_amount_tooltip": "Net amount on which the document-level discount is calculated (EN 16931 BT-93).",
        "document_discount_tax_percentage_tooltip": "VAT rate used for the tax allocation of the document-level discount.",
        "supplier_vat_number": "VAT ID",
        "supplier_payment_method": "Payment method",
        "supplier_iban": "IBAN",
        "supplier_bic": "BIC",
        "supplier_bank_country": "Bank Country",
        "supplier_bank_account": "Account Number",
        "supplier_bank_code": "Bank Code",
        "payment_reference": "Payment reference",
        "fix_recognition": "Dissatisfied with Data Recognition",
        "fix_recognition_checkbox": "I am dissatisfied with the data recognition.",
        "paid": "Invoice is already paid",
        "paid_auto_by_bank_statement_hint": "Marked as paid automatically by bank statement analysis on {date}.",
        "paid_manual_by_bank_statement_hint": "Marked as paid by manual bank statement matching on {date}.",
        "review_status": "Review Result",
        "selected_review_status": "Selected reason",
        "review_status_options": {
            "content_rejection": "Invoice rejected for content-related reasons",
            "insolvency_rejection": "Invoice rejected due to insolvency law",
            "further_review_required": "Invoice requires further review",
            "other_reason_rejection": "Cancelled for other reason",
            "approved": "Invoice approved"
        },
        "currency": "Currency",
        "notes": "Notes",
        "order_notes": "Order Notes",
        "discount_percentage": "Discount 1 (%)",
        "discount_amount": "Discount 1 - Amount",
        "discount_days": "Discount 1 - Days",
        "discount_payment_date": "Discount 1 - Date",
        "discount_percentage2": "Discount 2 (%)",
        "discount_amount2": "Discount 2 - Amount",
        "discount_days2": "Discount 2 - Days",
        "discount_payment_date2": "Discount 2 - Date",
        "type_discount_amount": "currency",
        "type_discount_amount2": "currency",
        "payment_in_advance": "Payment in advance",
        "einvoice_status": {
            "is_einvoice": "E-invoice",
            "not_einvoice": "No E-invoice",
            "not_relevant_hint": "No E-invoice, not relevant for input tax deduction",
            "tax_not_refundable_hint": "Input tax in the amount of {amount} cannot be refunded from 01/01/2027.",
            "zugferd10_hint": "ZUGFeRD 1.0 is not a valid e-invoice under the e-invoicing mandate (EN 16931)."
        },
        "electronic_validation": {
            "blocked_title": "The invoice does not meet the statutory requirements",
            "blocked_message": "Because the invoice does not meet the statutory requirements, further processing is not recommended. Manual processing is still possible.",
            "blocked_status": "Review required",
            "manual_export_warning_title": "Technical e-invoice errors",
            "manual_export_warning_message": "The technical validation of this e-invoice contains errors. Manual processing can still continue, but is not recommended. Do you want to consciously continue the export?",
            "manual_export_bulk_warning_message": "At least one selected e-invoice contains technical errors. Manual processing can still continue, but is not recommended. Do you want to consciously continue the export?",
            "manual_export_warning_confirm": "Continue export",
            "manual_export_warning_cancel": "Cancel",
            "show_details": "Show details",
            "hide_details": "Hide details",
            "rule_set": "Rule package",
            "external_reference_uris": "External references",
            "notify_supplier": "Notify supplier",
            "admin_report_hint": "Only administrators can download the complete technical validation report.",
            "issue": {
                "malformed_xml": "The XML is not well-formed or contains a prohibited XML construct.",
                "external_reference_not_resolved": "The e-invoice refers to an external resource. For security and privacy reasons, Liftbase does not automatically retrieve or resolve external resources.",
                "unknown_format": "The XML invoice format is not supported.",
                "unsupported_version": "No active rule package supports the detected version family.",
                "outdated_version": "The invoice uses the older XRechnung version {version}. This is shown as a note and does not by itself prevent legally permitted processing.",
                "unsupported_profile": "The detected format and profile do not meet the statutory requirements of EN 16931 and therefore cannot be accepted as a compliant e-invoice. Please use an EN 16931-compliant invoice format or profile, such as ZUGFeRD with the EN 16931 profile or XRechnung in a legally valid version.",
                "zugferd_10_unsupported": "The outdated format ZUGFeRD 1.0 was detected (profile: {profile}). This version is not supported. The supplier must reissue the invoice as current Factur-X/ZUGFeRD or XRechnung.",
                "electronic_invoice_extraction_failed": "Data could not be extracted from the technically valid e-invoice.",
                "kosit_execution_failed": "Technical e-invoice validation could not be executed.",
                "kosit_processing_failed": "A processing error occurred during technical e-invoice validation.",
                "processing_error": "Technical e-invoice validation could not be completed.",
                "multiple_bodies": "Multiple invoice bodies were found. Only single-body FatturaPA documents are processable under local FatturaPA rules.",
                "format_mismatch": "The FatturaPA transmission format (versione / FormatoTrasmissione) does not match local FatturaPA rules.",
                "fatturapa_total_mismatch": "Document totals do not match under local FatturaPA rules.",
                "unsupported_document_type": "This FatturaPA document type is not supported under local FatturaPA rules.",
                "fatturapa_schema_violation": "The document failed local FatturaPA XSD validation.",
                "fatturapa_line_total_mismatch": "A line total does not match quantity × unit price after discounts under local FatturaPA rules.",
                "fatturapa_riepilogo_mismatch": "Line totals do not match the tax summary under local FatturaPA rules.",
                "fatturapa_destinatario_missing": "The recipient code (CodiceDestinatario / PEC) is missing or incomplete under local FatturaPA rules.",
                "fatturapa_tax_mismatch": "VAT amounts do not match the taxable base × rate under local FatturaPA rules.",
                "fatturapa_business_rule_failed": "Local FatturaPA business rules could not be evaluated.",
                "fatturapa_iban_format": "An IBAN on the invoice failed format checks under local FatturaPA rules.",
                "fatturapa_vat_id_sanity": "A VAT identification (IdFiscaleIVA) failed basic length/charset checks under local FatturaPA rules.",
                "fatturapa_destinatario_length": "CodiceDestinatario length does not match the expected transmission format under local FatturaPA rules."
            },
            "local_scope_hint": "Local FatturaPA validation only — not an SDI acceptance result and not legal certainty for input-tax deduction (Vorsteuerabzug).",
            "local_accepted_title": "Valid according to local FatturaPA rules",
            "warning_title": "Technical validation warnings",
            "status": {
                "acceptable": "Accepted",
                "rejected": "Rejected",
                "undefined": "Undefined",
                "technical_error": "Technical error"
            },
            "supplier_template": {
                "subject": "Your invoice {number} dated {invoiceDate}",
                "unknown_value": "not provided",
                "rule_set_unavailable": "no matching rule package",
                "no_specific_reason": "The validator did not return a specific error message. Please review the complete technical validation report.",
                "reasons_heading": "What needs to be corrected?",
                "body": "<p>Hello,</p><p>The invoice cannot be accepted in its present form as a legally compliant e-invoice because the detected format or profile does not meet the statutory requirements.</p><p style=\"margin-bottom:-4px\"><strong>Affected invoice:</strong></p><ul style=\"margin-bottom:12px\"><li><strong>Invoice number:</strong> {number}</li><li><strong>Invoice date:</strong> {invoiceDate}</li><li><strong>Detected format:</strong> {standard}</li><li><strong>Detected version:</strong> {version}</li><li><strong>Detected profile:</strong> {profile}</li></ul>{reasonsSection}<br><p>Please use an invoice format or profile compliant with EN 16931, e.g. ZUGFeRD with the EN 16931 profile or XRechnung in a supported version.</p><p>Please issue a corrected e-invoice and send it to us again.</p><p>Thank you for your support.</p>",
                "body_fatturapa": "<p>Hello,</p><p>The invoice cannot be accepted in its present form as a legally compliant e-invoice because the detected format or profile does not meet the statutory requirements.</p><p style=\"margin-bottom:-4px\"><strong>Affected invoice:</strong></p><ul style=\"margin-bottom:12px\"><li><strong>Invoice number:</strong> {number}</li><li><strong>Invoice date:</strong> {invoiceDate}</li><li><strong>Detected format:</strong> {standard}</li><li><strong>Detected version:</strong> {version}</li><li><strong>Detected profile:</strong> {profile}</li></ul>{reasonsSection}<br><p>Please use an invoice format or profile compliant with EN 16931, e.g. ZUGFeRD with the EN 16931 profile or XRechnung in a supported version.</p><p>Please issue a corrected e-invoice and send it to us again.</p><p>Thank you for your support.</p>"
            }
        },
        "export_individual_items": "Export individual items",
        "export_individual_items_tooltip": "If this box is ticked, the positions are transmitted instead of the header data.",
        "status": "Status",
        "statuses": {
            "open": "Invoice Recognition",
            "export": "Ready for Export",
            "declined": "Discarded",
            "declined-exported": "Cancelled-Exported",
            "completed": "Completed",
            "historical-imported": "Historically imported",
            "approval": "Manual Check",
            "financial-approval": "Approval",
            "clearing": "Accounting Clearing",
            "accounting": "Accounting"
        },
        "page": {
            "ai_validation_result": {
                "title": "AI Validation Result",
                "result": "Result",
                "green_flags": "Positive Signals (Green Flags)",
                "red_flags": "Risk Signals (Red Flags)",
                "score": "Score",
                "check_method": "Check Method",
                "signals_considered": "Signals Considered",
                "signals_missing": "Signals Missing",
                "system_prompt": "System Prompt",
                "user_prompt": "User Prompt",
                "context": "Context",
                "no_data": "No AI validation data available for this invoice.",
                "response": "Response (JSON)",
                "trust_level": "Trustworthy",
                "not_trust_level": "Not trustworthy",
                "btn_tooltip": "Show AI validation details",
                "decision_summary": "Reasoning",
                "what_decided": "What decided this?",
                "positive_contributions": "Positive contributions",
                "risk_contributions": "Risk contributions",
                "scoring_method": "Method",
                "scoring_method_linear": "Linear",
                "scoring_method_multiplicative": "Multiplicative",
                "scoring_method_confidence": "Confidence",
                "score_kind_risk": "Risk score",
                "score_kind_confidence": "Confidence score",
                "score_kind_green_sum": "Positive signal sum",
                "score_explanation_title": "How the AI reached its decision",
                "score_scale_hint_risk": "Guide: 0 = no noticeable remaining risk, 1 = maximum risk. The lower the value, the more likely the invoice can be auto-approved.",
                "score_scale_hint_confidence": "Guide: 0 = very uncertain, 1 = very confident. The higher the value, the more likely the invoice can be auto-approved.",
                "score_scale_hint_green_sum": "Guide: 0 = no meaningful positive signals, 1 = very strong positive signals. The higher the value, the more likely the invoice can be auto-approved.",
                "decision_reasons_trusted": "Key factors were also: {ai_validation_reason_value}.",
                "decision_reasons_not_trusted": "Key factors were: {ai_validation_reason_value}.",
                "decision_reasons_insufficient_positive": "The positive signals were not sufficient: {ai_validation_reason_value}.",
                "show_calculation": "Show calculation",
                "formula_linear": "Risk = RedSum − GreenSum = {red_sum} − {green_sum} = {final_score}",
                "formula_multiplicative_risk": "Risk = (RedSum × Boost) × (1 − GreenSum) = ({red_sum} × {boost}) × (1 − {green_sum}) = {final_score}",
                "formula_multiplicative_green": "GreenSum = {green_sum}",
                "formula_confidence": "Confidence = GreenSum − RedPenalty = {green_sum} − {red_sum} = {final_score}",
                "decision_passed": "{score_label} {final_score} {comparison} {threshold} → trustworthy",
                "decision_failed": "{score_label} {final_score} {comparison} {threshold} → not trustworthy",
                "finding": "Finding",
                "detected": "Detected / Yes",
                "not_detected": "Not detected / No",
                "certainty_label": "Certainty",
                "tokens_used": "AI tokens used (In: {tokens_in}, Out: {tokens_out})",
                "tokens_not_used": "No AI tokens used",
                "ai_checked_flags": "Checked by AI",
                "local_checked_flags": "Checked locally before AI",
                "parse_error": "AI response could not be parsed as JSON.",
                "flag_descriptions": {
                    "GREEN_01": "Required fields are complete (invoice number, date, supplier, amounts, tax information).",
                    "GREEN_02": "Historically plausible for this supplier (similar amounts, structure, descriptions, intervals).",
                    "GREEN_03": "Sender email address is known (matches supplier master data or historical emails).",
                    "GREEN_04": "Amounts look plausible for the service (inferred price level matches the invoice amount).",
                    "GREEN_05": "Invoice refers to a clear service period (period is specified and not overlapping).",
                    "GREEN_06": "Bank details match master data (IBAN/recipient exactly match supplier master data).",
                    "RED_01": "Sender email address differs (new or slightly changed domain).",
                    "RED_02": "Service period overlaps with existing invoices (period appears already covered).",
                    "RED_03": "High amount or high inherent risk (amount over threshold or high-risk category).",
                    "RED_04": "Sudden amount increase for the same supplier (significant rise without clear reason).",
                    "RED_05": "Purchase order/contract missing or deviating (historically expected but missing, or major mismatch to linked order).",
                    "RED_06": "Bank details differ from supplier master data (new/changed IBAN compared to master data)."
                }
            },
            "upload": {
                "title": "Upload New Invoices",
                "info": "Drag and drop or click here to upload one or more invoices (*.pdf up to 30MB).",
                "info_attachments": "Drag-and-drop or click here to upload one or more attachments (up to 30MB per file).",
                "create_btn": "Start Invoice Recognition",
                "file_invalid": "Please upload only PDF or XML files up to 30MB.",
                "no_preview_available": "No preview is available for this file type. <br>Please download the file and open it on your computer.",
                "settings": "Settings",
                "group_by_tax": "Group by tax rate during recognition",
                "group_by_tax_hint": "When enabled, recognized lines will be grouped by tax rate on upload (e.g., Sum 19% tax).",
                "ai_validation": "Enable AI validation",
                "ai_validation_hint": "When enabled, the invoice will be moved directly to 'Ready for Export' status after AI recognition, provided no approval steps are required.",
                "ai_validation_mode": "AI validation",
                "ai_validation_mode_none": "No AI validation",
                "ai_validation_auto_forward": "Enable and move to Ready for Export",
                "ai_validation_auto_forward_hint": "When enabled, the invoice will be moved directly to 'Ready for Export' status after AI recognition, provided no approval steps are required.",
                "ai_validation_advisory": "Enable and keep status unchanged",
                "ai_validation_advisory_forced": "Already active, status remains unchanged",
                "ai_validation_advisory_hint": "When enabled, AI validates the invoice, writes the result to the timeline, and shows the score details without skipping the normal workflow.",
                "tour": {
                    "before_attach": "Here, you can upload one or multiple invoices by dragging and dropping or clicking within this area.",
                    "after_attach_title": "Start Invoice Recognition",
                    "after_attach": "Here, you can initiate automatic recognition for all uploaded invoices. You will then be redirected to the overview of the first invoice. The other invoices will be available in the task list."
                }
            },
            "tabs": {
                "lines": "Items",
                "discount": "Discount",
                "payment": "Payment data",
                "transactions": "Transactions",
                "notes": "Notes",
                "recognition": "Document recognition raw data"
            },
            "linked_transactions": {
                "title": "Linked transactions",
                "empty": "No linked transactions found.",
                "load_error": "Linked transactions could not be loaded.",
                "statement": "Statement",
                "match_type": "Link type",
                "allocated_amount": "Allocated amount",
                "match_type_direct": "Direct",
                "match_type_manual": "Split"
            },
            "new": "New Invoice",
            "select_contract_or_procurement": "Contract / Purchase request",
            "payment_conditions": "Payment Conditions",
            "discount1": "Discount 1",
            "discount2": "Discount 2",
            "discount_percentage": "Percentage",
            "discount_amount": "Amount",
            "discount_days": "Days",
            "discount_payment_date": "Date",
            "invoice_discount_data": "Discount data on the document",
            "supplier_discount_data": "Discount data in master data",
            "business_partner_discount_data": "Discount data in the business partner master data",
            "copy_discount_data_to_supplier": "Transfer from document to master data",
            "copy_discount_data_to_supplier_tooltip": "When clicked, the discount data entered in the form will be copied to the supplier's master data.",
            "copy_discount_data_to_business_partner_tooltip": "When clicked, the discount data entered in the form will be copied to the business partner's master data.",
            "download_pdf": "Download PDF",
            "download_pdf_info": "If the PDF is not displayed, please check your browser settings and ensure that the option \"Always download PDF files\" is disabled.",
            "download_xml": "Download XML",
            "download_xml_info": "Downloads the original FatturaPA XML file.",
            "visualization_generated_hint": "This PDF was generated from the e-invoice XML. The XML remains the legally binding original.",
            "visualization_compare_hint": "The XML PDF shows the XML content; the original PDF may differ. The XML remains legally binding.",
            "visualization_version_hint": "Visualization version: {version}.",
            "visualization_history": "PDF versions",
            "visualization_history_title": "PDF versions",
            "visualization_version_label": "PDF version {version}",
            "visualization_current_version": "Current",
            "visualization_version_created_at": "Created on: {date}",
            "visualization_version_renderer": "Rendering version: {renderer}",
            "visualization_version_view": "View",
            "visualization_version_download": "Download",
            "visualization_version_loading": "Loading PDF ...",
            "visualization_version_load_error": "The PDF version could not be loaded.",
            "regenerate_visualization": "Regenerate PDF",
            "regenerate_visualization_title": "Regenerate PDF",
            "regenerate_visualization_confirm": "The PDF will be regenerated using the current rendering version. The previous version will be retained. Do you want to continue?",
            "regenerate_visualization_confirm_button": "Regenerate",
            "regenerate_visualization_success": "PDF version {version} was generated successfully.",
            "regenerate_visualization_error": "The PDF could not be regenerated.",
            "document_tabs": {
                "xml": "XML",
                "preview": "Preview",
                "pdf": "PDF",
                "original_pdf": "Original PDF",
                "visualization": "KoSIT-PDF",
                "fatturapa": "FatturaPA",
                "fatturapa_pdf": "FatturaPA-PDF"
            },
            "fatturapa_preview": {
                "eyebrow": "FatturaPA",
                "invoice": "Invoice",
                "number": "Number",
                "date": "Date",
                "profile": "Format",
                "order_data": "Purchase order data",
                "order_number": "Number",
                "purchase_order_number": "Purchase order number",
                "line_reference": "Line reference",
                "order_reference": "Order reference",
                "item_number": "Item number",
                "convention_code": "Convention code",
                "cup": "CUP",
                "cig": "CIG",
                "supplier": "Seller",
                "customer": "Buyer",
                "vat_id": "VAT ID",
                "fiscal_code": "Fiscal code",
                "lines": "Line items",
                "description": "Description",
                "qty": "Qty",
                "unit_price": "Unit price",
                "discount": "Discount",
                "document_discount": "Document discount",
                "line_total": "Line total",
                "vat": "VAT",
                "taxable": "Taxable amount",
                "tax": "Tax",
                "total": "Total",
                "payment": "Payment",
                "payment_method": "Method",
                "show_xml": "Show XML",
                "hide_xml": "Hide XML",
                "footnote": "Local FatturaPA preview — the XML remains the legally binding original. Not an SDI acceptance result."
            },
            "notes_datev_hint": "This note is transmitted to the tax advisor via DATEV Unternehmen Online.",
            "recognition_data_title": "Recognition Raw Data",
            "no_recognition_data": "No data recognized.",
            "repeat_recognition_btn": "Repeat Document Recognition",
            "repeat_recognition_confirm_btn": "Confirm",
            "repeat_recognition_confirm_msg": "The existing data in the form will be overwritten. Are you sure you want to proceed?",
            "repeat_recognition_confirm_title": "Repeat Document Recognition",
            "repeat_recognition_feedback_msg": "Document recognition is being processed in the background and may take a few seconds.",
            "select_columns_btn": "Select columns",
            "export_to_datev_btn": "Submit to DATEV",
            "export_to_datev_csv_btn": "Export DATEV CSV",
            "export_to_ms365_btn": "Submit to D365",
            "export_btn_incomplete_form_tooltip": "Please complete the invoice data.",
            "export_btn_send_to_clearing_tooltip": "To retransmit to D365, please resend to accounting via the 'Clearing' step.",
            "export_error": "<b>The invoice could not be submitted</b>.<br>",
            "no_export_config_datev_tooltip": "No connection to <b>{export_name}</b> has been set up. <br>No DATEV client has been assigned in the configuration for the selected company <b>{client_name}</b>. <br>If necessary, contact a person with administrative rights <br>to set up the connection in the administration area.",
            "no_export_config_tooltip": "No connection to {export_name} has been set up.<br>Please contact a person with administrative rights to set up the connection in the administrative area.",
            "confirm_before_leave_msg": "Your invoice has not been saved. Are you sure you want to leave the page?",
            "can_not_edit": "You don't have permission to edit the data. To do so please send the invoice to clearing using Actions.",
            "recognized_client_id": "The company was successfully identified based on the <b>VAT ID</b> and <b>name</b>.<br> <b>Company:</b> {client_name}",
            "user_client_id": "The company was assigned based on the <b>user profile</b> of the uploader.<br><b>Company:</b> {client_name}",
            "field_origin": {
                "title": "Preselection origin",
                "source_label": "Source",
                "history_title": "Recognition history",
                "run_title": "{date} · {count} field(s){status}{model}",
                "unknown_run": "Unknown recognition",
                "field_column": "Field",
                "before_column": "Before",
                "after_column": "After",
                "reason_column": "Reason",
                "empty_value": "Empty",
                "ai_history_title": "AI processing history",
                "ai_request_label": "Request prompt",
                "ai_response_label": "AI response",
                "ai_system_prompt_label": "System prompt",
                "ai_user_prompt_label": "User prompt",
                "ai_sources_label": "Custom prompt sources",
                "ai_tenant_prompt_label": "Tenant prompt",
                "ai_client_prompt_label": "Client prompt",
                "ai_supplier_prompt_label": "Supplier prompt",
                "ai_recognition": "Invoice recognition",
                "ai_custom_prompt": "Custom prompt post-processing",
                "ai_supplier_identification": "Supplier identification",
                "ai_validation": "Invoice validation",
                "ai_succeeded": "Succeeded",
                "ai_failed": "Failed",
                "source_types": {
                    "recognition": "Document recognition",
                    "procurement": "Purchase order",
                    "supplier_master_data": "Supplier master data",
                    "business_partner_master_data": "Business partner master data",
                    "creator_default": "Uploader profile"
                },
                "reasons": {
                    "invoice_number_extracted_from_document": "Extracted directly from the recognized invoice document.",
                    "total_netto_extracted_from_document": "Extracted directly from the recognized invoice document.",
                    "total_brutto_extracted_from_document": "Extracted directly from the recognized invoice document.",
                    "invoice_date_extracted_from_document": "Extracted directly from the recognized invoice document.",
                    "due_date_extracted_from_document": "Extracted directly from the recognized invoice document.",
                    "delivery_date_extracted_from_document": "Extracted directly from the recognized invoice document.",
                    "document_discount_amount_extracted_from_document": "Extracted directly from the recognized invoice document.",
                    "document_discount_base_amount_extracted_from_document": "Extracted directly from the recognized invoice document.",
                    "document_discount_percentage_extracted_from_document": "Extracted directly from the recognized invoice document.",
                    "document_discount_tax_percentage_extracted_from_document": "Extracted directly from the recognized invoice document.",
                    "client_matched_by_receiver_name_or_vat": "Selected because the recognized invoice recipient matched a company by name or VAT ID.",
                    "client_matched_by_supplier_name_or_vat": "Selected because the recognized invoice issuer matched a company by name or VAT ID.",
                    "client_from_creator_profile": "Selected from the company assigned to the uploader.",
                    "client_from_procurement": "Copied from the matched purchase order.",
                    "supplier_matched_by_name_vat_or_iban": "Selected because recognized supplier data matched a supplier by name, VAT ID, or IBAN.",
                    "business_partner_matched_by_name_vat_or_iban": "Selected because recognized counterparty data matched a business partner by name, VAT ID, or IBAN.",
                    "business_partner_matched_by_receiver_name_or_vat": "Selected because the recognized invoice recipient matched a business partner by name or VAT ID.",
                    "supplier_from_single_procurement_supplier": "Selected because the matched purchase order has exactly one supplier.",
                    "procurement_matched_by_recognized_reference": "Selected because a recognized order reference matched this purchase order.",
                    "procurement_matched_by_invoice_similarity": "Selected because order amount, dates, and line items matched the invoice.",
                    "procurement_matched_by_invoice_similarity_without_supplier": "Selected because order amount, dates, and line items matched the invoice before a supplier was selected.",
                    "ledger_account_from_procurement": "Copied from the matched purchase order.",
                    "cost_center_from_procurement": "Copied from the matched purchase order.",
                    "cost_type_from_procurement": "Copied from the matched purchase order.",
                    "profit_center_from_supplier_master_data": "Copied from the selected supplier master data.",
                    "profit_center_from_business_partner_master_data": "Copied from the selected business partner master data.",
                    "department_from_procurement": "Copied from the matched purchase order.",
                    "branch_from_procurement": "Copied from the matched purchase order.",
                    "employee_from_procurement": "Copied from the matched purchase order.",
                    "financial_dimension_from_procurement": "Copied from the matched purchase order.",
                    "ledger_account_from_supplier_master_data": "Copied from the selected supplier master data.",
                    "cost_center_from_supplier_master_data": "Copied from the selected supplier master data.",
                    "ledger_account_from_business_partner_master_data": "Copied from the selected business partner master data.",
                    "cost_center_from_business_partner_master_data": "Copied from the selected business partner master data.",
                    "posting_key_from_recognized_tax": "Derived from the recognized tax rate.",
                    "supplier_iban_extracted_from_document": "Extracted directly from the recognized invoice document.",
                    "supplier_bic_extracted_from_document": "Extracted directly from the recognized invoice document.",
                    "payment_bank_data_extracted_from_document": "Bank details source was set from recognized document data."
                }
            },
            "client_address_check": {
                "match": "A check pursuant to Section 14 (4) UStG was carried out and no deviations were found.",
                "unrecognized": "The address could not be verified because it was not recognized on the invoice.",
                "mismatch_intro": "A check pursuant to Section 14 (4) UStG was carried out and a deviation was found:",
                "invoice_label": "Data on the invoice",
                "master_data_label": "Data in the master data",
                "supplier_message_button": "Request correction",
                "supplier_message_greeting": "Dear Sir or Madam,",
                "supplier_message_intro": "Thank you for sending the invoice.",
                "supplier_message_invoice_number_label": "Invoice number",
                "supplier_message_body": "Unfortunately, the address/name of our company stated on the invoice is not correct. Pursuant to Section 14 (4) UStG, an invoice must contain the correct address and name of the recipient of the service in order to meet the legal requirements.",
                "supplier_message_outro": "We therefore cannot accept the invoice in its current form and ask you to send us a corrected invoice with the correct address.",
                "supplier_message_questions": "If you have any questions, please do not hesitate to contact us.",
                "address_normalization": {
                    "street_aliases": ["street", "st", "st.", "road", "rd", "rd.", "avenue", "ave", "ave.", "boulevard", "blvd", "blvd.", "lane", "ln", "ln.", "drive", "dr", "dr.", "place", "pl", "pl.", "square", "sq", "sq.", "way", "wy"],
                    "number_aliases": ["nr", "nr.", "no", "no.", "number", "house number", "hno", "h.no"]
                }
            },
            "no_client_recognized": "No company could be identified based on the <b>VAT ID</b> or <b>name</b>.<br> Please check if the company data in liftbase matches the data on the invoice.",
            "recognized_supplier_id": "Based on the <b>IBAN</b>, <b>VAT ID</b> and <b>Name</b>, the supplier has been successfully identified.<br> <b>Supplier:</b> {supplier_name} <br> <b>VAT ID:</b> {supplier_vat_number} <br> <b>IBAN:</b> {supplier_iban} <br> <b>BIC:</b> {supplier_bic}",
            "supplier_custom_prompt_title": "Supplier-specific custom prompt",
            "supplier_custom_prompt_applied": "A supplier-specific custom prompt was applied during invoice recognition.",
            "supplier_custom_prompt_supplier_label": "Supplier",
            "supplier_custom_prompt_source_label": "Source",
            "supplier_custom_prompt_confidence_label": "Confidence",
            "supplier_custom_prompt_text_label": "Prompt",
            "supplier_custom_prompt_text_empty": "No custom prompt is currently stored for this supplier.",
            "supplier_custom_prompt_source": {
                "sender_domain": "Sender domain",
                "recognized_supplier_vat_iban": "VAT ID/IBAN",
                "recognized_supplier_name": "Supplier name",
                "first_page_ai": "AI (1st PDF page, text)",
                "first_page_ai_file": "AI (1st PDF page, scan)"
            },
            "recognized_business_partner_id": "Based on the <b>IBAN</b>, <b>VAT ID</b> and <b>Name</b>, the business partner has been successfully identified.<br> <b>Business Partner:</b> {supplier_name} <br> <b>VAT ID:</b> {supplier_vat_number} <br> <b>IBAN:</b> {supplier_iban} <br> <b>BIC:</b> {supplier_bic}",
            "no_supplier_recognized": "No supplier could be identified based on the <b>VAT ID</b> or <b>name</b>.<br> Please check if the supplier data in liftbase matches the data on the invoice.",
            "payment_details_not_equal": "The supplier's payment details do not match the recognized data or the form data.<br> <b>Supplier:</b> {supplier_name} <br> <b>VAT ID:</b> {supplier_vat_number} <br> <b>IBAN:</b> {supplier_iban} <br> <b>BIC:</b> {supplier_bic}",
            "payment_details_not_equal_business_partner": "The business partner's payment details do not match the recognized data or the form data.<br> <b>Business Partner:</b> {supplier_name} <br> <b>VAT ID:</b> {supplier_vat_number} <br> <b>IBAN:</b> {supplier_iban} <br> <b>BIC:</b> {supplier_bic}",
            "supplier_dialog_info": "\n<div style=\"text-align: justify\">\n    <style>\n        .modal-header {\n            margin-bottom: 0;\n        }\n\n        .modal-p {\n            margin-bottom: 10px !important;\n        }\n    </style>\n\n    <p class=\"modal-p\">\n        We noticed that the assigned supplier has changed.\n    </p>\n\n    <p class=\"modal-p\">\n        <strong>Possible reason:</strong><br>\n        The document recognition could not assign a supplier or assigned the wrong one.\n    </p>\n\n    <b class=\"modal-header\">Optimize automatic assignment</b>\n    <p class=\"modal-p\">\n        Did you know that in <strong>liftbase</strong> you can easily improve the automatic assignment for future documents?\n        Simply store the bank details (IBAN, BIC) or the VAT ID in the supplier's master data.\n        <strong>liftbase</strong> will use this information to automatically assign the correct supplier next time.\n    </p>\n    <p class=\"modal-p\">\n        In the <strong>“Payment data”</strong> section, you can either adopt the data recognized by the document recognition or enter your own.\n    </p>\n\n    <img src=\"images/example-payment-data.png\" alt=\"Example view\"\n         style=\"border: 1px solid #9c9c9c; border-radius: 5px; max-width: 100%; margin-bottom: 10px;text-align: center\"><br>\n\n    <b class=\"modal-header\">Automatic bank details verification</b>\n    <p class=\"modal-p\">\n        The bank details stored in <strong>liftbase</strong> are automatically checked for each document.\n        If a document contains different bank details, you will be notified.\n    </p>\n\n    <p class=\"modal-p\"><strong>Your advantages:</strong></p>\n    <ul>\n        <li>Reliably detect fraudulent invoices with fake bank details</li>\n        <li>Quickly identify when your supplier has changed their bank</li>\n    </ul>\n</div>",
            "supplier_dialog_title": "Automatic supplier recognition",
            "total_brutto_missing": "Please enter the Total Gross.",
            "total_brutto_zero": "Must not have an amount of 0 {currency}.",
            "total_brutto_does_not_match_with_positions": "Total amount must match the sum of the positions.",
            "total_brutto_difference": "Difference total a\u00ADmount vs line i\u00ADtems: {value}",
            "combination_invalid": "The combination of ledger account, cost center, and profit center is not allowed in D365.",
            "possible_combinations": "The following combinations are allowed",
            "current_combination": "Current combination",
            "combination": "Combination",
            "total_invoiced": "Total invoiced amount",
            "total_expected_procurement": "Total order value",
            "total_expected_contract": "Total contract value",
            "min_approval_one_person": "1 person",
            "min_approval_qty": "{qty} different people",
            "min_approval_error_msg": "The approval is not sufficient for this invoice. Please add another person for approval. This invoice must be approved by <b>at least {min_approval_msg}</b>.",
            "min_approval_error_title": "Approval not sufficient",
            "no_approval_limit_msg": "Your approval limit is not sufficient for this invoice. Please add another person for approval who has the necessary approval limit.",
            "no_approval_limit_title": "Approval limit",
            "confirm_without_approval_limit_msg": "None of the selected persons have the necessary approval limit for this invoice amount. The necessary approvals can be added later. Are you sure you want to proceed?",
            "confirm_without_approval_limit_title": "Approval limit",
            "invoice_vat_number": "Recognized VAT IDs",
            "supplier_vat_number": "VAT ID in master data",
            "business_partner_vat_number": "VAT ID in the business partner master data",
            "copy_vat_number_to_supplier": "Transfer to master data",
            "supplier_payment_data": "Bank details in master data",
            "business_partner_payment_data": "Bank details in the business partner master data",
            "invoice_payment_data": "Bank details on the document",
            "copy_payment_data_to_supplier": "Transfer from document to master data",
            "copy_payment_data_to_supplier_tooltip": "When clicked, the payment data entered in the form will be copied to the supplier's master data.",
            "copy_payment_data_to_business_partner_tooltip": "When clicked, the payment data entered in the form will be copied to the business partner's master data.",
            "magic_suggestions_btn_tooltip": "Fill suggestions based on previous invoices from the same supplier",
            "magic_suggestions_btn_tooltip_business_partner": "Fill suggestions based on previous invoices from the same business partner",
            "magic_suggestions_dialog": {
                "title": "Suggestions for this invoice",
                "message": "Select the fields you want to fill based on other invoices from this supplier.",
                "info_based_on_invoices": "Suggestions based on the following RE numbers:",
                "select_supplier_msg": "Please select a supplier in the form to search for suggestions.",
                "no_data": "No suggestions found for this supplier.",
                "error_load": "Error while loading suggestions.",
                "applied_success": "Suggestions applied."
            },
            "magic_suggestions_dialog_business_partner": {
                "message": "Select the fields you want to fill based on other invoices from this business partner.",
                "select_supplier_msg": "Please select a business partner in the form to search for suggestions.",
                "no_data": "No suggestions found for this business partner."
            },
            "procurement_summary": {
                "dialog_title": "Purchase request contents",
                "open_dialog": "Show details",
                "line_count": "{count} items at a glance",
                "empty": "No items are available for this purchase request.",
                "empty_filtered": "No items were found in the purchase request for the selected supplier \"{supplier_name}\".",
                "filtered_by_supplier": "Only items for supplier \"{supplier_name}\" are shown.",
                "item": "Item"
            },
            "lines": {
                "add_tooltip": "Add Invoice Line",
                "get_from_recognition": "Take from document recognition",
                "show_mismatch_panel_button": "Show deviations",
                "hide_mismatch_panel_button": "Hide deviations",
                "mismatch_warning_title": "Differences between calculated gross and document gross detected",
                "match_suggestion": "Suggestion",
                "match_confirmed": "Confirmed",
                "match_automatic": "Automatic",
                "match_automatic_suggestion": "Auto suggestion",
                "confirm_match": "Confirm match",
                "review_match": "Review",
                "match_confirm_dialog": {
                    "title": "Confirm line assignment",
                    "message": "These lines may be a match. Please review the values and choose how the assignment should be saved.",
                    "copied_fields_title": "Additional data that will be applied",
                    "copy_hint": "Assignment only confirms the order link. Apply data also copies cost center, ledger account and financial dimensions to the invoice line.",
                    "link_only_btn": "Confirm assignment only",
                    "copy_data_btn": "Confirm and apply data"
                },
                "legend": {
                    "description": "Legend",
                    "no_order": "Item not included in the order.",
                    "variance": "Variance in marked columns.",
                    "not_invoiced": "Ordered item not found on the invoice.",
                    "matched": "Item in order and on invoice is identical."
                },
                "group_by_tax": "Group by tax rate",
                "group_by_tax_hint": "Aggregate saved lines by tax rate (e.g., Sum 19% tax).",
                "form": {
                    "item": "Item",
                    "new": "New Invoice Line",
                    "validation": {
                        "description_required": "Please enter a name.",
                        "item_number_required": "Please enter an item number.",
                        "tax_percentage_required": "Please select a valid tax.",
                        "unit_net_price_required": "Please enter a valid number.",
                        "quantity_required": "Please enter a valid number.",
                        "commercial_discount_invalid": "Discount and base amounts must use the same sign, percentages must be between 0% and 100%, and discounts must not exceed their base amount."
                    },
                    "tour": {
                        "name": "Provide a meaningful name for the product.",
                        "number": "Here, you can enter the item number of the product.",
                        "price": "Enter a tax rate and a unit net price. The gross price will be calculated using the tax rate."
                    }
                },
                "table": {
                    "source": "Source",
                    "item_number": "Item No.",
                    "name": "Name",
                    "quantity": "Qty",
                    "tax": "Tax (%)",
                    "netto_price": "Unit Net",
                    "brutto_price": "Unit Gross",
                    "line_discount_percentage": "Discount (%)",
                    "show_discounts": "Enter discount",
                    "show_discounts_tooltip": "Shows the unit-price and line-discount fields. It is enabled automatically when a discount is present.",
                    "unit_price_base_amount": "Unit Price Before Price Discount",
                    "unit_price_base_amount_tooltip": "Original price per unit before a price discount is deducted.",
                    "unit_price_discount_amount": "Price Discount per Unit",
                    "unit_price_discount_amount_tooltip": "Discount amount per unit deducted from the original unit price.",
                    "line_discount_amount": "Total Line Discount",
                    "line_discount_amount_tooltip": "Discount amount for the entire invoice line, not per unit.",
                    "line_discount_base_amount": "Line Discount Base",
                    "line_discount_base_amount_tooltip": "Total line amount to which the line discount is applied.",
                    "line_discount_percentage_tooltip": "Percentage applied to the entire invoice line.",
                    "calc_brutto_from_net": "Calculate Gross from Net",
                    "calc_net_from_brutto": "Calculate Net from Gross",
                    "calc_brutto_from_net_tooltip": "Calculates only the unit gross price from unit net price and tax rate. Line discounts are not changed.",
                    "calc_net_from_brutto_tooltip": "Calculates only the unit net price from unit gross price and tax rate. Line discounts are not changed.",
                    "discount_validation_error": "Please check the values marked in red.",
                    "total_netto_price": "Total Net",
                    "tax_amount": "Total Tax",
                    "total_brutto_price": "Total Gross",
                    "cost_center": "Cost Center",
                    "profit_center": "Profit Center",
                    "ledger_account": "Ledger Account",
                    "tax_group": "Tax Group",
                    "tax_item_group": "Tax Item Group",
                    "open_bcase": "Open Document",
                    "no_order_position": "No order positions found. Please assign a <b>Purchase Order (PO)</b> and a <b>Supplier</b> to the invoice.",
                    "no_contract_position": "No contract items found. Please assign <b>a contract and a supplier</b> to the invoice.",
                    "copy_from_procurement": "Insert All Items from Purchase Order",
                    "copy_from_contract": "Insert All Items from Contract",
                    "no_order_tooltip": "No purchase order linked yet.",
                    "no_supplier_tooltip": "No supplier linked yet.",
                    "validation_error": "Please correct the errors in the table."
                }
            },
            "export_dialog": {
                "title": {
                    "D365": "Create Journal",
                    "DATEV": "Submit to DATEV",
                    "DATEV CSV": "DATEV CSV Export"
                },
                "description": "The following documents will be submitted to {export_name}.",
                "description_csv": "The following documents will be exported for {export_name}.",
                "btn_confirm": "Submit",
                "btn_confirm_csv": "Export",
                "btn_finish": "Close",
                "export_feedback_csv": "Exported",
                "export_feedback": "Submitted",
                "exported_csv": "Exported",
                "exported": "Submitted",
                "continue_background": "Continue in background",
                "exported_at": "Last exported",
                "is_loading": "Submission in progress",
                "is_loading_csv": "Export in progress",
                "include_exported": "Include already exported invoices",
                "export_selected_invoices_btn": "Send selection ({quantity}) to {export_name}",
                "export_cancelled_invoices_btn": "Send selected cancelled ({quantity}) to {export_name}",
                "export_all_cancelled_invoices_btn": "Send all cancelled ({quantity}) to {export_name}",
                "export_all_invoices_btn": "Send all documents ({quantity}) to {export_name}"
            },
            "export_menu": {
                "title": "Export",
                "group_ready": {
                    "title": "Export: Completed invoices"
                },
                "group_cancelled": {
                    "title": "Export: Cancelled invoices"
                }
            },
            "bulk_cancel_dialog": {
                "selected_btn": {
                    "invoice": "Cancel selected invoices ({quantity})",
                    "outgoing-invoice": "Cancel selected outgoing invoices ({quantity})",
                    "procurement": "Cancel selected orders ({quantity})",
                    "contract": "Cancel selected contracts ({quantity})",
                    "mixed": "Cancel selected documents ({quantity})"
                },
                "confirm_title": {
                    "invoice": "Cancel invoices",
                    "outgoing-invoice": "Cancel outgoing invoices",
                    "procurement": "Cancel orders",
                    "contract": "Cancel contracts",
                    "mixed": "Cancel documents"
                },
                "confirm_message": {
                    "invoice": "Do you really want to cancel all selected invoices ({quantity})?",
                    "outgoing-invoice": "Do you really want to cancel all selected outgoing invoices ({quantity})?",
                    "procurement": "Do you really want to cancel all selected orders ({quantity})?",
                    "contract": "Do you really want to cancel all selected contracts ({quantity})?",
                    "mixed": "Do you really want to cancel all selected documents ({quantity})?"
                },
                "confirm_btn": {
                    "invoice": "Cancel invoices",
                    "outgoing-invoice": "Cancel outgoing invoices",
                    "procurement": "Cancel orders",
                    "contract": "Cancel contracts",
                    "mixed": "Cancel documents"
                },
                "success": {
                    "invoice": "{quantity} invoices were cancelled.",
                    "outgoing-invoice": "{quantity} outgoing invoices were cancelled.",
                    "procurement": "{quantity} orders were cancelled.",
                    "contract": "{quantity} contracts were cancelled.",
                    "mixed": "{quantity} documents were cancelled."
                },
                "partial_success": {
                    "invoice": "{successCount} of {quantity} invoices were cancelled.",
                    "outgoing-invoice": "{successCount} of {quantity} outgoing invoices were cancelled.",
                    "procurement": "{successCount} of {quantity} orders were cancelled.",
                    "contract": "{successCount} of {quantity} contracts were cancelled.",
                    "mixed": "{successCount} of {quantity} documents were cancelled."
                },
                "error": {
                    "invoice": "The selected invoices could not be cancelled.",
                    "outgoing-invoice": "The selected outgoing invoices could not be cancelled.",
                    "procurement": "The selected orders could not be cancelled.",
                    "contract": "The selected contracts could not be cancelled.",
                    "mixed": "The selected documents could not be cancelled."
                }
            },
            "bulk_repeat_recognition_dialog": {
                "bulk_repeat_recognition_selected_invoices_btn": "Repeat document recognition ({quantity})",
                "confirm_title": "Repeat document recognition",
                "confirm_message": "The existing data in the selected invoices ({quantity}) will be overwritten. Are you sure you want to proceed?",
                "intro_message": "Document recognition will be restarted for the selected invoices ({quantity}). Existing form data may be overwritten.",
                "background_notice": "You can run it now and wait for the feedback, or start the process directly in the background.",
                "run_now_btn": "Run now",
                "run_background_btn": "Start in background",
                "background_started": "Document recognition was started in the background for {quantity} invoices.",
                "success": "Document recognition was restarted for {quantity} invoices.",
                "partial_success": "Document recognition was restarted for {successCount} of {quantity} invoices.",
                "error": "Document recognition could not be restarted for the selected invoices."
            },
            "select_columns_dialog": {
                "title": "Select columns",
                "select_fields": "The following columns will be displayed under <i>My Tasks</i> and <i>All Documents</i>.",
                "btn_confirm": "Apply",
                "btn_finish": "Close"
            },
            "copy_procurement_dialog": {
                "title": "Copy Data from Purchase Order",
                "message": "Would you like to copy some data from the purchase order to this invoice?",
                "message_contract": "Do you want to import some data from the contract into this invoice?",
                "overwrite_checkbox": "Overwrite existing data in the form.",
                "select_supplier_msg": "Select the supplier from which you want to copy the data:",
                "select_supplier_placeholder": "Select Supplier",
                "confirm_btn": "Confirm"
            },
            "copy_from_recognition_dialog": {
                "title": "Import data",
                "message": "Would you like to transfer some data from the invoice recognition or the form into this supplier?",
                "add_payment_method": "Would you also like to update the payment method?",
                "select_iban": "Select from the detected IBANs.",
                "select_vat_number": "Select from the detected VAT IDs.",
                "select_bic": "Select from the found BICs.",
                "success_msg": "Supplier updated.",
                "confirm_btn": "Confirm"
            },
            "validation": {
                "invoice_date_required": "Please enter an invoice date.",
                "due_date_required": "Please enter a due date.",
                "due_date_invalid1": "Due date must be greater than the document date.",
                "delivery_date_required": "Please enter a delivery date.",
                "ledger_account_required": "Please select a ledger account.",
                "branch_required": "Please select a branch.",
                "posting_key_required": "Please select a posting key.",
                "document_discount_tax_required": "Select a document discount VAT rate used by at least one invoice line.",
                "supplier_required": "Please select a supplier.",
                "business_partner_required": "Please select a business partner.",
                "cost_center_required": "Please select a cost center.",
                "profit_center_required": "Please select a profit center.",
                "employee_required": "Please select an employee.",
                "d365_branch_id_required": "Please select a branch.",
                "d365_employee_id_required": "Please select an employee.",
                "d365_department_required": "Please select a D365 department.",
                "financial_dimension_required": "Please select a financial dimension.",
                "client_required": "Please select a company.",
                "number_required": "Please enter the invoice number.",
                "prefix_required": "Please enter the prefix and the invoice number.",
                "number_invalid_d365": "Must contain no more than 20 characters.",
                "number_invalid": "Must contain up to 36 alphanumeric characters, no umlauts, and characters $ % & * + - /.",
                "notes_length": "Must not exceed 120 characters.",
                "discount_percentage_invalid1": "Discount percentage must be greater than 0.",
                "discount_percentage_invalid2": "Discount 1 must be greater than discount 2.",
                "discount_amount_invalid1": "Only positive amounts are acceptable for positive invoice amounts.",
                "discount_amount_invalid2": "Only negative amounts are acceptable for negative invoice amounts.",
                "discount_amount_invalid3": "Discount 1 must be greater than discount 2.",
                "discount_amount_invalid4": "Discount must be less than the total amount.",
                "discount_amount_invalid5": "The sum of the discount amounts must be less than the amount.",
                "discount_date_invalid1": "Discount dates 1 and 2 must be between invoice and due date.",
                "discount_date_invalid2": "Discount date 1 must be before discount date 2.",
                "missing_discount_field": "All discount fields must be filled in.",
                "procurement_required": "Please select a purchase request.",
                "contract_required": "Please select a contract.",
                "iban_required": "Please enter an IBAN.",
                "bank_country_required": "Please enter a bank country.",
                "bank_country_invalid": "Please enter a 2-letter ISO country code.",
                "bank_account_required": "Please enter an account number.",
                "bank_code_required": "Please enter a bank code."
            }
        }

    },
    "outgoing_invoice": {
        "description": "Outgoing invoice",
        "page": {
            "upload": {
                "title": "Upload new outgoing invoices"
            }
        }
    },
    "invoice_line": {
        "item_number": "Item Number",
        "quantity": "Quantity",
        "unit_net_price": "Unit Net Price",
        "tax_percentage": "Tax",
        "has_discount": "Line has a discount",
        "unit_price_base_amount": "Unit Price Before Discount (BT-148)",
        "unit_price_discount_amount": "Unit Price Discount (BT-147)",
        "line_discount_amount": "Line Discount (BT-136)",
        "line_discount_base_amount": "Line Discount Base (BT-137)",
        "line_discount_percentage": "Line Discount % (BT-138)"
    },
    "location": {
        "name": "Name",
        "number": "Number",
        "address": "Address",
        "form_sequence": "name,number,address"
    },
    "spreadsheet": {
        "add_row": "New Row",
        "download": "Download Table",
        "save": "Save Table"
    },
    "audit_log": {
        "description": "Edits",
        "history": "Edits",
        "table": "Table",
        "lb_user_id": "User",
        "data_before": "Before",
        "data_after": "After",
        "created_at": "Date",
        "type": {
            "insert": "Added",
            "update": "Edited",
            "delete": "Removed"
        },
        "msg": {
            "deleted": "removed",
            "inserted": "added",
            "was_deleted": "Was removed.",
            "was_inserted": "Was added.",
            "created_by_historical_invoice_onboarding": "Created during historical invoice onboarding."
        },
        "none": "none",
        "empty": "No edits available."
    },
    "txt_before_leave_page": "Your changes may not be saved. Are you sure you want to proceed?",
    "easybill_invoice": {
        "from_tenant": "From Tenant",
        "no_invoice": "No invoice created yet.",
        "number": "Number",
        "service_date": "Period",
        "from": "From",
        "until": "to",
        "total": "Total",
        "due_date": "Due Date",
        "status": "Status",
        "paid_at": "Paid On",
        "payment_missing": "Pending",
        "sepa": "SEPA",
        "tour": {
            "invoice_table": "Here you can find a detailed overview of all liftbase invoices, including their status. The invoices can be downloaded using a button."
        }
    },
    "configuration": {
        "description": "Settings",
        "sepa_number": "Creditor Identification Number",
        "sepa_mandate_reference": "Mandate Reference",
        "remove_sepa_msg": "Are you sure you want to revoke the SEPA direct debit?",
        "remove_sepa_btn": "Revoke",
        "system-modules-procurement": "Module - Purchase Requests",
        "system-modules-invoice": "Module - Invoices",
        "system-modules-bank-statements": "Module - Bank Statement Matching",
        "system-modules-permissions": "Module - Permission Groups",
        "system-modules-multilingualism": "Module - Multilingual Master Data",
        "system-modules-invoice-export": "Module - Invoice Export to",
        "purchaseorder-defaults-selectproduct": "Role Presets - Person “Product Selection”",
        "purchaseorder-defaults-sendorder": "Role Presets - Person “Order Placement”",
        "purchaseorder-defaults-clearing": "Role Presets - Person “Purchase Clearing”",
        "purchaseorder-defaults-consignee": "Role Presets - Person “Goods Receipt”",
        "invoice-defaults-manual_check": "Role Presets - Person “Manual Check (Invoice)”",
        "invoice-defaults-clearing": "Role Presets - Person “Accounting Clearing”",
        "purchaseorder-defaults-init_seq": "Purchase Requests - Order Numbers From",
        "purchaseorder-product-require_product_group": "Purchase Requests - All Products Must Be Assigned to a Product Group.",
        "purchaseorder-product-require_product_selection": "Purchase Requests - Purchase Request Process",
        "email-send-order": "Orders - E-Mail Order",
        "purchaseorder-pdf-free-text": "Orders - Order PDF",
        "type_email-send-order": "html-i18n",
        "type_purchaseorder-pdf-free-text": "html-i18n",
        "invoice-recognition-lines": "Invoices - Automatically Create Invoice Lines from Document Recognition.",
        "invoice-recognition-timeout": "Invoices - Azure receipt recognition timeout",
        "invoice-form-procurement-required": "Invoices - Purchase Request Link Required.",
        "notifications-mail-interval": "Notifications - E-Mail Interval in Minutes",
        "punchout-amazon-identity": "Integrations - Punch-out Amazon - Identity",
        "punchout-amazon-secret": "Integrations - Punch-out Amazon - Secret",
        "punchout-amazon-url": "Integrations - Punch-out Amazon - Punch-out URL",
        "punchout-amazon-order-url": "Integrations - Punch-out Amazon - Order URL",
        "punchout-amazon-email": "Integrations - Punch-out Amazon - E-Mail",
        "punchout-amazon-supplier": "Integrations - Punch-out Amazon - Default Supplier",
        "punchout-mercateo-identity": "Integrations - Punch-out Mercateo - Identity",
        "punchout-mercateo-secret": "Integrations - Punch-out Mercateo - Secret",
        "punchout-mercateo-url": "Integrations - Punch-out Mercateo - Punch-out URL",
        "punchout-mercateo-order-url": "Integrations - Punch-out Mercateo - Order URL",
        "punchout-mercateo-email": "Integrations - Punch-out Mercateo - E-Mail",
        "punchout-mercateo-supplier": "Integrations - Punch-out Mercateo - Default Supplier",
        "punchout-rajapack-identity": "Integrations - Punch-out RAJA - Identity",
        "punchout-rajapack-secret": "Integrations - Punch-out RAJA - Secret",
        "punchout-rajapack-url": "Integrations - Punch-out RAJA - Punch-out URL",
        "punchout-rajapack-order-url": "Integrations - Punch-out RAJA - Order URL",
        "punchout-rajapack-email": "Integrations - Punch-out RAJA - E-Mail",
        "punchout-rajapack-supplier": "Integrations - Punch-out RAJA - Default Supplier",
        "punchout-conrad-identity": "Integrations - Punch-out Conrad - Identity",
        "punchout-conrad-secret": "Integrations - Punch-out Conrad - Secret",
        "punchout-conrad-url": "Integrations - Punch-out Conrad - Punch-out URL",
        "punchout-conrad-order-url": "Integrations - Punch-out Conrad - Order URL",
        "punchout-conrad-email": "Integrations - Punch-out Conrad - E-Mail",
        "punchout-conrad-supplier": "Integrations - Punch-out Conrad - Default Supplier",
        "punchout-thgeyer-identity": "Integrations - Punch-out TH-GEYER - Identity",
        "punchout-thgeyer-secret": "Integrations - Punch-out TH-GEYER - Secret",
        "punchout-thgeyer-url": "Integrations - Punch-out TH-GEYER - Punch-out URL",
        "punchout-thgeyer-supplier": "Integrations - Punch-out TH-GEYER - Default Supplier",
        "punchout-reichelt-identity": "Integrations - Punch-out Reichelt - Identity",
        "punchout-reichelt-secret": "Integrations - Punch-out Reichelt - Secret",
        "punchout-reichelt-url": "Integrations - Punch-out Reichelt - Punch-out URL",
        "punchout-reichelt-supplier": "Integrations - Punch-out Reichelt - Default Supplier",
        "validation": {
            "bic_invalid": "Please enter a valid BIC.",
            "iban_invalid": "Please enter a valid IBAN number.",
            "default_decimal_places_invalid": "Please specify 2 to 4 decimal places."
        },
        "datev": {
            "description": "DATEV",
            "connection": "Connection with DATEV",
            "status_active": "Active",
            "status_inactive": "Inactive",
            "from": "From",
            "until": "Until",
            "load_clients": "Load DATEV Clients",
            "remove_connection": "Remove Connection",
            "deactivate_connection": "Deactivate connection",
            "add_connection": "Set Up Connection",
            "connected_by": "Connection established by {name}.",
            "apps_manager": "Here you can manage the <a href=\"https://apps.datev.de/tokrevui\" target=\"_blank\">applications connected with DATEV</a>.",
            "no_client_found": "No DATEV client found.",
            "msg_no_clients": "No entries found or you do not have the necessary permissions or the connection needs to be set up again.",
            "fiscal_year_start": "Fiscal Year Start",
            "account_length": "Account Length",
            "is_accounts_payable_ledger_available": "Accounts Payable Ledger",
            "is_accounts_receivable_ledger_available": "Accounts Receivable Ledger",
            "client_number": "Client Number",
            "consultant_number": "Consultant Number",
            "client_name": "Client",
            "liftbase_client": "liftbase Company",
            "save_client": "Save Company",
            "change_client": "Change Company"
        },
        "ms365": {
            "description": "D365",
            "connection": "Connect with D365",
            "status_active": "Active",
            "status_inactive": "Inactive",
            "auth_type": "Authentication",
            "oauth": "OAuth (User Consent)",
            "client_secret_auth": "Client Credentials (App Client ID + Secret)",
            "app_client_id": "App Client ID (Azure Application)",
            "app_tenant_id": "Azure Tenant ID",
            "client_secret": "Client Secret",
            "client_credentials_note": "If App Client ID and Client Secret are provided, the Client Credentials flow will be used for invoice export. Email import remains unchanged (OAuth).",
            "connect_and_load_data": "Establish connection and load data",
            "connect": "Establish connection",
            "load_data": "Load all data",
            "remove_connection": "Remove Connection",
            "add_connection": "Set Up Connection",
            "no_client_found": "No D365 tenants were found.",
            "msg_no_clients": "No entries found, or you do not have the necessary permissions, or the connection needs to be set up again.",
            "client_number": "D365 Company Number",
            "client_name": "D365 Company",
            "liftbase_client": "liftbase Company",
            "save_client": "Save Company",
            "change_client": "Change Company",
            "sync_running": "Data is loading. This may take a few minutes.",
            "last_sync_at": "Last loaded on {last_sync_at}",
            "journal_name": "Journal Name",
            "org_url": "Organization URL",
            "http_read_timeout": {
                "label": "HTTP read timeout for D365",
                "hint": "Defines how long liftbase waits for a D365 response. Leave empty to use the global backend configuration. Examples: <b>420s</b>, <b>5m</b>, <b>1h</b>.",
                "error": "Please enter a positive timeout, e.g. 420s, 5m, or 1h."
            }
        },
        "datev-csv": {
            "description": "DATEV CSV",
        },
        "template": {
            "module-procurement": {
                "group": "Modules",
                "label": "Purchase Order",
                "tour": [
                    {
                        "target": ".step-modules",
                        "content": "<p>Please select the liftbase modules you want to activate. You can find information on costs at <a href=\"liftbase.de/preise\" target=\"_blank\">liftbase.de/preise</a>.</p>"
                    }
                ]
            },
            "module-invoice": {
                "group": "Modules",
                "label": "Invoice"
            },
            "module-outgoing-invoice": {
                "group": "Modules",
                "label": "Outgoing invoices"
            },
            "module-bank-statements": {
                "group": "Modules",
                "label": "Bank Statement Matching"
            },
            "module-contract": {
                "group": "Modules",
                "label": "Contracts"
            },
            "module-permissions": {
                "group": "Modules",
                "label": "Permission Group"
            },
            "module-multilingualism": {
                "group": "Modules",
                "label": "Multilingual Master Data"
            },
            "module-supplier-communication": {
                "group": "Modules",
                "label": "Supplier Communication"
            },
            "module-liquidity-planning": {
                "group": "Modules",
                "label": "Liquidity Planning"
            },
            "insolvency-law-fields": {
                "group": "Modules",
                "label": "Show insolvency law fields"
            },
            "approval-limit-priority": {
                "group": "Modules",
                "label": "Priority level of approval limit"
            },
            "custom-fields": {
                "group": "Module",
                "label": "Custom fields"
            },
            "module-invoice-export": {
                "group": "Modules",
                "label": "Invoice export to",
                "options": [
                    {
                        "value": "datev",
                        "content": "DATEV"
                    },
                    {
                        "value": "ms365",
                        "content": "D365 Dynamics"
                    },
                    {
                        "value": "datev-csv",
                        "content": "DATEV CSV"
                    }
                ]
            },
            "procurement-select-product": {
                "group": "Role Defaults",
                "label": "Person \"Product Selection\"",
                "tour": [
                    {
                        "target": ".step-assignment",
                        "content": "<p>Here you can set global role defaults. If no role defaults are defined for the company or the department, the people entered here will be assigned to the respective steps in the workflow of purchase orders and invoices.</p>"
                    }
                ]
            },
            "procurement-send-order": {
                "group": "Role Defaults",
                "label": "Person \"Order Placement\""
            },
            "procurement-clearing": {
                "group": "Role Defaults",
                "label": "Person \"Procurement Clearing\"",
                "hint": "For clearing issues in procurement processes."
            },
            "procurement-consignee": {
                "group": "Role Defaults",
                "label": "Person \"Receipt of Goods\""
            },
            "invoice-manual-check": {
                "group": "Role Defaults",
                "label": "Person \"Manual Check (Invoice)\""
            },
            "invoice-clearing": {
                "group": "Role Defaults",
                "label": "Person \"Accounting Clearing\"",
                "hint": "For resolving issues during invoice processing."
            },
            "contract-clearing": {
                "group": "Role Defaults",
                "label": "Person \"Contract Clearing\"",
                "hint": "For clearing in contract workflows."
            },
            "procurement-init-seq": {
                "group": "Purchase Orders",
                "label": "Starting Order Numbers",
                "hint": "Enter a number from which order numbers should start.",
                "validation": {
                    "interval": "Must be between 0 and 999999999.",
                    "type": "Should only contain whole numbers."
                },
                "tour": [
                    {
                        "target": ".step-procurement",
                        "content": "Here you will find settings related to purchase orders. Configure the starting number for purchase orders and whether all products in purchase orders must be assigned to a product group."
                    }
                ]
            },
            "procurement-require-product-group": {
                "group": "Purchase Orders",
                "label": "All Products Must Belong to a Product Group."
            },
            "procurement-skip-place-order": {
                "group": "Purchase requisitions",
                "label": "Automatic transmission of the order to the online shop",
                "hint": "After the PunchOut, the online shop waits for approval in the ordering system. Without this option, the transmission must be started manually via the \"Transmit electronically\" button. With this option, the order is automatically transmitted electronically after approval. Works only for orders with a single supplier."
            },
            "procurement-require-product-selection": {
                "group": "Purchase Orders",
                "label": "Purchase Orders ",
                "options": [
                    {
                        "value": "true",
                        "content": "with product selection<br><ul><li>Create Purchase Order</li><li>Product Selection</li><li>Approval</li><li>Order</li><li>Receipt of goods</li></ul>"
                    },
                    {
                        "value": "false",
                        "content": "without product selection<br><ul><li>Create Purchase Order</li><li>Approval</li><li>Order</li><li>Receipt of goods</li></ul>"
                    }
                ]
            },
            "email-send-order": {
                "group": "Orders",
                "label": "Email Order",
                "hint": "Email message generated during the order placement step, including the order PDF, and sent to the supplier.",
                "default_value": "Dear Sir/Madam,<br>I am sending you our order as a PDF attachment. Please provide us with an order confirmation.",
                "tour": [
                    {
                        "target": ".step-email-order-free-text",
                        "content": "Compose a text here that will be included in the email message generated during the order placement step, including the order PDF, and sent to the supplier."
                    },
                    {
                        "target": ".step-pdf-free-text",
                        "content": "Compose a text here that will be displayed on the generated order PDF during the order placement step, which will be subsequently sent to the supplier."
                    }
                ]
            },
            "procurement-pdf-free-text": {
                "group": "Orders",
                "label": "Purchase Order PDF",
                "hint": "Message displayed on the generated purchase order PDF during the order placement step, which will be subsequently sent to the supplier.",
                "default_value": "",
            },
            "procurement-pdf-show-department": {
                "group": "Orders",
                "label": "Show department on order PDF"
            },
            "procurement-pdf-show-cost-center": {
                "group": "Orders",
                "label": "Show cost center on order PDF"
            },
            "procurement-pdf-show-created-by": {
                "group": "Orders",
                "label": "Show 'Created by' on order PDF"
            },
            "procurement-pdf-show-approver": {
                "group": "Orders",
                "label": "Show approver on order PDF"
            },
            "procurement-pdf-show-offer": {
                "group": "Orders",
                "label": "Show offer in item list"
            },
            "procurement-pdf-show-vat-number": {
                "group": "Orders",
                "label": "Show VAT ID on order PDF"
            },
            "invoice-recognition-lines": {
                "group": "Invoices",
                "label": "Automatically take the positions that document recognition has identified."
            },
            "invoice-recognition-group-by-tax": {
                "group": "Invoices",
                "label": "Group recognized invoice lines by tax rate",
                "hint": "When enabled, recognized lines are grouped by tax rate (e.g., Sum 19% tax)."
            },
            "invoice-recognition-ai-validation-mode": {
                "group": "Invoices",
                "label": "Default AI validation mode for invoice uploads",
                "hint": "This mode is preselected during upload and can be changed before creating the invoice.",
                "options": [
                    {
                        "value": "none",
                        "content": "No AI validation"
                    },
                    {
                        "value": "advisory",
                        "content": "Enable and keep the status unchanged"
                    },
                    {
                        "value": "ready-for-export",
                        "content": "Enable and move to Ready for Export"
                    }
                ]
            },
            "invoice-recognition-custom-fields": {
                "group": "Invoices",
                "label": "Extract Custom Fields during Azure recognition",
                "hint": "If enabled, we send queryFields (based on your custom fields) to Azure Document Intelligence to extract values. This can increase processing costs."
            },
            "invoice-recognition-custom-prompt": {
                "group": "Invoices",
                "label": "Global custom prompt for invoice recognition",
                "hint": "These instructions are applied to invoice recognition for the tenant and combined with any client- or supplier-specific prompts."
            },
            "invoice-recognition-model": {
                "group": "Invoices",
                "label": "Azure receipt recognition – Model",
                "options": [
                    {
                        "value": "document-intelligence",
                        "content": "Azure Document Intelligence (classic)"
                    },
                    {
                        "value": "content-understanding",
                        "content": "Azure Content Understanding (GenAI)"
                    },
                    {
                        "value": "azure-open-ai",
                        "content": "Azure OpenAI Responses API"
                    }
                ]
            },
            "invoice-recognition-timeout": {
                "group": "Invoices",
                "label": "Azure receipt recognition timeout per region",
                "hint": "Defines how long liftbase should poll one Azure region before switching to the next configured region. Default: <b>150s</b>. Examples: <b>150s</b>, <b>5m</b>, <b>1h</b>.",
                "validation": {
                    "format": "Please enter a duration like 150s, 5m, or 1h."
                }
            },
            "invoice-procurement-required": {
                "group": "Invoices",
                "label": "Linking the purchase order or contract is required."
            },
            "invoice-approval": {
                "group": "Invoices",
                "label": "When should an invoice be approved?",
                "options": [
                    {
                        "value": "always",
                        "content": "<b>Always</b><br>Invoices must always be approved."
                    },
                    {
                        "value": "if-no-order",
                        "content": "<b>Only if neither a PO nor a CT is assigned</b><br>Approval is only required if neither a Purchase Order (PO) nor a Contract (CT) is present."

                    },
                    {
                        "value": "never",
                        "content": "<b>Never</b><br>Invoices do not require separate approval."
                    }
                ]
            },
            "notifications-mail-interval": {
                "group": "Notifications",
                "label": "Email Interval in Minutes",
                "tour": [
                    {
                        "target": ".step-notification",
                        "content": "Set a global frequency for email notifications about new tasks. Email notifications are only sent when a person receives a new task."
                    }
                ]
            },
            "product-default-tax": {
                "group": "Product",
                "label": "Default tax rate (%)"
            },
            "product-default-currency": {
                "group": "Product",
                "label": "Default currency"
            },
            "product-default-unit": {
                "group": "Product",
                "label": "Default unit"
            },
            "punchout-amazon-identity": {
                "group": "Integrations",
                "subgroup": "Punch-out Amazon",
                "label": "Identity",
                "tour": [
                    {
                        "target": ".step-punchout-amazon",
                        "content": "Here you can set up your access to integrated marketplaces like Amazon and Mercateo. Instructions can be found <a href=\"https://liftbase.de/handbuch/einrichtung/punch-out\" target=\"_blank\">in our manual</a>."
                    }
                ]
            },
            "punchout-amazon-secret": {
                "group": "Integrations",
                "subgroup": "Punch-out Amazon",
                "label": "Secret"
            },
            "punchout-amazon-url": {
                "group": "Integrations",
                "subgroup": "Punch-out Amazon",
                "label": "Punch-out URL"
            },
            "punchout-amazon-order-url": {
                "group": "Integrations",
                "subgroup": "Punch-out Amazon",
                "label": "Order URL"
            },
            "punchout-amazon-email": {
                "group": "Integrations",
                "subgroup": "Punch-out Amazon",
                "label": "Email",
                "hint": "The email address of the main Amazon account. <br>Leave blank to transmit the email address of the logged-in person. <br>May require an Amazon account per person."
            },
            "punchout-amazon-supplier": {
                "group": "Integrations",
                "subgroup": "Punch-out Amazon",
                "label": "Supplier",
                "hint": "To which supplier should orders from this Punch-out provider be assigned (e.g., in reports)?"
            },
            "punchout-mercateo-identity": {
                "group": "Integrations",
                "subgroup": "Punch-out Mercateo",
                "label": "Identity"
            },
            "punchout-mercateo-secret": {
                "group": "Integrations",
                "subgroup": "Punch-out Mercateo",
                "label": "Secret"
            },
            "punchout-mercateo-url": {
                "group": "Integrations",
                "subgroup": "Punch-out Mercateo",
                "label": "Punch-out URL"
            },
            "punchout-mercateo-order-url": {
                "group": "Integrations",
                "subgroup": "Punch-out Mercateo",
                "label": "Order URL"
            },
            "punchout-mercateo-email": {
                "group": "Integrations",
                "subgroup": "Punch-out Mercateo",
                "label": "Email",
                "hint": "The email address of the main Mercateo account. <br>Leave blank to transmit the email address of the logged-in person. <br>May require a Mercateo account per person."
            },
            "punchout-mercateo-supplier": {
                "group": "Integrations",
                "subgroup": "Punch-out Mercateo",
                "label": "Supplier",
                "hint": "To which supplier should orders from this Punch-out provider be assigned (e.g., in reports)?"
            },
            "punchout-rajapack-identity": {
                "group": "Integrations",
                "subgroup": "Punch-out RAJA",
                "label": "Identity"
            },
            "punchout-rajapack-secret": {
                "group": "Integrations",
                "subgroup": "Punch-out RAJA",
                "label": "Secret"
            },
            "punchout-rajapack-url": {
                "group": "Integrations",
                "subgroup": "Punch-out RAJA",
                "label": "Punch-out URL"
            },
            "punchout-rajapack-order-url": {
                "group": "Integrations",
                "subgroup": "Punch-out RAJA",
                "label": "Order URL"
            },
            "punchout-rajapack-email": {
                "group": "Integrations",
                "subgroup": "Punch-out RAJA",
                "label": "Email"
            },
            "punchout-rajapack-supplier": {
                "group": "Integrations",
                "subgroup": "Punch-out RAJA",
                "label": "Supplier",
                "hint": "To which supplier should orders from this Punch-out provider be assigned (e.g., in reports)?"
            },
            "punchout-conrad-identity": {
                "group": "Integrations",
                "subgroup": "Punch-out Conrad",
                "label": "Identity"
            },
            "punchout-conrad-secret": {
                "group": "Integrations",
                "subgroup": "Punch-out Conrad",
                "label": "Secret"
            },
            "punchout-conrad-url": {
                "group": "Integrations",
                "subgroup": "Punch-out Conrad",
                "label": "Punch-out URL"
            },
            "punchout-conrad-order-url": {
                "group": "Integrations",
                "subgroup": "Punch-out Conrad",
                "label": "Order URL"
            },
            "punchout-conrad-email": {
                "group": "Integrations",
                "subgroup": "Punch-out Conrad",
                "label": "Email"
            },
            "punchout-conrad-supplier": {
                "group": "Integrations",
                "subgroup": "Punch-out Conrad",
                "label": "Supplier",
                "hint": "To which supplier should orders from this Punch-out provider be assigned (e.g., in reports)?"
            },
            "punchout-thgeyer-identity": {
                "group": "Integrations",
                "subgroup": "Punch-out TH.GEYER",
                "label": "Identity"
            },
            "punchout-thgeyer-secret": {
                "group": "Integrations",
                "subgroup": "Punch-out TH.GEYER",
                "label": "Secret"
            },
            "punchout-thgeyer-url": {
                "group": "Integrations",
                "subgroup": "Punch-out TH.GEYER",
                "label": "Punch-out URL"
            },
            "punchout-thgeyer-supplier": {
                "group": "Integrations",
                "subgroup": "Punch-out TH.GEYER",
                "label": "Default Supplier Company",
                "hint": "To which supplier should orders from this Punch-out provider be assigned (e.g., in reports)?"
            },
            "punchout-reichelt-identity": {
                "group": "Integrations",
                "subgroup": "Punch-out Reichelt",
                "label": "Identity"
            },
            "punchout-reichelt-secret": {
                "group": "Integrations",
                "subgroup": "Punch-out Reichelt",
                "label": "Secret"
            },
            "punchout-reichelt-url": {
                "group": "Integrations",
                "subgroup": "Punch-out Reichelt",
                "label": "Punch-out URL"
            },
            "punchout-reichelt-supplier": {
                "group": "Integrations",
                "subgroup": "Punch-out Reichelt",
                "label": "Default Supplier Company",
                "hint": "To which supplier should orders from this Punch-out provider be assigned (e.g., in reports)?"
            },
            "tour": [
                {
                    "target": "",
                    "content": ""
                }
            ]

        },
        "tour": {
            "tab_general": "Here, you can provide the name of your company for the liftbase environment.",
            "tab_contact": "Enter your company's contact information here. This data will be used for sending and delivering invoices for liftbase usage.",
            "tab_bank": "Here, you can set up a SEPA direct debit for liftbase billing or revoke it.",
            "tab_datev": "Here, you can set up the integration with DATEV. Log in to DATEV first to load all available clients. Link these clients with the companies registered in liftbase and individually connect each client with DATEV to enable the DATEV export. This connection has a validity of 2 years and extends each time it's used for an export.",
            "tab_marketplaces": "Here you can set up your access to integrated marketplaces such as Amazon and Mercateo. You can find a guide <a href=\"https://liftbase.de/handbuch/einrichtung/punch-out\" target=\"_blank\">in our manual</a>."
        }
    },
    "error_title": "Error",
    "request_error": "Error executing the request. Please check your internet connection or try again later.",
    "saved_success": "The document was saved successfully.",
    "duplicate_exists_check_records": "An identical record already exists. The item was not created. Please check your records.",
    "save_error": "Error saving the document.",
    "help_page": {
        "title": "Help",
        "popup_feedback_msg": "Your browser is set up correctly. You can now close this window.",
        "punchout_error_msg": "An error occurred. Please check the Punch-out settings or contact a person with administration rights.",
        "popup_did_not_open": "If no new window opened, pop-ups are blocked in your browser. Limitations may therefore occur during use.",
        "test_email_msg": "An email program or a list of email programs should have opened. Set up an email program from the list if necessary.",
        "tour_restart": "The tour has been restarted.",

        "manual_title": "Manual",
        "manual_msg": "<p>In the manual, you will find various articles and guides about the usage and setup of liftbase.</p>",
        "manual_open_btn": "Open Manual",

        "function_title": "Test Functions",

        "popup_msg": "<p>Here, you can test if pop-up windows are allowed in your browser, which are required for your product selection on external marketplaces like Amazon and Mercateo.</p>",
        "popup_test_btn": "Test Pop-up Blocker",

        "email_msg": "<p>Here, you can test if you can open emails with an email program. The email function is used, for example, to send orders to suppliers.</p>",
        "email_test_btn": "Test Email Function",

        "tour_title": "Tour",
        "tour_msg": "<p>To get a reintroduction to liftbase, you can restart the tour here.</p>",
        "tour_btn": "Restart Tour"
    },
    "dashboard_page": {
        "title": "Dashboard",
        "no_option": "None",
        "date_picker": {
            "start_placeholder": "Start date",
            "end_placeholder": "Start date",
            "separator": "to"
        },
        "ai": {
            "title": "AI Statistics",
            "menu_title": "AI Stats",
            "add_widget": "[+] Add new widget",
            "prompt_placeholder": "Describe the chart you want (e.g., Show me total orders per day)",
            "empty_state": "No widgets yet. Add one using a prompt.",
            "remove": "Remove",
            "limits_info": "You can ask only for totals of bcase (procurement, invoice, contract) either as COUNT or as VALUE, aggregated by a time unit (day, month, etc.). The AI will return generic fields (time and value) and metadata so the chart can be rendered generically.",
            "edit_label_title": "Edit widget label",
            "edit_label_message": "This will only edit the label/title shown on the card. It does not change the query or the chart.",
            "chart_type": {
                "bar": "bar",
                "line": "line",
                "pie": "pie"
            },
            "date_picker": {
                "required": "Date range is required"
            },
            "loading": {
                "adding_widget": "Adding widget…",
                "refresh_widget": "Refreshing…",
                "refresh_all": "Refreshing all widgets…"
            },
            "errors": {
                "create_failed": "It was not possible to create the widget.",
                "render_failed": "It was not possible to render the chart."
            }
        },
        "hub": {
            "title": "All dashboards in one place",
            "subtitle": "Use this overview as the central entry point for procurement, incoming invoices, outgoing invoices, e-invoice and AI.",
            "procurement_title": "Procurement Dashboard",
            "procurement_description": "Current purchasing charts, budgets and spending analysis.",
            "einvoice_title": "E-invoice Dashboard",
            "einvoice_description": "Supplier adoption, risk and e-invoice format analysis.",
            "invoice_title": "Incoming Invoice Dashboard",
            "invoice_description": "Analytics for real incoming invoice data based on your current filters.",
            "outgoing_invoice_title": "Outgoing Invoice Dashboard",
            "outgoing_invoice_description": "Analytics for real outgoing invoice data based on your current filters.",
            "supplier_title": "Supplier Dashboard",
            "supplier_description": "Bird's-eye view of suppliers, spending, orders, invoices and communication.",
            "ai_description": "Dynamic AI-generated charts based on prompt-driven widgets.",
            "demo_badge": "Test version"
        },
        "supplier": {
            "menu_title": "Supplier Dashboard",
            "eyebrow": "Purchasing assistant",
            "title": "Supplier Dashboard",
            "subtitle": "Select a supplier to see spending, orders, invoices, SupplierConnect and imported e-mails, plus an automatic AI summary.",
            "selected_supplier": "Selected supplier",
            "change_supplier": "Change supplier",
            "top_suppliers_title": "Top 10 suppliers",
            "top_suppliers_subtitle": "The most-used suppliers in the selected period and visible permission scope.",
            "top_supplier_spend": "{amount} net",
            "empty_top_suppliers": "No suppliers found for the selected period.",
            "orders": "orders",
            "invoices": "Invoices",
            "total_spend": "Spend",
            "total_spend_hint": "Sum of visible incoming invoices in the period",
            "procurement_value": "Order value",
            "procurement_value_hint": "Sum of visible orders in the period",
            "order_count": "Orders",
            "order_count_hint": "Visible orders in the period",
            "invoice_count": "Invoices",
            "invoice_count_hint": "Visible incoming invoices in the period",
            "email_count": "E-mails",
            "email_count_hint": "SupplierConnect and imported e-mails from visible documents",
            "ai_summary_title": "AI summary",
            "ai_summary_subtitle": "Generated automatically from visible orders, invoices and e-mails.",
            "ai_summary_loading": "AI analyzing",
            "ai_summary_empty": "No reliable AI summary available.",
            "ai_section_titles": {
                "highlights": "Highlights",
                "disputes": "Disputes and risks",
                "agreements": "Special agreements",
                "next_steps": "Next steps",
                "general": "Summary"
            },
            "ai_summary_disabled": "AI is disabled for your tenant. Enable AI in tenant settings to receive automatic summaries.",
            "refresh_ai_summary": "Refresh summary",
            "charts_title": "Spend and documents",
            "charts_subtitle": "Monthly development of spend, orders and invoices in the current period.",
            "spend_chart_title": "Spend per month",
            "document_chart_title": "Orders and invoices per month",
            "spend_mix_chart_title": "Spend by document type",
            "status_chart_title": "Documents by status",
            "invoice_spend_chart_title": "Invoice spend per month",
            "procurement_spend_chart_title": "Procurement value per month",
            "invoice_count_chart_title": "Invoices per month",
            "procurement_count_chart_title": "Orders per month",
            "invoice_status_chart_title": "Invoices by status",
            "procurement_status_chart_title": "Orders by status",
            "procurements_title": "Orders",
            "procurements_subtitle": "Visible orders for this supplier.",
            "invoices_title": "Invoices",
            "invoices_subtitle": "Visible incoming invoices for this supplier.",
            "contracts_title": "Contracts",
            "contracts_subtitle": "Visible contracts and informational findings for this supplier.",
            "contract_term": "Term",
            "contract_renewal": "Renewal",
            "contract_notice": "Notice",
            "contract_findings": "Contract findings",
            "empty_contracts": "No contracts found.",
            "contracts_disclaimer": "The contract information and findings shown here are informational only and are not legal advice.",
            "contract_finding_severity": {
                "high": "High",
                "medium": "Medium",
                "low": "Low",
                "info": "Information"
            },
            "unknown": "Unknown",
            "emails_title": "E-mails",
            "emails_subtitle": "SupplierConnect communication and imported invoice e-mails from visible documents.",
            "email_type_filter": "E-mail type",
            "email_type_all": "All",
            "email_type_communication": "Communication",
            "email_type_imported_invoice": "Imported invoice",
            "expand_email": "Expand e-mail",
            "collapse_email": "Collapse e-mail",
            "email_source_supplier_connect": "SupplierConnect",
            "email_source_imported": "Importierte E-Mail",
            "email_direction_outgoing": "Outgoing",
            "email_direction_incoming": "Incoming",
            "imported_email_hint": "Incoming invoice from imported e-mail.",
            "loading_original_email": "Loading original e-mail…",
            "open_document": "Open document",
            "show_more": "Show more",
            "show_less": "Show less",
            "empty_procurements": "No orders found.",
            "empty_invoices": "No invoices found.",
            "empty_emails": "No e-mails found.",
            "empty_filtered_emails": "No e-mails found for this filter.",
            "net_value": "Net",
            "no_subject": "No subject",
            "last_three_months": "Last 3 months",
            "last_six_months": "Last 6 months",
            "nav": {
                "summary": "Summary",
                "charts": "Charts",
                "emails": "E-mails",
                "procurements": "Orders",
                "invoices": "Invoices",
                "contracts": "Contracts"
            }
        },
        "invoice": {
            "title": "Incoming Invoice Dashboard",
            "incoming_subtitle": "This dashboard uses real incoming invoice data and shows status and distributions based on your current filters.",
            "outgoing_subtitle": "This dashboard uses real outgoing invoice data and shows status and distributions based on your current filters.",
            "sample_data": "Sample data",
            "accordions": {
                "summary": "Summary",
                "status": "Status"
            },
            "hero": {
                "data_label": "Data source",
                "live_value": "Real invoice data",
                "period_label": "Period",
                "documents_label": "Documents in view",
                "filters_label": "Active filters"
            },
            "filters": {
                "title": "Filter context",
                "subtitle": "Choose period, organization and supplier details to sharpen every section of the dashboard at once.",
                "active_filters_label": "Active filters",
                "active_filters_suffix": "active filters",
                "period_label": "Period"
            },
            "summary": {
                "incoming_count_label": "Invoices",
                "outgoing_count_label": "Outgoing invoices",
                "gross_total_label": "Gross volume",
                "gross_total_hint": "Gross total in the selected period",
                "suppliers_label": "Suppliers in filter",
                "suppliers_kicker": "Suppliers",
                "business_partners_label": "Business partners in filter",
                "business_partners_kicker": "Partners",
                "value_kicker": "Value",
                "departments_kicker": "Departments",
                "departments_label": "Departments in filter",
                "clients_kicker": "Clients",
                "clients_label": "Clients in filter",
                "incoming_count_hint": "Document count in the selected period",
                "outgoing_count_hint": "Document count in the selected period",
                "incoming_suppliers_hint": "Unique suppliers in the filtered invoice set",
                "outgoing_business_partners_hint": "Unique business partners in the filtered outgoing invoice set",
                "outgoing_suppliers_hint": "Unique suppliers in the filtered outgoing invoice set",
                "incoming_departments_hint": "Unique departments in the filtered invoice set",
                "outgoing_clients_hint": "Unique clients in the filtered outgoing invoice set"
            },
            "status_sections": {
                "incoming_title": "Invoices by status",
                "incoming_subtitle": "Status cards based on the same filters as the procurement dashboard.",
                "outgoing_title": "Outgoing invoices by status",
                "outgoing_subtitle": "Status cards for outgoing invoices in the same compact overview."
            },
            "datasets": {
                "incoming": "Invoices",
                "outgoing": "Outgoing invoices"
            },
            "sections": {
                "incoming_subtitle": "Charts for incoming invoices using the same core filters as the procurement dashboard.",
                "outgoing_subtitle": "Charts for outgoing invoices with focus on clients, suppliers, status and organization data."
            },
            "empty_state": "No invoice data found for the current filter combination.",
            "presets": {
                "this_month": "This month",
                "last_3_months": "Last 3 months",
                "year_to_date": "Year to date"
            },
            "status": {
                "approved": "Approved",
                "pending": "Pending review",
                "blocked": "Blocked"
            },
            "kpis": {
                "total_invoices": "Total invoices",
                "approved_rate": "Approved rate",
                "pending_review": "Pending review",
                "avg_gross": "Average gross value"
            },
            "charts": {
                "status_distribution": "Invoice status distribution",
                "status_distribution_subtitle": "Quick overview of how invoices are currently moving through the process.",
                "volume_trend": "Invoice volume trend",
                "volume_trend_subtitle": "Approved versus pending documents across the selected test period.",
                "count_by_status_subtitle": "Document count by status.",
                "value_by_status_subtitle": "Gross total by status.",
                "department_count_subtitle": "Distribution by department.",
                "department_value_subtitle": "Gross total by department.",
                "cost_center_count_subtitle": "Document count by cost center.",
                "cost_center_value_subtitle": "Gross total by cost center.",
                "ledger_count_subtitle": "Top ledger accounts by document count.",
                "incoming_status_count_title": "Invoices by status",
                "incoming_status_value_title": "Invoice value by status",
                "incoming_supplier_count_title": "Invoices by supplier",
                "incoming_supplier_count_subtitle": "Top suppliers by document count.",
                "incoming_supplier_value_title": "Invoice value by supplier",
                "incoming_supplier_value_subtitle": "Top suppliers by gross total.",
                "incoming_department_count_title": "Invoices by department",
                "incoming_department_value_title": "Invoice value by department",
                "incoming_cost_center_count_title": "Invoices by cost center",
                "incoming_cost_center_value_title": "Invoice value by cost center",
                "incoming_ledger_count_title": "Invoices by ledger account",
                "incoming_monthly_title": "Invoice trend by month",
                "incoming_monthly_subtitle": "Time series for incoming invoices.",
                "outgoing_status_count_title": "Outgoing invoices by status",
                "outgoing_status_value_title": "Outgoing invoice value by status",
                "outgoing_client_count_title": "Outgoing invoices by client",
                "outgoing_client_count_subtitle": "Top clients by document count.",
                "outgoing_client_value_title": "Outgoing invoice value by client",
                "outgoing_client_value_subtitle": "Top clients by gross total.",
                "outgoing_business_partner_count_title": "Outgoing invoices by business partner",
                "outgoing_business_partner_count_subtitle": "Top business partners by document count.",
                "outgoing_business_partner_value_title": "Outgoing invoice value by business partner",
                "outgoing_business_partner_value_subtitle": "Gross total by business partner.",
                "outgoing_department_count_title": "Outgoing invoices by department",
                "outgoing_cost_center_value_title": "Outgoing invoice value by cost center",
                "outgoing_ledger_count_title": "Outgoing invoices by ledger account",
                "outgoing_monthly_title": "Outgoing invoice trend by month",
                "outgoing_monthly_subtitle": "Time series for outgoing invoices."
            },
            "table": {
                "title": "Period breakdown",
                "subtitle": "Supporting sample table for the charts above.",
                "period": "Period",
                "total": "Total",
                "approved": "Approved",
                "pending": "Pending",
                "gross_value": "Gross value"
            }
        },
        "ordered_by": "Created by",
        "count_by_status": "Count by status",
        "diagrams": {
            "title": "Charts",
            "count_by_status": "Count per status",
            "value_by_status": "Values per status (Net in EUR)",
            "count_by_department": "Count per department",
            "value_by_department": "Values per department (Net in EUR)",
            "count_by_cost_center": "Count per cost center",
            "value_by_cost_center": "Values per cost center (Net in EUR)",
            "count_by_ledger_account": "Number by ledger account",
            "value_by_ledger_account": "Amounts by ledger account (Net in EUR)"
        },
        "budgets": {
            "title": "Budgets and Expenses",
            "approved_status": "Approved",
            "in_approval_status": "In Approval",
            "open_status": "Open",
            "no_budget": "Without Budget",
            "from": "From",
            "no_name": "No name"
        },
        "products": {
            "title": "Products",
            "approved_status": "Approved",
            "in_approval_status": "In Approval"
        },
        "no_data": "No purchase orders found.",
        "no_permission": "You do not have permission for the dashboard.",
        "from_budget": "from budget",
        "data": "Expenses",
        "shortcuts": {
            "this_week": "This week",
            "last_week": "Last week",
            "this_month": "This month",
            "last_month": "Last month",
            "last_30_days": "Last 30 days",
            "last_3_months": "Last 3 months",
            "last_6_months": "Last 6 months",
            "this_year": "This year",
            "last_year": "Last year"
        },
        "tour": {
            "title": "The dashboard offers you statistics and evaluation features for your purchase orders.",
            "filters_title": "Filter",
            "filters": "First select a desired period and then filter the purchase orders by company, ordered by, cost center or department.",
            "count_by_status_title": "Count by status",
            "count_by_status": "This shows how many of the pre-filtered purchase orders are currently in the respective statuses.",
            "graphic_title": "Charts",
            "graphic": "This is a graphical representation of the number or amounts of purchase orders, grouped by status, departments or cost centers.",
            "budget_title": "Budgets and expenses",
            "budget": "This area gives you an overview of the budgets and expenses of your cost centers. The colored bars show the usage of the budgets and how many of the expenses are still in approval.",
            "progress_bar_cost_center_title": "Progress bars by cost center",
            "progress_bar_cost_center": "Here you can unfold a more detailed overview of the different budgets of a cost center. The orders placed can also be listed for the individual budgets. Expenses without a budget are listed under a separate bar."
        },
        "einvoice": {
            "title": "E‑Invoice Dashboard",
            "analysis_period": "Analysis Period",
            "filters": {
                "date_range": "Date range",
                "client": "Company",
                "supplier": "Supplier",
                "select_period": "Select Period"
            },
            "placeholders": {
                "all": "All"
            },
            "kpis": {
                "percent_einvoices": "E-invoice Rate",
                "total_tax_eur": "Total Input Tax",
                "potential_loss": "Input Tax Risk",
                "total_invoices": "Total Invoices",
                "non_einvoice_quote": "Non-E-invoice Rate",
                "top_10_risk_share": "Top-10 Suppliers Input Tax Risk Share",
                "total_suppliers": "Total Suppliers",
                "suppliers_with_einvoice": "Suppliers with E-invoice",
                "suppliers_without_einvoice": "Suppliers without E-invoice",
                "avg_einvoice_quote": "Average E-quote (active suppliers)",
                "evaluated_months": "Evaluated Months",
                "data_coverage": "Data Coverage",
                "risk_concentration": "Risk Concentration",
                "only_suppliers_with_min_1": "only suppliers with at least 1 e-invoice"
            },
            "charts": {
                "format_distribution": "Format Distribution",
                "format_distribution_subtitle": "Share of XML, PDF+XML and non-structured invoices",
                "monthly_trend": "Monthly Trend by Invoice Format",
                "monthly_trend_subtitle": "Stacked quantities per month",
                "top_suppliers_risk": "Top Suppliers by Input Tax Risk",
                "top_suppliers_risk_subtitle": "High risk concentration on individual suppliers"
            },
            "table": {
                "monthly_evolution": "Monthly Evolution",
                "all_suppliers": "All Suppliers by E-quote (descending)",
                "month": "MONTH",
                "xml": "XML",
                "pdf_xml": "PDF+XML",
                "non_einvoice": "NON E-INVOICE",
                "risk": "INPUT TAX RISK",
                "supplier": "SUPPLIER",
                "quote": "E-QUOTE",
                "total_tax": "TOTAL TAX"
            },
            "banner": {
                "title": "Estimated amount of sales tax that will not be refunded by the tax office from 01.01.2027:",
                "subtitle": "{percent}% of estimated sales tax (Form Risk Model)",
                "description": "Period: {start} to {end}. Receipt obligation since 01.01.2025. Regulatory pressure increases from 01.01.2027. Increased formal validity risk for non-structured domestic B2B invoices from 01.01.2028. Model only assesses format compliance."
            },
            "hint": "Attention: The government will soon stop tax refunds for non-electronic invoices. Contact your suppliers as soon as possible to ensure you receive your e‑invoices correctly and do not lose money.",
            "alert": {
                "title": "Attention: Higher tax and formal risk for non-electronic invoices",
                "item_1": "From 01.01.2027, the risk for non-structured invoices increases significantly.",
                "item_2": "For such invoices, the tax office may refuse input VAT refunds.",
                "item_3": "From 01.01.2028, this applies to all suppliers, including those under €800,000 turnover (transition rule only for 2027).",
                "item_4": "Recommendation: Switch all your suppliers to e-invoices early and request adjusted invoicing."
            },
            "action_button": "Contact Recipient",
            "email_dialog": {
                "title": "Contact Recipient",
                "to": "Recipient Email",
                "to_placeholder": "email1@company.com; email2@company.com",
                "subject": "Subject",
                "message": "Message",
                "download_eml": "Download .eml",
                "send_email": "Send Email",
                "recipient_type": "Recipient Type",
                "recipient_type_supplier": "Supplier",
                "recipient_type_client": "Company",
                "invalid_recipients": "Please provide at least one valid email address.",
                "send_success": "Email sent successfully ({count}).",
                "send_error": "Email could not be sent.",
                "select_supplier_warning": "Please select a supplier first.",
                "default_subject": "Important: Transition to Electronic Invoices - {supplier}",
                "default_message": "Dear {supplier} Team,\n\nWe are currently reviewing our tax refund processes. Between {startDate} and {endDate}, we identified a total of {amount} in taxes from your invoices that were not sent as e-invoices (ZUGFeRD or XRechnung).\n\nPlease be advised that the government will soon stop tax refunds for non-electronic invoices. To ensure our continued partnership and avoid financial losses, we kindly request that you switch to sending electronic invoices as soon as possible.\n\nThank you for your cooperation.\n\nBest regards,\n{userName}\n{tenantName}\nYour Accounting Team",
                "client_default_subject": "E-invoice status and required action - {client}",
                "client_default_message": "Dear {client} Team,\n\nIn the period from {startDate} to {endDate}, a potential formal risk of {amount} was identified in your documents.\nPlease consider switching to structured e-invoice formats to reduce compliance risks.\n\nBest regards,\n{userName}\n{tenantName}"
            }
        }
    },
    "exceptions_center": {
        "menu_title": "Pending items",
        "title": "Pending items & exceptions",
        "subtitle": "This view brings together the most urgent invoices, procurements and contracts that need human action now.",
        "total_items": "Open items",
        "total_items_hint": "Filtered items currently visible in the central queue.",
        "filters_title": "Filter queue",
        "filters_subtitle": "Focus the list by document type, severity or a free-text search.",
        "clear_filters": "Clear filters",
        "search_placeholder": "Search by reference, client, supplier or reason",
        "type_filter": "Document types",
        "severity_filter": "Severity",
        "quick_filters_title": "Quick filters",
        "focus_areas_title": "Focus areas",
        "analysis_title": "Analysis",
        "document_mix_title": "Document mix",
        "amount_at_risk": "Amount at risk",
        "active_filters_title": "Active filters",
        "filtered_total_hint": "{filtered} of {total} items visible",
        "total_reference": "of {count} total",
        "active_state": "Filter active",
        "list_title": "Operational queue",
        "list_subtitle": "{count} items currently match the selected filters.",
        "empty_state": "No pending items were found for the current filter combination.",
        "open_case": "Open case",
        "updated_label": "Last update",
        "reasons_count": "{count} flags",
        "filter_groups": {
            "severity": "Severity",
            "type": "Type",
            "focus": "Focus",
            "search": "Search"
        },
        "summary": {
            "severity_kicker": "Severity",
            "document_kicker": "Document type",
            "severity_title": "By severity",
            "document_title": "By document type"
        },
        "signals": {
            "critical": "Critical now",
            "unassigned": "Without owner",
            "stale": "Stale items"
        },
        "focus_areas": {
            "payments": "Payments",
            "approvals": "Approvals",
            "master-data": "Master data",
            "ownership": "Ownership",
            "export": "Export",
            "deadlines": "Deadlines"
        },
        "severity": {
            "critical": "Critical",
            "high": "High",
            "medium": "Medium"
        },
        "document_types": {
            "invoice": "Invoice",
            "outgoing_invoice": "Outgoing invoice",
            "procurement": "Procurement",
            "contract": "Contract",
            "bank_statement": "Bank statement"
        },
        "reasons": {
            "invoice_duplicate": "Possible duplicate invoice detected.",
            "invoice_ai_validation_failed": "AI validation did not trust this invoice and routed it to manual review.",
            "invoice_overdue": "Invoice due date is overdue by {days} day(s).",
            "invoice_missing_due_date": "Invoice has no due date.",
            "invoice_waiting_approval": "Invoice is waiting in an approval step.",
            "invoice_missing_link": "Invoice has no linked procurement or contract.",
            "invoice_missing_supplier": "Invoice has no supplier assigned.",
            "invoice_missing_accounting_data": "Invoice is missing accounting dimensions such as cost center or ledger account.",
            "invoice_ready_for_export": "Invoice is ready for export but has not been exported yet.",
            "outgoing_invoice_duplicate": "Possible duplicate outgoing invoice detected.",
            "outgoing_invoice_overdue": "Outgoing invoice due date is overdue by {days} day(s).",
            "outgoing_invoice_missing_due_date": "Outgoing invoice has no due date.",
            "outgoing_invoice_waiting_processing": "Outgoing invoice is waiting in approval or accounting.",
            "outgoing_invoice_missing_client": "Outgoing invoice has no client assigned.",
            "outgoing_invoice_missing_accounting_data": "Outgoing invoice is missing accounting dimensions such as cost center or ledger account.",
            "outgoing_invoice_not_exported": "Outgoing invoice is completed but has not been exported yet.",
            "procurement_waiting_approval": "Procurement is waiting for approval.",
            "procurement_ordered_without_invoice": "Ordered procurement has no invoice after its delivery date.",
            "procurement_approved_without_invoice": "Approved procurement still has no invoice after one week.",
            "procurement_missing_delivery_date": "Procurement has no delivery date planned.",
            "procurement_not_allocated": "Procurement is not fully allocated.",
            "procurement_open_value_remaining": "Procurement still has open value after invoicing started.",
            "procurement_missing_supplier": "Procurement has no supplier assigned.",
            "procurement_missing_accounting_data": "Procurement is missing accounting dimensions such as cost center or ledger account.",
            "contract_termination_deadline_passed": "Termination deadline has already passed.",
            "contract_termination_deadline_soon": "Termination deadline is within the next {days} day(s).",
            "contract_termination_deadline_near": "Termination deadline is within the next 30 days.",
            "contract_end_date_passed": "Contract end date has already passed.",
            "contract_end_date_soon": "Contract end date is within the next {days} day(s).",
            "contract_end_date_near": "Contract end date is within the next 30 days.",
            "contract_missing_owner": "Contract has no responsible owner assigned.",
            "contract_missing_supplier": "Contract has no supplier assigned.",
            "bank_statement_failed": "Bank statement processing failed.",
            "bank_statement_partial": "Bank statement processing completed only partially.",
            "bank_statement_unmatched_entries": "Bank statement still has {count} unmatched entrie(s).",
            "bank_statement_processing_too_long": "Bank statement has been processing for more than one day.",
            "bank_statement_empty": "Bank statement was processed without entries.",
            "bank_statement_missing_owner": "Bank statement has no account owner filled in.",
            "item_unassigned": "Current workflow step has no responsible user assigned.",
            "item_stale": "Item has had no relevant update for {days} day(s)."
        }
    },
    "overview_page": {
        "title": "Overview",
        "procurement_abbr": "PO",
        "invoice_abbr": "IN",
        "outgoing_invoice_abbr": "OI",
        "draft_abbr": "DR",
        "contract_abbr": "CT",
        "delivery_note_abbr": "DN",
        "all_docs": "All documents",
        "all_docs_tree": "All documents (Tree view)",
        "all_docs_list": "All documents (List view)",
        "search_all_documents": "Search in all documents",
        "export_ready_docs": "Ready for export",
        "my_tasks": "My tasks",
        "my_orders": "My orders",
        "my_bank_statements": "My bank statements",
        "previous_document": "Previous document",
        "next_document": "Next document",
        "collapse_sidebar": "Collapse sidebar",
        "expand_sidebar": "Expand sidebar",
        "collapse_properties_sidebar": "Collapse actions panel",
        "expand_properties_sidebar": "Expand actions panel",
        "properties_sidebar": {
            "no_step": "No active step",
            "completed": "Completed"
        },
        "saved_searches": "Saved searches",
        "my_orders_no_invoices": "No invoice linked to this order yet.",
        "my_orders_goods_receipt": "Goods receipt",
        "procurements": "Purchase orders",
        "invoices": "Invoices",
        "outgoing_invoices": "Outgoing invoices",
        "list_column_incoming_invoice": "Incoming",
        "list_column_outgoing_invoice": "Outgoing",
        "drafts": "Drafts",
        "contracts": "Contracts",
        "no_selection": "No document selected.",
        "common_fields": "Common fields",
        "comment_box_placeholder": "Your comment...",
        "comment_box_btn": "Comment",
        "comment_box_mentions_loading": "Loading users...",
        "comment_box_mentions_empty": "No users found.",
        "communication": {
            "tooltip": "Contact supplier",
            "tooltip_business_partner": "Contact business partner",
            "disabled_hint": "Please configure an active mailbox with supplier communication enabled for this document type in settings.",
            "dialog_title": "Contact supplier",
            "dialog_title_business_partner": "Contact business partner",
            "send_order_dialog_title": "Send order via SupplierConnect",
            "from_mailbox": "Sender mailbox",
            "from_mailbox_placeholder": "Select mailbox",
            "supplier": "Supplier",
            "to": "To",
            "visibility": "Visibility",
            "internal_note": "Internal note",
            "internal_tag": "Internal",
            "external_tag": "External",
            "external_hint": "External: the supplier and all selected recipients receive this message.",
            "internal_hint": "Internal: only mentioned liftbase users receive a notification. The supplier is not contacted.",
            "cc_mentions": "Cc users (@mention)",
            "cc_mentions_placeholder": "Use @ to mention users from the system",
            "internal_recipients": "Internal recipients",
            "cc_emails": "Cc e-mails",
            "cc_emails_placeholder": "Add e-mail and press Enter",
            "subject": "Subject",
            "body": "Message",
            "body_placeholder": "Write your message...",
            "attach_order_pdf": "Attach order PDF",
            "attach_invoice_document": "Attach invoice document",
            "attach_order_pdf_mode_plain": "Without offer",
            "attach_order_pdf_mode_with_line_attachments": "With offer",
            "reply_info": "Replies are sent only to the configured communication mailbox. The initiating user is notified afterwards.",
            "internal_reply_info": "Internal notes are sent only to mentioned liftbase users.",
            "send": "Send e-mail",
            "dialog_options_action": "More e-mail options",
            "validation": "Please fill in all required fields.",
            "sent_success": "Communication sent successfully.",
            "sent_error": "Could not send the communication.",
            "sent_error_mailbox_reconnect": "The communication could not be sent because the Microsoft mailbox {mailbox} is no longer connected.\nPlease reconnect the mailbox in settings and try again.",
            "sent_error_mailbox_incomplete": "The communication could not be sent because the mailbox {mailbox} is missing SMTP host, username or password.\nPlease complete the mailbox configuration in settings.",
            "history_title": "Supplier communications",
            "history_title_business_partner": "Business partner communications",
            "history_empty": "No communications were started for this document yet.",
            "recipients": "Recipients",
            "cc": "Cc",
            "attachments": "Attachments",
            "attachments_available": "Contains attachments",
            "statuses": {
                "pending": "Pending",
                "sent": "Sent",
                "failed": "Failed",
                "received": "Received"
            },
            "reply_action": "Reply",
            "forward_action": "Forward",
            "forward_dialog_title": "Forward e-mail",
            "forward_subject_prefix": "Fwd:",
            "forwarded_message_title": "Forwarded message",
            "forward_attachments_hint": "These attachments will be sent with the forwarded e-mail.",
            "history_quote_title": "Conversation history",
            "history_date_label": "Date",
            "history_from_label": "From",
            "history_to_label": "To",
            "history_subject_label": "Subject",
            "show_less": "Show less",
            "involved_button": "Involved",
            "involved_title": "People and e-mails involved",
            "involved_search_placeholder": "Search by name or e-mail",
            "involved_copy_email": "Copy e-mail",
            "involved_copied": "E-mail copied",
            "involved_empty": "No participants found",
            "involved_sections": {
                "suppliers": "Suppliers",
                "users": "Internal users",
                "manual": "Manual e-mails",
                "mailbox": "Mailbox"
            },
            "address_book_source_supplier": "Supplier address",
            "address_book_source_saved": "Previously used",
            "address_book_delete": "Remove saved suggestion",
            "address_book_delete_success": "Saved suggestion removed.",
            "address_book_delete_error": "Could not remove the saved suggestion."
        },
        "edit_filename_title": "Edit filename",
        "edit_filename_msg": "Please enter the new filename. <br> Old name: {filename}",
        "duplicate_invoice": {
            "message": "Duplicate - At least one invoice with the same invoice number was found:",
            "invoice_number": "Invoice Number",
            "invoice_date": "Date"
        },
        "task_list": {
            "name": "Name",
            "status": "Status",
            "date": "Date",
            "draft": "Draft"
        },
        "searchbar": {
            "search": "Search",
            "filter_by": "Filter by",
            "created_at": "Creation date",
            "timeline": "Timeline",
            "last_used": "Last used",
            "favorites": "Favorites",
            "no_search": "None",
            "save_search": "Save search",
            "save_search_prompt": "Do you want to save this search? Enter a label.",
            "label_placeholder": "Label",
            "label_required": "Please enter a label.",
            "label_exists": "This label already exists.",
            "saved_success": "Search saved.",
            "edit_saved_search": "Rename saved search",
            "edit_saved_search_title": "Rename saved search",
            "edit_saved_search_prompt": "What should this saved search be called?",
            "edited_success": "Saved search renamed.",
            "delete_saved_search": "Delete saved search",
            "delete_saved_search_title": "Delete saved search",
            "delete_saved_search_prompt": "Do you really want to delete the saved search \"{label}\"?",
            "deleted_success": "Saved search deleted.",
            "timeline_props": {
                "editor_name": "Editor",
                "entry_type": "Timeline Step",
                "current_editor_name": "Current Editor",
                "current_entry_type": "Current Step"
            },
            "common_props": {
                "client_name": "Company Name",
                "client_number": "Company Number",
                "department_name": "Department Name",
                "department_number": "Department Number",
                "cost_center_name": "Cost Center Name",
                "cost_center_number": "Cost Center Number",
                "ledger_account_name": "Ledger Account Name",
                "ledger_account_number": "Ledger Account Number",
                "cost_type_name": "Cost Type",
                "product_names": "Product",
                "product_numbers": "Product Number",
                "status": "Status",
                "supplier_display_name": "Supplier",
                "payment_in_advance": "Payment in advance",
            },
            "procurement_props": {
                "order_number_formatted": "Order Number",
                "name": "Description",
                "creator_name": "Created by",
                "consignee_name": "Goods Receipt",
                "supplier_names": "Supplier",
                "delivery_date_overdue": "Delivery date overdue"
            },
            "invoice_props": {
                "invoice_number": "Invoice Number",
                "invoice_number_formatted": "Internal Invoice Number",
                "invoice_prefix": "Invoice prefix",
                "procurement_number": "Order Number",
                "creator_name": "Uploaded by",
                "supplier_name": "Supplier Name",
                "supplier_number": "Supplier Number",
                "invoice_date": "Invoice Date",
                "due_date": "Due Date"
            },
            "time_ranges": {
                "today": "today",
                "yesterday": "yesterday",
                "past_7_days": "last 7 days",
                "past_30_days": "last 30 days",
                "this_week": "this week",
                "last_week": "last week",
                "this_month": "this month",
                "last_month": "last month",
                "this_year": "this year",
                "last_year": "last year"
            }
        },
        "export": {
            "all_information": "All Information",
            "export_procurement": "Export Purchase Orders",
            "export_documents": "Export Documents",
            "registers": "entries",
            "export": "Export",
            "to_export": "Export",
            "export_with_products": "Export with products",
            "custom_export": "Configured export",
            "select_fields": "Select the fields that should be exported.",
            "select_all": "Select all",
            "deselect_all": "Remove all",
            "general": "General",
            "products": "Products",
            "include_product": "Incl. products",
            "filter": " filter",
            "no_filter": "no filter",
            "format": "File format",
            "csv": "CSV",
            "xlsx": "XLSX",
            "loading": "loading",
            "error": "Export failed. Please try again.",
            "labels": {
                "procurement": {
                    "order_number_formatted": "LB-Number",
                    "name": "Name",
                    "creator_name": "Created by",
                    "status": "Status",
                    "total_price_brutto": "Total-Gross",
                    "total_price_netto": "Total-Net",
                    "type_total_price_brutto": "currency",
                    "type_total_price_netto": "currency",
                    "created_at": "Creation date",
                    "client_number": "Company number",
                    "client_name": "Company name",
                    "department_name": "Department name",
                    "department_number": "Department number",
                    "cost_center_number": "Cost center number",
                    "cost_center_name": "Cost center name",
                    "consignee_name": "Receipt of goods",
                    "shipping_date": "Delivery date",
                    "shipping_name": "Delivery address name",
                    "shipping_consignee": "Delivery address name of receiving person",
                    "shipping_dropoff_location": "Delivery address name of drop-off location",
                    "shipping_address": "Delivery address street and no.",
                    "shipping_complement": "Delivery address street 2",
                    "shipping_country": "Delivery address country",
                    "shipping_zipcode": "Delivery address postal code",
                    "shipping_city": "Delivery address city",
                    "shipping_phone_country_code": "Delivery address phone country",
                    "shipping_phone_number": "Delivery address phone number",
                    "billing_name": "Invoice address name",
                    "billing_consignee": "Invoice address name receiving person",
                    "billing_dropoff_location": "Invoice address name of the drop-off location",
                    "billing_address": "Invoice address street and no.",
                    "billing_complement": "Invoice address street 2",
                    "billing_country": "Invoice address country",
                    "billing_zipcode": "Invoice address postal code",
                    "billing_city": "Invoice address city",
                    "billing_phone_country_code": "Invoice address phone country",
                    "billing_phone_number": "Invoice address phone number"
                },
                "product": {
                    "product_name": "Product name",
                    "product_number": "Item number",
                    "product_supplier_name": "Supplier name",
                    "product_supplier_email": "Supplier email",
                    "product_cost_center_name": "Cost center name (product)",
                    "product_cost_center_number": "Cost center number (product)",
                    "product_tax": "Tax",
                    "product_quantity": "Quantity (product)",
                    "product_total_netto": "Total-net (product)",
                    "product_total_brutto": "Total-gross (product)",
                    "product_netto": "Single price net",
                    "product_brutto": "Single price gross",
                    "product_unit_price_base_amount": "Unit price before discount (product)",
                    "product_unit_price_discount_amount": "Unit price discount (product)",
                    "product_line_discount_amount": "Line discount (product)",
                    "product_line_discount_base_amount": "Line discount base (product)",
                    "product_line_discount_percentage": "Line discount % (product)",
                    "product_unit": "Unit",
                    "product_img_url": "Image URL",
                    "product_shop_url": "Shop URL",
                    "product_shipping_name": "Delivery address name (product)",
                    "product_shipping_consignee": "Delivery address name receiving person (product)",
                    "product_shipping_dropoff_location": "Delivery address name of the drop-off location (pProduct)",
                    "product_shipping_address": "Delivery address street and no. (product)",
                    "product_shipping_complement": "Delivery address street 2 (product)",
                    "product_shipping_country": "Delivery address country (product)",
                    "product_shipping_zipcode": "Delivery address postal code (product)",
                    "product_shipping_city": "Delivery address city (product)",
                    "product_shipping_phone_country_code": "Delivery address phone country (product)",
                    "product_shipping_phone_number": "Delivery address phone number (product)",
                    "product_received_at": "Last goods receipt (date)",
                    "product_received_by": "Last goods receipt (person)"
                },
                "invoice": {
                    "invoice_number_formatted": "Internal invoice number",
                    "invoice_prefix": "Invoice prefix",
                    "number": "Invoice number",
                    "creator_name": "Uploaded by",
                    "status": "Status",
                    "procurement_name": "Purchase order",
                    "procurement_number": "Order number",
                    "cost_center_name": "Cost center name",
                    "cost_center_number": "Cost center number",
                    "total_price_netto": "Total net",
                    "total_price_brutto": "Total gross",
                    "document_discount_amount": "Document discount amount",
                    "document_discount_base_amount": "Document discount base",
                    "document_discount_percentage": "Document discount %",
                    "document_discount_tax_percentage": "Document discount VAT %",
                    "type_total_price_brutto": "currency",
                    "type_total_price_netto": "currency",
                    "created_at": "Uploaded on",
                    "client_name": "Company",
                    "client_number": "Company number",
                    "invoice_date": "Invoice date",
                    "due_date": "Due date",
                    "delivery_date": "Delivery date",
                    "currency": "Currency",
                    "ledger_account_name": "Ledger account name",
                    "ledger_account_number": "Ledger account number",
                    "posting_key_number": "Posting key number",
                    "posting_key_tax": "Posting key tax",
                    "supplier_name": "Supplier",
                    "paid": "Paid"
                },
                "contract": {
                    "name": "Name",
                    "contract_date": "Contract date",
                    "contract_number_formatted": "CT number",
                    "contract_number": "Contract number",
                    "category": "Category",
                    "status": "Status",
                    "term_type": "Term type",
                    "payment_method": "Payment method",
                    "external_contract_number": "External contract number",
                    "creator_name": "Created by",
                    "created_at": "Creation date",
                    "client_number": "Company number",
                    "client_name": "Company name",
                    "department_name": "Department name",
                    "department_number": "Department number",
                    "cost_center_name": "Cost center name",
                    "cost_center_number": "Cost center number",
                    "supplier_name": "Supplier name",
                    "supplier_number": "Supplier number",
                    "responsible_name": "Responsible",
                    "notes": "Note",
                    "payment_direction": "Relation",
                    "recurring_invoice": "Recurring invoice",
                    "start_date": "Start date",
                    "end_date": "End date",
                    "duration": "Contract duration",
                    "duration_unit_type": "Contract duration unit",
                    "renewal_type": "Renewal type",
                    "renewal_duration": "Renewal duration",
                    "renewal_duration_unit_type": "Renewal duration unit",
                    "notice_period": "Notice period",
                    "notice_period_unit_type": "Notice period unit",
                    "termination_special_right": "Special right of termination",
                    "termination_deadline": "Termination deadline",
                    "next_possible_contract_end": "Next possible contract end",
                    "terminated_on": "Terminated on",
                    "termination_to": "Termination to",
                    "payment_timing": "Payment type",
                    "usage_type": "Frequency"
                }
            }
        },
        "actions": {
            "tour": {
                "procurement_reassignment_title": "Assign/Clearing Purchase Order",
                "procurement_reassignment_msg": "This task is currently with another person. Use this button to send the task to clearing or to assign this task to a third person or yourself. In clearing, purchase orders can also be cancelled.",
                "invoice_reassignment_title": "Assign/Clearing invoice",
                "invoice_reassignment_msg": "This task is currently with another person. Use this button to send the task to clearing or to assign this task to a third person or yourself. In clearing, invoices can also be cleared."
            },
            "skip_confirm_dialog_title": "Cancel document recognition",
            "skip_confirm_dialog_msg": "To check if a document recognition result already exists, refresh the page in your browser. <br>Are you sure you want to cancel the invoice data recognition and enter the invoice data manually?",
            "button_hint": {
                "to_approval": "To approval",
                "to_send_order": "To order",
                "to_accounting": "To Accounting",
                "approve": "Approve",
                "self_assign": "Accept",
                "finish_order": "Complete order",
                "finish_delivery": "Finish",
                "skip_recognition": "Cancel document recognition",
                "to_export": "To Export",
                "default": "Continue",
                "cancel_or_assign_procurement": "Assign/Cancel",
                "cancel_or_assign_invoice": "Assign/Cancel",
                "clearing_or_assign": "Assign/Clearing"
            },
            "assignment_tooltip": "Clearing or Assignment",
            "restart_approval_tooltip": "Restart timeline",
            "restart_or_clearing_tooltip": "Restart timeline or assign for clearing",
            "restart_approval_error": "The approval process could not be restarted.",
            "assignment_dialog": {
                "title_procurement_assign_or_cancel": "Assignment or Cancellation",
                "title_invoice_assign_or_cancel": "Assignment or Cancellation",
                "title_assign": "Assignment",
                "title_clearing_or_assign": "Clearing or Assignment",
                "assign_title": "Assign Current Task to Another Person",
                "assign_msg": "The currently assigned person is not available or not responsible for this task, so another person should take over this task.",
                "clearing_title": "Assign for clearing",
                "clearing_msg": "The currently assigned person is available and responsible for this task, but the process cannot be continued for other reasons. Therefore, you want to initiate a clearing process.",
                "cancel_procurement_title": "Cancellation",
                "cancel_procurement_msg": "The order is irrevocably cancelled and cannot be processed further. Cancelled orders can be found in the overview under the status 'Declined'.",
                "cancel_invoice_title": "Canceling",
                "cancel_invoice_msg": "The invoice is irrevocably cleared and cannot be processed further. Cleared invoices can be found in the overview of all documents under the status 'Cleared'.",
                "assign_to": "Assign to",
                "reason": "Reason",
                "declined_invoice_alert_title": "Declined invoice cannot be reopened",
                "declined_invoice_alert_message": "This invoice has already been declined. It may only be sent to clearing to adjust data if needed. After that it must not be reopened and has to be submitted again.",
                "clearing_footer_info": "The current task is cancelled. The selected person is getting a new task for clearing.",
                "reassignment_footer_info": "Only the assigned person of the current task is changed.",
                "restart_approval_title": "Restart approval process",
                "restart_approval_dialog_title": "Restart timeline",
                "restart_or_clearing_dialog_title": "Restart timeline or assign for clearing",
                "restart_approval_msg": "The invoice is reset to manual check and goes through a new approval round. The previous timeline history remains intact.",
                "restart_approval_footer_info": "The invoice is reset to manual check. The previous timeline history remains intact.",
                "cancel_invoice_btn": "Cancel Invoice",
                "cancel_procurement_btn": "Cancel Order",
                "assign_btn": "Assign",
                "restart_approval_btn": "Restart",
                "prevent_approve_group_msg": "Please assign this step to a person before approving.",
                "clearing_dialog": {
                    "title": "Clearing Person",
                    "procurement_message": "The person in the 'clearing' step results from various defaults of responsible persons per department, company, a global role default and the person who created the order. The person who is at the top of the list is preassigned for the task.",
                    "invoice_message": "The person in the 'clearing' step results from various defaults of responsible persons per department, company, a global role default and the person who uploaded the invoice. The person who is at the top of the list is preassigned for the task.",
                    "department_form": "Department in form",
                    "department_creator": "Department of the ordered-by person",
                    "client_form": "Company in form",
                    "client_creator": "Company of the ordered-by person",
                    "no_selection": "not yet selected",
                    "no_action": "not applicable"
                },
                "cancellation_dialog": {
                    "title_procurement": "Cancellation",
                    "btn_procurement": "Cancel Order",
                    "message_procurement": "Do you really want to cancel this order?",
                    "title_invoice": "Canceling",
                    "btn_invoice": "Cancel Invoice",
                    "message_invoice": "Do you really want to cancel this invoice?"
                }
            }
        },
        "tour": {
            "overview": {
                "search_box": "With the search, you can filter the purchase orders under \"My tasks\" and \"All documents\" and search for various information to find specific purchase orders faster.",
                "tab_tasks": "Here you can see the purchase orders for which you are currently responsible. In the right column, you can see the status of your tasks.",
                "tab_all_procurements": "In this tree structure, you can find all purchase orders, sorted by current status.",
                "refresh_btn": "Here you can refresh the overview of the purchase orders.",
                "type_filter": "Here you can filter by the type of task."
            },
            "procurement": {
                "form_title": "Form of the purchase order",
                "form": "Here you can see information about the purchase order.",
                "approve_btn_title": "Forward the purchase order",
                "approve_btn": "When you have completed a task and want to forward the purchase order to the next person responsible or the next step, press the blue tick.",
                "reassign_btn": "If you do not want to complete the task, because, for example, there are still uncertainties or another person should continue to process the task, you can press the red button. You can then either hand over the task or assign it to someone for clearing. During the clearing process, purchase orders can also be cancelled.",
                "add_comment": "You can add a comment to the purchase order via the comment field. This is then displayed in the timeline.",
                "timeline_title": "Timeline",
                "timeline": "The timeline shows the past and future course of the purchase order as well as the current status (blue) and comments on the purchase order. The sort order can be reversed using the gear icon.",
                "timeline_preferences": "Via this button, display settings can be made on the timeline. For example, it can be set whether the events should be sorted in ascending or descending order and whether changes to the purchase order should be hidden or displayed."
            },
            "invoice": {
                "form_title": "Invoice Form",
                "form": "Here you can enter or edit the information for the invoice.",
                "add_line": "Here you can add an invoice line item.",
                "edit_lines": "Here you can adjust information about the invoice line items.",
                "approve_btn_title": "Forward the invoice",
                "approve_btn": "Once you have completed a task and want to forward the invoice to the next person in charge or the next step, then you can press the blue tick.",
                "reassign_btn": "If you don't want to finish the task, for example because there is an issue to be solved or if another person should continue working on the task, you can press the red button. Then you can either assign the task to someone else or assign it to someone for clearing. During the clearing process, invoices can also be adjusted.",
                "add_comment": "You can add a comment to the invoice via the comment field. This will then be displayed in the timeline.",
                "timeline_title": "Timeline",
                "timeline": "The timeline shows the past and future course of the invoice as well as the current status (blue) and comments on the invoice. The sort order can be reversed using the gear icon.",
                "timeline_preferences": "Via this button, display settings can be made on the timeline. Here it can be set whether the events should be sorted in ascending or descending order and whether edits to the invoice should be hidden or displayed."
            },
            "welcome": {
                "logo_title": "Welcome to liftbase!",
                "logo": "<p>To make it easier for you to start, we will explain the most important things with a tour through liftbase.</p> <p>Use the buttons below or your arrow keys to navigate through the tour.</p>",
                "menu": "In the upper right corner is the main menu, through which you can find all important areas of liftbase.",
                "menu_help": "You can finish the individual sections of the tour at any time and restart them at a later time in the help menu.",
                "menu_admin": "Here you can find the next section of the tour."
            }
        }
    },
    "liquidity_planning": {
        "subtitle": "Review current cash flow by company, plan the coming weeks and compare alternative scenarios.",
        "horizon_hint": "Default view: current calendar week, 12 following weeks and then 6 monthly blocks. Manual entries are always maintained on calendar-week level.",
        "scenario_placeholder": "Select scenario",
        "scenario": "Scenario",
        "start_date": "Start date",
        "start_date_required": "Please enter a start date.",
        "start_date_min_today": "The start date must be today or later.",
        "active_filters": "Active filters",
        "default_scenario_name": "Main scenario",
        "no_scenarios_found": "No scenarios found.",
        "opening_balance": "Opening balance",
        "ending_balance": "Ending balance",
        "inflow": "Cash inflow",
        "outflow": "Cash outflow",
        "total_in_period": "Total in the visible horizon",
        "last_visible_period": "Balance at the end of the last visible period",
        "empty_client_description": "Select a company first to load liquidity planning.",
        "empty_scenario_description": "There is no scenario for this company yet. Create the first one now.",
        "table_row_label": "Position",
        "manual_row_label": "Row label",
        "manual_row_label_required": "Please enter a row label.",
        "add_manual_row": "Add manual row",
        "add_manual_row_individual": "Enter individually",
        "add_manual_row_spreadsheet": "Spreadsheet (Excel)",
        "manual_spreadsheet_hint": "The first row is shown in the plan. The entire spreadsheet is saved.",
        "manual_spreadsheet_unavailable": "The spreadsheet is unavailable. Please close and reopen the editor.",
        "manual_spreadsheet_values_required": "Please enter at least one value or formula in the first row.",
        "manual_edit": "Edit manually",
        "manual_entries": "Manual entries",
        "manual_entries_hint": "Maintain label and amount per calendar week here. Monthly view aggregates those weekly rows automatically.",
        "manual_week": "Calendar week",
        "manual_entry_label": "Label",
        "manual_entry_amount": "Amount",
        "manual_entries_count": "{count} manual entries",
        "documents_count": "{count} records",
        "pending": "Pending",
        "open_outgoing_invoices": "Open outgoing invoices",
        "open_incoming_invoices": "Open incoming invoices",
        "open_procurements": "Open procurements",
        "view_records": "Show records",
        "records_number": "Number",
        "records_name": "Name",
        "records_date": "Date",
        "records_amount": "Amount",
        "unassigned_cost_type": "Without cost type",
        "unassigned_revenue_type": "Without revenue type",
        "select_cost_type": "Select cost type",
        "select_revenue_type": "Select revenue type",
        "manual_row_type_save_error": "The manual row could not be linked to the selected cost or revenue type. Please apply Hasura metadata (metadata apply) and save again.",
        "balance_source_statement": "Anchored by bank statement until {date}",
        "balance_source_manual": "Only manual scenario adjustment is active",
        "balance_source_none": "No historical bank balance available",
        "load_error": "Liquidity planning could not be loaded.",
        "save_error": "The scenario could not be saved.",
        "create_scenario": "Create scenario",
        "copy_scenario": "Copy scenario",
        "delete_scenario": "Delete scenario",
        "delete_scenario_confirm": "Do you really want to delete this scenario? This step is irreversible.",
        "create_scenario_prompt": "Enter the name for the new scenario.",
        "edit_scenario_prompt": "Enter the new name for this scenario.",
        "copy_scenario_prompt": "Enter the name for the copied scenario.",
        "copy_suffix": "Copy",
        "name_required": "Please enter a name.",
        "delete_manual_row_confirm": "Do you really want to delete this manual row?",
        "table_width": "Column width",
        "show_chart": "Show chart",
        "view_standard": "Standard (13 weeks + 6 months)",
        "view_all_weeks": "All weeks",
        "view_all_months": "All months",
        "add_manual_row_inflow": "Manual inflow row",
        "add_manual_row_outflow": "Manual outflow row",
        "discard_unsaved_title": "Unsaved changes",
        "discard_unsaved_confirm": "You have unsaved changes. If you switch views, your edits will be lost. Do you want to continue?",
        "discard_unsaved_confirm_button": "Discard changes"
    },
    "operator_area": {
        "title": "Operator",
        "tenant_menu": "Tenants",
        "feature_billing_menu": "Feature Monetization",
        "feature_usage_menu": "Feature Usage",
        "mcp_usage_menu": "MCP Usage",
        "invoice_recognition_menu": "Invoice Recognition",
        "ai_llm_menu": "AI/LLM Monitor",
        "holiday_settings_menu": "Holidays",
        "einvoice_acceptance_menu": "E-invoice acceptance rules",
        "bank_statement_fixtures_menu": "Bank Statement Fixtures",
        "procurement_menu": "Purchase Orders",
        "invoice_menu": "Invoices",
        "invoice_export_log_menu": "Export Log",
        "no_permission": "You are not authorized to see this area.",
        "invoice_export_log": {
            "title": "Export Log",
            "filters": {
                "tenant": "Filter tenant",
                "invoice_id": "Invoice ID",
                "export_group": "Export group",
                "module": "Module",
                "source": "Source",
                "include_exported": "Included exported",
                "clear": "Reset filters"
            },
            "sources": {
                "bulk": "Bulk selection",
                "individual": "Individual export"
            },
            "statuses": {
                "success": "Success",
                "partial": "Partial",
                "failed": "Failed",
                "empty": "No export"
            },
            "columns": {
                "id": "ID",
                "status": "Status",
                "created_at": "Created at",
                "tenant": "Tenant",
                "module": "Module",
                "source": "Source",
                "include_exported": "Included exported",
                "requested_by": "Requested by",
                "export_group": "Export group",
                "requested": "Requested",
                "exported": "Exported",
                "skipped": "Skipped",
                "failed": "Failed",
                "requested_invoice_ids": "Requested invoices",
                "actually_exported_invoice_ids": "Actually exported invoices",
                "skipped_already_exported_invoice_ids": "Skipped already exported",
                "failed_invoice_ids": "Failed invoices",
                "error_details": "Registered error"
            },
            "copy_success": "Export log copied.",
            "copy_failed": "The export log could not be copied.",
            "errors": {
                "load_failed": "The export log could not be loaded."
            }
        },
        "holiday_settings": {
            "title": "Holiday calendar",
            "subtitle": "Maintain holidays by country and state/region. Leave the state list empty to make a holiday apply nationwide.",
            "add": "Add holiday",
            "create_title": "Create holiday",
            "edit_title": "Edit holiday",
            "year_filter": "Filter by year",
            "state_filter": "Filter by state",
            "country_filter": "Filter by country",
            "regions_placeholder": "Select or enter states/regions",
            "nationwide": "Nationwide",
            "empty_regions_hint": "If no state/region is stored, the holiday applies to the entire country.",
            "delete_confirm": "Do you really want to delete this holiday?"
        },
        "einvoice_acceptance": {
            "title": "E-invoice acceptance rules",
            "subtitle": "Configure AI exception instructions and rule-based criticality for local e-invoice validation.",
            "add": "Add rule",
            "create_title": "Create acceptance rule",
            "edit_title": "Edit acceptance rule",
            "error_code": "Rule / error code",
            "error_code_placeholder": "Search a rule, e.g. BR-CL-23 or unit code",
            "error_code_description": "Short description",
            "instruction": "Instruction for the AI",
            "instruction_placeholder": "Rule: BR-CL-23\nFinding: Non-standard unit code\nDecision: ACCEPT if quantity, service, totals and tax calculation are still unambiguous\nJustification: The deviation concerns the technical unit code and does not automatically make the invoice unusable.",
            "enabled": "Enabled",
            "delete_confirm": "Do you really want to delete this acceptance rule?",
            "with_ai": "With AI",
            "without_ai": "Without AI",
            "edit_lists": "Edit rule lists",
            "edit_lists_title": "Edit non-AI rule lists",
            "edit_lists_hint": "Move each local validation rule to the appropriate list. Changes are applied only after saving.",
            "manual_rule": "Manual rule",
            "manual_rule_placeholder": "Enter any rule or error code",
            "add_manual_rule": "Add rule",
            "critical": "Critical",
            "critical_hint": "A finding in this list keeps the e-invoice blocked.",
            "non_critical": "Non-critical",
            "non_critical_hint": "An e-invoice with only findings from this list can pass local validation.",
            "comment": "Comment",
            "comment_placeholder": "Optional comment for this rule",
            "edit_comment_title": "Edit rule comment",
            "no_comment": "No comment"
        },
        "bank_statement_fixtures": {
            "title": "Bank Statement Fixtures",
            "subtitle": "Download automatically generated bank statement test files based on open invoices in the current tenant.",
            "access_notice": "Operator only. The ZIP file contains tenant-specific test cases including manifest.json.",
            "format_label": "Output format",
            "format_placeholder": "Select a bank statement format",
            "format_hint": "Choose one target format. All downloaded variants will be generated in that format.",
            "format_required": "Select a bank statement format first.",
            "client_hint": "Choose the company whose open invoices should be used to generate the bank statement fixtures.",
            "client_required": "Select a company first.",
            "client_placeholder": "Select a company with open invoices",
            "load_clients_error": "The available companies could not be loaded.",
            "setup_title": "Setup",
            "setup_hint": "Select the target format and company before downloading one or more fixture scenarios.",
            "selection_ready": "Ready to generate fixtures",
            "selection_incomplete": "Complete the selection to enable downloads",
            "selection_hint": "The selected company is used to pick open invoices and embed realistic master data into each variant.",
            "selection_format": "Format",
            "selection_company": "Company",
            "variants_title": "Available scenarios",
            "variants_hint": "Choose a focused scenario below, or download the complete ZIP once the setup is ready.",
            "technical_details": "Technical preview",
            "missing_value": "Not selected",
            "download_all": "Download all variants",
            "download_variant": "Download variant",
            "download_ready": "The download has started.",
            "download_error": "The test fixtures could not be downloaded.",
            "endpoint_label": "Endpoint",
            "auto_match_title": "Auto-Match",
            "auto_match_description": "Downloads focused test cases where bookings should be matched automatically with open invoices.",
            "mixed_title": "Mixed Scenario",
            "mixed_description": "Contains one automatic match, one unmatched debit entry and one ignored credit entry.",
            "random_title": "Random Multi-Match",
            "random_description": "Contains multiple realistic bookings with several matches, additional unmatched entries and one ignored credit entry.",
            "counterparty_distinction_title": "Counterparty vs. Account Holder",
            "counterparty_distinction_description": "Generates a focused CAMT scenario where the extracted counterparty and account holder are intentionally different so both columns can be validated separately.",
            "supplier_iban_mismatch_title": "Supplier IBAN Mismatch",
            "supplier_iban_mismatch_description": "Downloads a focused test case where the supplier is recognized but the IBAN in the bank statement differs from supplier master data."
        },
        "tenant": {
            "description": "Tenant",
            "new": "New tenant",
            "edit": "Edit",
            "archive": "Archive",
            "delete": "Delete",
            "activate": "Restore",
            "procurement_count": "PO",
            "user_count": "User",
            "automatic_billing": "Automatic Billing",
            "automatic_billing_via": "Yes (via {id})",
            "automatic_billing_missing_easybill_id": "Yes (no ID linked)",
            "storage_usage": "Storage",
            "tabs": {
                "general": "General",
                "invoice_config": "Billing",
                "ai": "AI"
            },
            "standard_package": "Standard package",
            "invoice": {
                "items": {
                    "label": "Additional Items",
                    "description": "Description",
                    "price": "Net Amount",
                    "start_date": "Start Date",
                    "end_date": "End Date"
                },
                "tiered_price": {
                    "label": "Tiered prices",
                    "unit_price": "Unit price",
                    "base_price": "Base price",
                    "doc_amount": "Quantity"
                }
            },
            "contact_email_tooltip": "The tenant can initially log in with this email.",
            "no_bank_info": "The data is not yet available and can only be created by the tenant.",
            "no_connection_with_easybill": "This tenant is not yet connected with Easybill. Please register the tenant ID in the Easybill system.",
            "sync_with_easybill": "Retrieve all data from Easybill",
            "update_from_easybill_btn": "Retrieve from Easybill",
            "update_from_easybill_tooltip": "Retrieve tenant from Easybill",
            "send_to_easybill_btn": "Create in Easybill",
            "send_to_easybill_tooltip": "Create tenant in Easybill",
            "link_existing_easybill_btn": "Link to existing Easybill ID",
            "link_existing_easybill_tooltip": "Manually set an existing Easybill customer ID",
            "link_easybill_replace_title": "Replace Easybill ID?",
            "link_easybill_replace_message": "This tenant is already linked to Easybill ID {current}. Do you want to change the link to {next}?",
            "link_easybill_title": "Link Easybill ID",
            "link_easybill_prompt": "Please enter the existing Easybill customer ID.",
            "link_easybill_invalid": "Please enter a numeric ID.",
            "create_and_send_invoice_tooltip": "Create invoice in Easybill and send to customer",
            "create_and_send_invoice_btn": "Create/send invoice",
            "open_invoices": "View invoices",
            "delete_procurements": "Delete Purchase Order",
            "delete_invoices": "Delete Invoices",
            "confirm_before_delete_msg": "<p>Are you sure you want to permanently delete this tenant and all its data from the database?</p><p> <i>This action cannot be undone.</i></p><p><b>Enter the name of the tenant:</b></p>",
            "confirm_before_delete_error_msg": "The tenant was not deleted because the name was entered incorrectly.",
            "deleted_msg": "The tenant has been permanently deleted.",
            "updated_msg": "It has been updated.",
            "created_msg": "It has been created.",
            "sync_msg_error": "This tenant is not yet connected with Easybill. Please register the tenant ID in the Easybill system.",
            "create_invoice_dialog": {
                "title": "Create Billing",
                "message": "Choose the billing period.",
                "date_placeholder": "Select a month.",
                "create_btn": "Create"
            },
            "validation": {
                "name_required": "Please enter a name.",
                "name_exists": "The name already exists.",
                "email_required": "Please enter a contact email.",
                "email_invalid": "Please enter a valid email."
            },
            "ai": {
                "enabled": "Enable AI features",
                "model_name": "AI model name",
                "max_tokens": "Maximum tokens per request (per 1k tokens)",
                "price_input_tokens": "Price per 1k input tokens (cents)",
                "price_output_tokens": "Price per 1k output tokens (cents)"
            }
        },
        "procurement": {
            "title": "Purchase orders from Tenant",
            "delete_title": "Delete purchase order",
            "result_found": "Hits",
            "delete_result_found": "Delete hits",
            "start_date": "Start date",
            "end_date": "End date",
            "range_separator": "to",
            "confirm_delete_msg": "Are you sure you want to permanently delete the selected purchase orders from the database?",
            "confirm_delete_title": "Delete purchase order",
            "confirm_delete_btn": "Delete"
        },
        "invoice": {
            "title": "Invoices from Tenant",
            "delete_title": "Delete invoices",
            "result_found": "Hits",
            "delete_result_found": "Delete hits",
            "start_date": "Start date",
            "end_date": "End date",
            "range_separator": "to",
            "confirm_delete_msg": "Are you sure you want to permanently delete the selected invoices from the database?",
            "confirm_delete_title": "Delete invoice",
            "confirm_delete_btn": "Delete"
        },
        "feature_usage": {
            "title": "Feature usage by tenant",
            "empty_state": "No tracked feature usage was found for the selected period.",
            "not_available": "n/a",
            "unknown_tenant": "Unknown tenant",
            "filters": {
                "tenant_placeholder": "Filter by tenant"
            },
            "units": {
                "ms": "ms",
                "seconds": "s"
            },
            "summary": {
                "total_usage": "Tracked usage",
                "active_tenants": "Active tenants",
                "used_features": "Used features",
                "avg_usage_per_tenant": "Avg. usage per tenant",
                "top_feature": "Top feature",
                "of_active_base": "of active base",
                "top_feature_hint": "{usage} tracked uses across {tenants} tenants"
            },
            "charts": {
                "top_features": "Top features",
                "top_features_subtitle": "Most demanded features in the selected period.",
                "daily_trend": "Daily trend",
                "daily_trend_subtitle": "Tracked usage volume per day.",
                "procurement_sources": "Procurement sourcing",
                "procurement_sources_subtitle": "How products enter procurement lines in the selected period.",
                "punchout_providers": "Punchout providers",
                "punchout_providers_subtitle": "Marketplace usage by imported Punchout products.",
                "daily_usage_label": "Usage"
            },
            "procurement_sources": {
                "punchout": "Punchout",
                "catalog": "Product catalog",
                "on_the_fly": "On-the-fly",
                "unknown_punchout": "Unknown punchout"
            },
            "errors": {
                "schema_missing": "Feature usage tracking is not available in this environment yet. Apply the Hasura migration and metadata for tenant_feature_usage and reload the page.",
                "load_failed": "Feature usage could not be loaded."
            },
            "tables": {
                "features": "Feature ranking",
                "features_subtitle": "Demand by feature across the active tenant base.",
                "tenants": "Tenant ranking",
                "tenants_subtitle": "Most active tenants and their dominant features.",
                "modules": "Module overview",
                "modules_subtitle": "Consolidated demand by catalog module."
            },
            "columns": {
                "feature": "Feature",
                "module": "Module",
                "total_usage": "Usage",
                "active_tenants": "Tenants",
                "avg_per_tenant": "Avg./tenant",
                "event_breakdown": "Events",
                "top_tenant": "Top tenant",
                "last_used": "Last usage",
                "tenant": "Tenant",
                "used_features": "Features",
                "top_feature": "Top feature"
            }
        },
        "mcp_usage": {
            "title": "MCP usage",
            "empty_state": "No MCP usage was found for the selected period.",
            "no_errors": "No MCP errors were found for the selected period.",
            "not_available": "n/a",
            "units": {
                "ms": "ms",
                "seconds": "s"
            },
            "unknown_tenant": "Unknown tenant",
            "filters": {
                "tenant_placeholder": "Filter by tenant"
            },
            "summary": {
                "total_calls": "MCP calls",
                "active_tenants": "Active tenants",
                "active_users": "Active users",
                "success_rate": "Success rate",
                "error_calls_suffix": "calls with errors",
                "quality_score": "Quality score",
                "quality_score_hint": "Inferred from tool outcomes, warnings and result quality.",
                "answer_completion": "Inferred completion",
                "empty_results_suffix": "empty results",
                "avg_duration": "Avg. duration",
                "paginated_calls": "Paginated calls",
                "quality_signals_suffix": "quality signals",
                "session_feedback": "Session feedback",
                "session_feedback_hint": "Anonymized product insights from MCP conversations."
            },
            "charts": {
                "daily_trend": "Daily trend",
                "daily_trend_subtitle": "MCP calls per day in the selected period.",
                "top_tools": "Top tools",
                "top_tools_subtitle": "Most used MCP tools.",
                "outcomes": "Outcomes",
                "outcomes_subtitle": "Successful, blocked and failed calls.",
                "answer_quality": "Answer quality",
                "answer_quality_subtitle": "Inferred completeness of responses without storing prompts or answers.",
                "entities": "Entities",
                "entities_subtitle": "Business objects touched through MCP.",
                "calls_label": "Calls"
            },
            "tables": {
                "tools": "Tool ranking",
                "tools_subtitle": "Usage, success rate and average duration by tool.",
                "tenants": "Tenant ranking",
                "tenants_subtitle": "Tenants with the highest MCP activity.",
                "quality": "Quality focus",
                "quality_subtitle": "Tools with empty results, warnings, ignored filters or low inferred quality.",
                "answer_reasons": "Answer reasons",
                "answer_reasons_subtitle": "Why answers were complete, partial, blocked or unknown.",
                "errors": "Error focus",
                "errors_subtitle": "Sanitized error categories without prompts or payloads.",
                "session_feedback": "Session feedback",
                "session_feedback_subtitle": "Short anonymized AI notes about routing issues, gaps and suspected bugs."
            },
            "columns": {
                "tool": "Tool",
                "category": "Category",
                "answer_outcome": "Answer",
                "reason": "Reason",
                "calls": "Calls",
                "success_rate": "Success",
                "quality_score": "Quality",
                "empty_results": "Empty",
                "warnings": "Warnings",
                "ignored_filters": "Ignored filters",
                "avg_duration": "Avg. duration",
                "tenant": "Tenant",
                "users": "Users",
                "top_tool": "Top tool",
                "last_used": "Last usage",
                "error": "Error",
                "when": "When",
                "feedback_category": "Category",
                "severity": "Severity",
                "summary": "Notes",
                "related_tools": "Tools",
                "related_entities": "Entities"
            },
            "outcomes": {
                "success": "Success",
                "error": "Error",
                "permission_denied": "Permission denied",
                "rate_limited": "Rate limited",
                "validation_error": "Validation error",
                "timeout": "Timeout",
                "authentication_error": "Authentication error",
                "unknown": "Unknown"
            },
            "answer_outcomes": {
                "complete": "Complete",
                "partial": "Partial",
                "blocked": "Blocked",
                "empty_result": "Empty result",
                "low_confidence": "Low confidence",
                "unknown": "Unknown"
            },
            "feedback_reasons": {
                "success": "Successful",
                "no_data": "No data",
                "authentication_error": "Authentication",
                "permission_denied": "Permission denied",
                "rate_limited": "Rate limited",
                "timeout": "Timeout",
                "validation_error": "Validation error",
                "ambiguous_master_data": "Ambiguous master data",
                "paginated_result": "Paginated results",
                "tool_error": "Tool error",
                "low_confidence": "Low confidence",
                "not_supported": "Not supported",
                "filters_ignored": "Ignored filters",
                "warnings": "Warnings",
                "unknown": "Not specified"
            },
            "entities": {
                "none": "General",
                "bcase": "Workflow",
                "invoice": "Incoming invoices",
                "outgoing_invoice": "Outgoing invoices",
                "procurement": "Purchase orders",
                "contract": "Contracts",
                "bank_statement_entry": "Bank statement entries"
            },
            "no_session_feedback": "No session feedback was found for the selected period.",
            "session_feedback_categories": {
                "bug_suspicion": "Bug suspicion",
                "missing_capability": "Missing capability",
                "wrong_routing": "Wrong routing",
                "data_quality": "Data quality",
                "ux_friction": "UX friction",
                "feature_request": "Feature request",
                "positive_signal": "Positive signal",
                "unknown": "Unknown"
            },
            "session_feedback_severities": {
                "low": "Low",
                "medium": "Medium",
                "high": "High",
                "unknown": "Unknown"
            },
            "no_quality_issues": "No MCP quality signals were found for the selected period.",
            "errors": {
                "schema_missing": "MCP usage analytics is not available in this environment yet. Apply the Hasura migration and metadata for mcp_usage_event and reload the page.",
                "load_failed": "MCP usage could not be loaded."
            }
        },
        "ai_llm": {
            "title": "AI/LLM Monitor",
            "empty_state": "No LLM calls available for the selected period.",
            "no_errors": "No LLM failures in the selected period.",
            "unknown_tenant": "Unknown tenant",
            "unknown_region": "Unknown Azure endpoint",
            "unknown_operation": "Unknown operation",
            "unknown_model": "Unknown model",
            "filters": {
                "tenant_placeholder": "Filter by tenant",
                "operation_placeholder": "Filter by operation",
                "model_placeholder": "Filter by model",
                "status_placeholder": "Filter by status"
            },
            "shortcuts": {
                "this_month": "This month",
                "last_month": "Last month",
                "last_7_days": "Last 7 days",
                "last_30_days": "Last 30 days"
            },
            "summary": {
                "total_calls": "LLM calls",
                "total_calls_hint": "Central Azure OpenAI calls recorded by the backend.",
                "success_rate": "Success rate",
                "succeeded_suffix": "successful calls",
                "fallbacks": "Fallbacks used",
                "fallbacks_hint": "Successful calls that reached a secondary region.",
                "failures": "Failures",
                "rejected_suffix": "non-regional rejections",
                "system_status": "System status",
                "tokens": "Tokens",
                "tokens_hint": "{input} input / {output} output",
                "estimated_cost": "Estimated cost",
                "estimated_cost_hint": "Shown when token price configuration is available."
            },
            "health_states": {
                "unknown": "No data",
                "unknown_hint": "No calls were recorded for the selected filters.",
                "normal": "Normal",
                "normal_hint": "LLM calls are succeeding within the selected period.",
                "degraded": "Degraded",
                "degraded_hint": "Failures or fallback usage need attention.",
                "unavailable": "Unavailable",
                "unavailable_hint": "No successful LLM calls were recorded."
            },
            "alerts": {
                "unavailable_title": "LLM appears unavailable",
                "unavailable_description": "All recorded calls failed or were blocked for the selected period.",
                "failure_rate_high_title": "High LLM failure rate",
                "failure_rate_high_description": "The selected scope has a failure rate of {rate}.",
                "failure_rate_warning_title": "Elevated LLM failure rate",
                "failure_rate_warning_description": "The selected scope has a failure rate of {rate}.",
                "fallbacks_title": "Fallbacks were used",
                "fallbacks_description": "{count} successful call(s) required a secondary Azure endpoint."
            },
            "healthcheck": {
                "action": "Run healthcheck",
                "title": "Manual healthcheck",
                "subtitle": "Live Azure OpenAI endpoint test triggered by an operator.",
                "success": "At least one Azure endpoint responded successfully.",
                "warning": "No Azure endpoint responded successfully.",
                "error": "The LLM healthcheck could not be completed.",
                "no_endpoints_title": "No Azure endpoints were tested",
                "no_endpoints_description": "Check that endpoint, api-key and deployment are configured for Azure OpenAI.",
                "all_ok_title": "All Azure endpoints are reachable",
                "all_ok_description": "{count} Azure endpoint(s) responded successfully.",
                "partial_title": "Some Azure endpoints are reachable",
                "partial_description": "{succeeded} of {total} Azure endpoint(s) responded successfully. Check the per-endpoint error details.",
                "none_ok_title": "No Azure endpoint responded successfully",
                "none_ok_description": "The endpoint can be correct while the API key, deployment name or permissions do not match at least one Azure OpenAI resource."
            },
            "charts": {
                "region_health": "Azure endpoint health",
                "region_health_subtitle": "Successful and failed Azure OpenAI calls by endpoint and operation.",
                "daily_failures": "Failures over time",
                "daily_failures_subtitle": "Failed, rejected and circuit-open calls per day.",
                "failures_label": "Failures"
            },
            "tables": {
                "regions": "Azure endpoints and operations",
                "regions_subtitle": "Aggregated health by Azure OpenAI endpoint, operation and model.",
                "latest_errors": "Latest errors",
                "latest_errors_subtitle": "Recent failed or rejected LLM calls for operational triage."
            },
            "columns": {
                "created_at": "Time",
                "tenant": "Tenant",
                "region": "Region",
                "azure_endpoint": "Azure endpoint",
                "operation": "Operation",
                "model": "Model",
                "calls": "Calls",
                "successes": "Successes",
                "failures": "Failures",
                "failure_rate": "Failure rate",
                "avg_duration": "Avg. duration",
                "status": "Status",
                "http_status": "HTTP",
                "retries": "Retries",
                "duration": "Duration",
                "error": "Error"
            },
            "statuses": {
                "succeeded": "Succeeded",
                "failed": "Failed",
                "rejected": "Rejected",
                "circuit_open": "Region blocked"
            },
            "units": {
                "milliseconds": "{value} ms",
                "seconds": "{value} s"
            },
            "errors": {
                "schema_missing": "LLM call logging is not available in this environment yet. Apply the Hasura migration and metadata for ai_llm_call_log and reload the page.",
                "load_failed": "LLM dashboard data could not be loaded."
            }
        },
        "invoice_recognition": {
            "title": "Invoice Recognition – Monitor",
            "empty_state": "No data available for the selected period.",
            "no_switchovers": "No region switchovers were required in the selected period.",
            "no_in_flight": "No recognitions are currently in the queue.",
            "unknown_tenant": "Unknown tenant",
            "processing_active": "Processing",
            "processing_idle": "Waiting",
            "copy_success": "Copied to clipboard.",
            "copy_failed": "Could not copy.",
            "filters": {
                "tenant_placeholder": "Filter by tenant"
            },
            "shortcuts": {
                "this_month": "This month",
                "last_month": "Last month",
                "last_7_days": "Last 7 days",
                "last_30_days": "Last 30 days"
            },
            "summary": {
                "invoices_processed": "Invoices processed",
                "invoices_processed_hint": "{attempts} attempts in total",
                "successful": "Recognized successfully",
                "switchovers": "Region switchovers",
                "switchovers_hint": "Invoices that needed at least one region switch (relevant for MS refund).",
                "failed": "Finally failed",
                "failed_hint": "Invoices without a successful recognition (handed over to manual review).",
                "in_flight": "Currently in flight",
                "in_flight_hint": "Invoices currently waiting in the recognition queue."
            },
            "charts": {
                "region_status": "Attempts per region",
                "region_status_subtitle": "Distribution of recognition attempts by region and status.",
                "daily_failures": "Failures over time",
                "daily_failures_subtitle": "Failed attempts per day in the selected period.",
                "failures_label": "Failures"
            },
            "tables": {
                "switchovers": "Invoices with region switchover",
                "switchovers_subtitle": "Invoices that switched at least once to another region. Expand a row to see the full attempt trail incl. provider operation IDs (evidence for MS refund cases).",
                "region_health": "Region health",
                "region_health_subtitle": "Current health of each Azure AI region in the selected period.",
                "in_flight": "In-flight recognitions",
                "in_flight_subtitle": "Invoices currently waiting in the queue for a response."
            },
            "columns": {
                "tenant": "Tenant",
                "invoice_id": "Invoice ID",
                "region_path": "Region path",
                "attempt_count": "Attempts",
                "final_status": "Final status",
                "last_attempt": "Last attempt",
                "operation_id": "Operation ID",
                "region": "Region / model",
                "total_attempts": "Attempts",
                "successes": "Successes",
                "failures": "Failures",
                "failure_rate": "Failure rate",
                "last_failure": "Last failure",
                "poll_attempts": "Polls",
                "elapsed": "Elapsed",
                "processing": "Status"
            },
            "statuses": {
                "submitted": "Submitted",
                "succeeded": "Succeeded",
                "failed": "Failed",
                "timed_out": "Timed out",
                "submission_failed": "Submission failed",
                "circuit_open": "Region blocked"
            },
            "models": {
                "document_intelligence": "Document Intelligence",
                "content_understanding": "Content Understanding",
                "azure_open_ai": "Azure OpenAI"
            },
            "errors": {
                "load_failed": "Could not load data."
            },
            "tabs": {
                "operations": "Operations",
                "quality": "Quality",
                "approval_quality": "Approval quality"
            },
            "approval_quality": {
                "scope_manual": "Manually reviewed",
                "scope_auto": "Auto-forwarded",
                "scope_all": "All decisions",
                "methodology": "By default all AI approval decisions are compared — including auto-forwarded ones. Approved = accounting, export, or completed; cancelled = declined or declined-exported. In-flight and technically unavailable decisions are excluded from quality rates.",
                "invoices_evaluated": "Invoices evaluated",
                "invoices_evaluated_hint": "{decided} decisions, including {pending} in flight and {unavailable} technically unavailable",
                "false_approval_rate": "False approval rate",
                "false_approval_rate_hint": "{falseApprovals} of {aiApprovals} proposed AI approvals were later cancelled.",
                "approval_precision": "Correct AI approvals",
                "approval_precision_hint": "Share of proposed AI approvals that remained approved in the final outcome.",
                "missed_automation_rate": "Missed automation",
                "missed_automation_rate_hint": "{missed} of {approved} finally approved invoices were not approved by the AI.",
                "agreement_rate": "Agreement",
                "agreement_rate_hint": "Share of resolved cases where the AI decision matches the final outcome.",
                "matrix_title": "AI decision versus final outcome",
                "matrix_subtitle": "Only resolved, technically evaluable decisions in the selected period.",
                "actual_approved": "Finally approved",
                "actual_cancelled": "Finally cancelled",
                "ai_approved": "AI would approve",
                "ai_rejected": "AI would not approve",
                "correct": "Correct",
                "false_approval": "False approval",
                "missed_automation": "Missed automation",
                "false_approvals_title": "False approvals in detail",
                "false_approvals_subtitle": "Up to 80 invoices the AI would have approved but that were finally cancelled.",
                "empty_state": "No false approvals were found for the selected period.",
                "load_failed": "Could not load approval quality data.",
                "number": "Invoice number",
                "score": "AI score",
                "threshold": "Threshold",
                "reasons": "Decisive signals",
                "final_status": "Final status",
                "auto_forwarded": "Automatic",
                "decided_at": "AI decision",
                "yes": "Yes",
                "no": "No"
            },
            "quality": {
                "scope_all": "All invoices",
                "scope_manual": "Manually reviewed",
                "scope_auto": "AI auto-forwarded",
                "methodology": "Comparison: snapshot after document recognition and AI validation versus the current invoice. A changed field counts as incorrect recognition.",
                "invoices_evaluated": "Invoices evaluated",
                "invoices_evaluated_hint": "{manual} manually reviewed, {auto} auto-forwarded",
                "mean_field_rate": "Arithmetic mean",
                "mean_field_rate_hint": "Average recognition rate across all fields.",
                "median_field_rate": "Median",
                "median_field_rate_hint": "Recognition rate of the middle field, less affected by outliers.",
                "mean_receipt_score": "Mean per invoice",
                "median_receipt_score_hint": "Median per invoice: {median}",
                "field_chart_title": "Recognition rate by field",
                "field_chart_subtitle": "Share of invoices where the field stayed unchanged after recognition.",
                "groups_title": "Field groups",
                "groups_subtitle": "Weighted rate per group (evaluated fields only).",
                "fields_title": "Fields in detail",
                "fields_subtitle": "Unchanged = correctly recognized. Fields empty on both sides are excluded.",
                "invoices_title": "Invoices with the lowest scores",
                "invoices_subtitle": "The 80 invoices with the weakest match in the selected period. Expand a row to see changed fields.",
                "empty_state": "No baselines for this period yet. Measurement starts with newly recognized invoices after this release.",
                "load_failed": "Could not load quality data.",
                "field": "Field",
                "group": "Group",
                "evaluated": "Evaluated",
                "matched": "Unchanged",
                "rate": "Rate",
                "number": "Invoice number",
                "receipt_score": "Invoice score",
                "fields_short": "Fields",
                "auto_forwarded": "Auto-forward",
                "auto_yes": "Yes",
                "auto_no": "No",
                "baseline_at": "Snapshot",
                "baseline": "After recognition",
                "final_value": "Current",
                "no_mismatches": "No changed fields.",
                "groups": {
                    "document": "Document data",
                    "bank": "Bank details",
                    "matching": "Matching",
                    "organization": "Organization",
                    "lines": "Line items"
                }
            }
        },
        "feature_billing": {
            "title": "Feature monetization",
            "sync": "Sync catalog",
            "new_package": "New package",
            "create_package": "Create package",
            "edit_package": "Edit package",
            "sync_success": "Feature catalog synchronized.",
            "catalog_hint": "This area monetizes existing modules, features and packages without changing the current runtime behavior of the system.",
            "overview_title": "Overview & metrics",
            "show_overview": "Show metrics",
            "hide_overview": "Hide metrics",
            "edit_feature": "Edit monetization",
            "manage_tenants": "Manage tenants",
            "assign_tenant": "Assign tenant",
            "manage_package_tenants": "Manage package tenants",
            "assign_package": "Assign package",
            "assignment_dialog_title": "Tenant feature assignment",
            "package_assignment_dialog_title": "Tenant package assignment",
            "custom_price_hint": "Leave empty to use the feature default price.",
            "not_configured": "Not configured",
            "no_assignments": "No tenant assignment found.",
            "unassigned_module": "Without module",
            "unassigned_module_description": "Features that are monetized independently from any specific module.",
            "package_features_label": "Included features",
            "package_feature_hint": "Select the features that belong to this package.",
            "package_code_placeholder": "stable-package-code",
            "package_code_hint": "Generated automatically from the package name.",
            "catalog_inactive": "Catalog inactive",
            "billing_enabled": "Monetization enabled",
            "billing_disabled": "Monetization disabled",
            "tabs": {
                "features": "Features",
                "packages": "Packages",
                "tenants": "Tenants",
                "ai_automation": "AI automation"
            },
            "summary": {
                "modules": "Modules",
                "features": "Features",
                "packages": "Packages",
                "direct_assignments": "Direct assignments",
                "package_assignments": "Package assignments",
                "active_assignments": "Active assignments",
                "trial_assignments": "Trial assignments"
            },
            "sections": {
                "package_assignments": "Package assignments",
                "direct_feature_assignments": "Direct feature assignments"
            },
            "columns": {
                "module": "Module",
                "feature": "Feature",
                "package": "Package",
                "code": "Code",
                "description": "Description",
                "catalog_status": "Catalog status",
                "billing_type": "Billing type",
                "default_price": "Default price",
                "default_demo_days": "Demo days",
                "pricing": "Pricing",
                "coverage": "Coverage",
                "composition": "Composition",
                "assignments": "Assignments",
                "direct_assignments": "Direct",
                "covered_tenants": "Covered tenants",
                "packages": "Packages",
                "included_features": "Included features",
                "references": "System reference",
                "tenant": "Tenant",
                "status": "Status",
                "effective_price": "Effective price",
                "custom_price": "Custom price",
                "demo_until": "Demo until",
                "active_features": "Active",
                "active_packages": "Packages",
                "trial_features": "Trial",
                "total_assignments": "Total"
            },
            "ai_automation": {
                "title": "AI automation by client and supplier",
                "description": "Evaluates AI-validated invoices by whether they reached export without relevant manual corrections.",
                "details_title": "Monthly evaluation",
                "empty_title": "No AI automation data yet",
                "empty_text": "After the migration is applied and AI-validated invoices have been exported, the evaluation will be filled.",
                "unknown_tenant": "Unknown tenant",
                "unknown_client": "Unknown client",
                "unknown_supplier": "Unknown supplier",
                "no_client": "No client",
                "no_supplier": "No supplier",
                "detail_title": "Invoice details",
                "actions": {
                    "details": "Details"
                },
                "summary": {
                    "total_invoices": "Invoices",
                    "ai_validated": "AI validated",
                    "one_click_export": "One-click export",
                    "best_case": "Best case",
                    "automation_value": "Automation value",
                    "manual_corrections": "Manual corrections"
                },
                "columns": {
                    "company": "Company",
                    "client_supplier": "Client / supplier",
                    "period": "Period",
                    "supplier": "Supplier",
                    "billing_tier": "Billing tier",
                    "ai_validated": "AI validated",
                    "email_imported": "Email",
                    "auto_export": "Auto export",
                    "exported": "Exported",
                    "one_click": "One-click",
                    "best_case": "Best case",
                    "manual_corrections": "Manual corrections"
                },
                "column_help": {
                    "tenant": "Tenant or customer account to which this monthly KPI row belongs.",
                    "client_supplier": "Combination of client and supplier for the invoices counted in this row.",
                    "period": "Calendar month and year covered by this evaluation row.",
                    "billing_tier": "Derived monetization tier based on the measured automation score for this row.",
                    "ai_validated": "How many invoices were AI-validated out of all invoices in the row. The note shows how many came from email import.",
                    "auto_export": "Invoices automatically forwarded toward export. The note shows how many were ultimately exported successfully.",
                    "one_click": "Invoices that reached export with a one-click confirmation after AI validation.",
                    "best_case": "Invoices with the highest automation level, typically email-imported and exported with one click and no relevant manual correction.",
                    "manual_corrections": "Invoices that still required relevant manual changes after AI processing. The note breaks down the correction types.",
                    "actions": "Opens the invoice-level detail view for the selected monthly row."
                },
                "detail_columns": {
                    "invoice": "Invoice",
                    "automation": "Automation",
                    "ki": "AI",
                    "export": "Export",
                    "corrections": "Corrections",
                    "result": "Result"
                },
                "boolean": {
                    "yes": "Yes",
                    "no": "No"
                },
                "labels": {
                    "email": "Email",
                    "validated": "Validated",
                    "auto_forwarded": "Auto export",
                    "one_click": "One-click",
                    "best_case": "Best case",
                    "not_exported": "Not exported"
                },
                "automation_levels": {
                    "unknown": "Unknown",
                    "no_ai": "No AI",
                    "ai_not_validated": "Not validated",
                    "manual_correction": "Manual correction",
                    "ki_validated_waiting": "AI validated",
                    "ki_autonomous_to_export_ready": "Prepared for export",
                    "one_click_export": "One-click export",
                    "email_import_one_click_export": "Email one-click export"
                },
                "billing_tiers": {
                    "premium": "Premium",
                    "advanced": "Advanced",
                    "automation": "Automation",
                    "assist": "Assist",
                    "base": "Base"
                },
                "billing_tier_legend": {
                    "title": "Billing tier guide",
                    "items": {
                        "base": "Little measurable automation value in this row.",
                        "assist": "AI assists the process, but manual work still dominates.",
                        "automation": "Meaningful automation gains; several invoices are export-ready with limited manual effort.",
                        "advanced": "High automation level with only occasional manual intervention.",
                        "premium": "Very high automation level; most invoices run nearly touchless."
                    }
                },
                "correction_types": {
                    "values": "Values",
                    "bank": "Bank",
                    "organization": "Organization",
                    "other": "Other",
                    "note_only": "Note only",
                    "none": "No relevant correction"
                }
            },
            "billing_types": {
                "monthly": "Monthly",
                "yearly": "Yearly",
                "one_time": "One-time",
                "usage": "Usage-based",
                "included": "Included"
            },
            "assignment_statuses": {
                "active": "Active",
                "trial": "Trial",
                "inactive": "Inactive"
            },
            "validation": {
                "package_name_required": "Please enter a package name.",
                "package_code_required": "Please enter a valid package code.",
                "package_features_required": "Please select at least one feature for the package."
            }
        }
    },
    "timeline": {
        "title": "Timeline",
        "preferences": {
            "order_asc": "Oldest first",
            "order_desc": "Newest first",
            "comment_notifications": "Email notifications for comments",
            "comment_notifications_enabled": "Comment notifications enabled.",
            "comment_notifications_disabled": "Comment notifications disabled."
        },
        "text": {
            "description_assignment": "The task has been accepted.",
            "cancellation": {
                "name": "{name}",
                "description_past_successful_invoice": "The invoice has been removed and archived.",
                "description_past_successful_outgoing-invoice": "The outgoing invoice has been canceled and archived.",
                "description_past_successful_procurement": "The purchase order has been canceled and archived.",
                "description_past_successful_contract": "The contract has been canceled and archived.",
                "name_procurement": "Cancellation",
                "name_contract": "Cancellation",
                "name_outgoing-invoice": "Cancellation",
                "name_invoice": "Removal"
            },
            "start": {
                "name": "New Purchase Order",
                "description_past_successful": "New purchase order has been created."
            },
            "select-product": {
                "is_searchable": true,
                "simple_name": "Product selection",
                "name": "Product selection (Stage {index})",
                "description_past_unsuccessful": "Product selection has been cancelled.",
                "description_past_successful": "Products for this order have been selected.",
                "description_present": "Please select products for this order.",
                "description_future": "Products for this order need to be selected."
            },
            "approval": {
                "is_searchable": true,
                "simple_name": "Approval",
                "name": "Approval (Stage {index})",
                "description_past_unsuccessful": "Approval of the order was cancelled.",
                "description_past_successful": "Purchase order has been reviewed and approved.",
                "description_present": "Please review and approve the purchase order.",
                "description_future": "Purchase order needs to be reviewed and approved."
            },
            "send-order": {
                "is_searchable": true,
                "name": "Order placement",
                "description_past_unsuccessful": "Order placement was cancelled.",
                "description_past_successful": "Order has been placed with the supplier.",
                "description_present": "Please place the order with the supplier.",
                "description_future": "Order must be placed with supplier."
            },
            "delivery": {
                "is_searchable": true,
                "name": "Delivery Confirmation",
                "description_past_unsuccessful": "Confirmation of receipt of goods has been cancelled.",
                "description_past_successful": "Goods have been delivered and receipt has been confirmed.",
                "description_present": "Please confirm the receipt of goods.",
                "description_future": "Receipt of goods must be confirmed."
            },
            "reassignment": {
                "name": "Assignment",
                "description_past_unsuccessful": "",
                "description_past_successful": "assigned the task to {name}.",
                "description_past_successful_from_group": "accepted the task."
            },
            "clearing": {
                "is_searchable": true,
                "name": "Clearing",
                "description_past_unsuccessful": "Clearing was cancelled.",
                "description_past_successful": "Uncertainties were cleared.",
                "description_present": "Please clear uncertainties concerning the order.",
                "description_finished_unsuccessful": "Order was cancelled and archived."
            },
            "order-sent-internal": {
                "name": "System message",
                "description_past_successful": "The order <b>({first_product_name})</b> with the supplier <b>{supplier}</b> has been placed and confirmed."
            },
            "order-sent-punchout": {
                "name": "System message",
                "description_past_successful": "The order <b>({first_product_name})</b> was sent electronically to the supplier <b>{supplier}</b>."
            },
            "product-received": {
                "name": "System message",
                "description_past_successful": "<b>{quantity} {unit}</b> received:<p>{product}</p><span style=\"color:#9a9898\">{supplier}</span>"
            },
            "invoice-upload": {
                "name": "New Invoice",
                "description_past_successful": "The invoice has been uploaded."
            },
            "invoice-recognition": {
                "is_searchable": true,
                "name": "Invoice Recognition",
                "description_past_unsuccessful": "Recognition of invoice data has been cancelled.",
                "description_past_successful": "Recognition of invoice data has been completed.",
                "description_present": "The invoice data is being read. This process may take up to a minute. Please refresh the page after this time to see the results."
            },
            "invoice-historical-import": {
                "name": "Historical Import",
                "description_past_successful": "The invoice has been saved as a historical invoice."
            },
            "procurement-recognition": { "name": "Order data recognized", "description_past_successful": "The order data was extracted from the historical email." },
            "procurement-counterparty-recognition": { "name": "Counterparties recognized", "description_past_successful": "The company and supplier were recognized from the order." },
            "procurement-master-data-adopted": { "name": "Master data adopted", "description_past_successful": "Recognized company, supplier and product data was adopted into master data." },
            "procurement-historical-import": { "name": "Historical import", "description_past_successful": "The order was saved as historical context and does not create an open commitment." },
            "invoice-counterparty-recognition": {
                "name": "Company and supplier recognized",
                "description_past_successful": "The company and supplier were recognized from the invoice.",
                "description_past_unsuccessful": "The company and supplier could not be identified reliably."
            },
            "invoice-master-data-adopted": {
                "name": "Master data adopted",
                "description_past_successful": "Recognized company or supplier data was adopted into master data.",
                "description_past_unsuccessful": "No reliable master data was adopted."
            },
            "invoice-manual-check": {
                "is_searchable": true,
                "name": "Manual Check",
                "description_past_unsuccessful": "The manual check has not been completed.",
                "description_past_successful": "The invoice has been manually checked.",
                "description_present": "Please check the invoice data.",
                "description_future": "The invoice must be manually checked."
            },
            "invoice-financial-approval": {
                "is_searchable": true,
                "simple_name": "Invoice Approval",
                "name": "Invoice Approval (Stage {index})",
                "description_past_unsuccessful": "Invoice approval was canceled.",
                "description_past_successful": "Invoice was reviewed and approved.",
                "description_present": "Please review and approve the invoice.",
                "description_future": "The invoice must be reviewed and approved."
            },
            "invoice-clearing": {
                "is_searchable": true,
                "name": "Accounting clearing",
                "description_past_unsuccessful": "Clearing was cancelled.",
                "description_past_successful": "Invoice uncertainties were cleared.",
                "description_present": "Please clear uncertainties concerning the invoice.",
                "description_finished_unsuccessful": "The invoice was cancelled and archived."
            },
            "invoice-export": {
                "is_searchable": true,
                "name": "Export",
                "description_past_unsuccessful": "The invoice was not exported.",
                "description_past_successful": "The invoice was submitted to {export_name}.",
                "description_present": "The invoice is ready for export.",
                "description_future": "The invoice is ready for export."
            },
            "invoice-accounting": {
                "is_searchable": true,
                "name": "Accounting",
                "description_past_unsuccessful": "Accounting was aborted.",
                "description_past_successful": "Accounting was verified.",
                "description_present": "Please check accounting.",
                "description_future": "Accounting needs to be checked."
            },
            "invoice-verified": {
                "is_searchable": true,
                "name": "Verified",
                "description_past_unsuccessful": "Verification was cancelled.",
                "description_past_successful": "The invoice was verified.",
                "description_present": "The invoice will be verified.",
                "description_future": "The invoice will be verified."
            },
            "skip": {
                "name": "Cancellation",
                "description_past_successful": "has cancelled the step."
            },
            "contract-start": {
                "name": "New contract",
                "description_past_successful": "The contract has been created."
            },
            "contract-recognition": {
                "is_searchable": true,
                "name": "Contract recognition",
                "description_past_successful": "The contract data has been recognized.",
                "description_present": "The contract data is being recognized."
            },
            "contract-check": {
                "is_searchable": true,
                "name": "Contract review",
                "description_past_unsuccessful": "The review was not completed.",
                "description_past_successful": "The contract has been reviewed.",
                "description_present": "Please review the contract data."
            },
            "contract-signing": {
                "is_searchable": true,
                "name": "Contract signing",
                "description_past_unsuccessful": "The contract has not been signed.",
                "description_past_successful": "The contract has been signed.",
                "description_present": "Please sign the contract.",
                "description_future": "The contract must be signed."
            },
            "contract-clearing": {
                "is_searchable": true,
                "name": "Contract Clearing",
                "description_past_unsuccessful": "Clearing was canceled.",
                "description_past_successful": "Contract issues have been cleared.",
                "description_present": "Please clear the contract.",
                "description_finished_unsuccessful": "The contract was canceled and archived."
            }
        }
    },
    "jexcel": {
        "noRecordsFound": "No entries found.",
        "showingPage": "Page {0} of {1}",
        "show": "Show ",
        "entries": " entries",
        "insertANewColumnBefore": "Insert column before",
        "insertANewColumnAfter": "Insert column after",
        "deleteSelectedColumns": "Delete selected columns",
        "renameThisColumn": "Rename this column",
        "orderAscending": "Sort ascending",
        "orderDescending": "Sort descending",
        "insertANewRowBefore": "Insert row before",
        "insertANewRowAfter": "Insert row after",
        "deleteSelectedRows": "Delete selected rows",
        "copy": "Copy",
        "paste": "Paste",
        "saveAs": "Save as",
        "about": "About",
        "areYouSureToDeleteTheSelectedRows": "Are you sure you want to delete the selected rows?",
        "areYouSureToDeleteTheSelectedColumns": "Are you sure you want to delete the selected columns?",
        "thisActionWillDestroyAnyExistingMergedCellsAreYouSure": "This action will destroy any existing merged cells. Are you sure?",
        "thisActionWillClearYourSearchResultsAreYouSure": "This action will clear your search results. Are you sure?",
        "thereIsAConflictWithAnotherMergedCell": "There is a conflict with another merged cell",
        "invalidMergeProperties": "Invalid merged properties",
        "cellAlreadyMerged": "Cell already merged",
        "noCellsSelected": "No cell selected",
        "save_warning": "Copying data between Excel and the web can lead to incorrect sequences and lost ID relationships. <br>Please use only the online editing or add Excel data as a supplement."
    },
    "system_comment": {
        "name": {
            "allocation": "Allocation",
            "datev_export": "DATEV export",
            "export_error": "Export error",
            "export_detail": "Export protocol",
            "repeat_recognition": "Repeat Invoice Recognition",
            "bank_data_export_summary": "Payment modality",
            "payment": "Payment via bank statement",
            "bank_statement_payment": "Payment via bank statement",
            "contract-termination-email": "Contract termination reminder",
            "ai_validation": "AI validation"
        },
        "contract_termination_email_sent": "Termination reminder email was sent to {recipient}.",
        "contract_termination_email_failed": "Termination reminder email could not be sent to {recipient}. Error: {error}.",
        "ai_validation_trusted": "The invoice was verified by AI and considered reliable.",
        "ai_validation_not_trusted": "The invoice was verified by AI and forwarded to manual check.",
        "invoice_approval_restart": "The invoice approval process was restarted. Reason: {reason}",
        "recognition_was_repeated": "{user_name} repeated the document recognition.",
        "attach_new_invoice_to_procurement": "The invoice <b>{link_to_invoice}</b> from <b>{supplier_name}</b> has been allocated to this purchase order by <b>{user_name}</b>.",
        "attach_new_invoice_to_bcase": "The invoice <b>{link_to_invoice}</b> from <b>{supplier_name}</b> was assigned to this document by <b>{user_name}</b>.",
        "change_bcase_of_invoice": "The assignment of invoice <b>{link_to_invoice}</b> from <b>{supplier_name}</b> has been removed. <br>The invoice was reassigned to document {link_to_bcase}.",
        "detach_bcase_of_invoice": "The assignment of invoice <b>{link_to_invoice}</b> from <b>{supplier_name}</b> has been removed.",
        "attach_new_invoice_to_procurement_without_supplier": "The invoice <b>{link_to_invoice}</b> has been allocated to this purchase order by <b>{user_name}</b>.",
        "change_procurement_of_invoice": "The allocation of the invoice <b>{link_to_invoice}</b> from <b>{supplier_name}</b> has been removed. <br>The invoice has been allocated to the purchase order {link_to_procurement}.",
        "change_procurement_of_invoice_without_supplier": "The allocation of the invoice <b>{link_to_invoice}</b> has been removed. <br>The invoice has been allocated to the purchase order {link_to_procurement}.",
        "detach_procurement_of_invoice": "The allocation of the invoice <b>{link_to_invoice}</b> from <b>{supplier_name}</b> has been removed.",
        "detach_procurement_of_invoice_without_supplier": "The allocation of the invoice <b>{link_to_invoice}</b> has been removed.",
        "attach_external_invoice_to_procurement": "The invoice {invoice_number} from <b>{supplier_name}</b> has been allocated to this purchase order by <b>{invoice_by}</b>.",
        "insert_datev_note": "The invoice <b>{link_to_invoice}</b> from <b>{supplier_name}</b> has been sent to DATEV.",
        "insert_datev_note_without_supplier": "The invoice <b>{link_to_invoice}</b> has been sent to DATEV.",
        "on_ms365_export_error_generic": "Error while exporting the invoice to D365. Please contact support.",
        "on_ms365_export_validation_error": "Error while exporting the invoice to D365. Please contact support. Error: {error}",
        "on_export_error": "The invoice could not be sent to DATEV. {error}",
        "on_export_error_generic": "Error while exporting the invoice to DATEV. Please contact support.",
        "on_export_error_validation": "{supplier_external_id_export_validation}{supplier_name_export_validation} Please contact someone with administration rights to check the settings.",
        "on_export_error_datev_access_is_not_active": "The connection with DATEV must be established. Please contact someone with administrator rights.",
        "on_export_error_client_has_no_datev_access": "The company {client_name} has not stored any DATEV access data. Please contact someone with administrator rights.",
        "on_export_error_client_has_no_datev_permission": "An error occurred during transmission to DATEV. The set up DATEV account does not have permission for the company {client_name}. Please contact someone with administrator rights to check the access, the company data or the permissions within DATEV.",
        "on_export_error_datev_has_protocol_entries": "Error exporting the invoice to DATEV. Please check the export log or contact support.",
        "on_export_error_no_fiscal_year": "An error occurred during transmission to DATEV. The invoice date is not within the DATEV fiscal year. Please contact someone with administrator rights to check the fiscal year in DATEV.",
        "on_export_error_invoice_not_active_for_fiscal_year": "An error occurred during transmission to DATEV. The DATEV fiscal year is not released for the transmission of incoming invoices. Please contact someone with administrator rights to check the fiscal year in DATEV.",
        "on_export_error_running": "Export blocked: Another instance is already executing this process.",
        "on_export_error_outgoing_invoice_not_supported": "Outgoing invoices cannot be exported. The workflow ends with verification.",
        "on_export_error_document_discount_tax_required": "The document discount cannot be exported because its VAT rate is missing or does not match any invoice line. Select the VAT rate of the discount.",
        "on_export_error_document_discount_exceeds_base": "The document discount is higher than the net base of the matching invoice lines and cannot be exported.",
        "on_export_error_document_discount_invalid": "The document discount cannot be exported. Check the discount amount, base, and VAT rate.",
        "insert_datev_protocol_note": "<b>Status</b>: {status} <br><br> <b>Protocol Entries</b>: <br> {protocol}",
        "labels": {
            "ai_validation_trusted_label": "The invoice was verified by AI and considered reliable.",
            "ai_validation_not_trusted_label": "The invoice was verified by AI and forwarded to manual check.",
            "ai_validation_trusted_score_only_label": "The invoice was classified as trustworthy by AI. {score_block}",
            "ai_validation_not_trusted_score_only_label": "The invoice was forwarded for manual review. {score_block}",
            "ai_validation_trusted_reasons_label": "The invoice was classified as trustworthy by AI. {score_block} Key factors were also: {ai_validation_reason_value}.",
            "ai_validation_not_trusted_reasons_label": "The invoice was forwarded for manual review. {score_block} Key factors were: {ai_validation_reason_value}.",
            "ai_validation_not_trusted_insufficient_positive_label": "The invoice was forwarded for manual review. {score_block} The positive signals were not sufficient: {ai_validation_reason_value}.",
            "ai_validation_score_block_risk_passed": "From positive and negative signals, the AI calculated an overall risk of {score} — a {score_level} risk level. For automatic approval, this risk must stay below {threshold}; this invoice is within that limit.",
            "ai_validation_score_block_risk_failed": "From positive and negative signals, the AI calculated an overall risk of {score} — a {score_level} risk level. For automatic approval, this risk must stay below {threshold}; this value is above that limit.",
            "ai_validation_score_block_confidence_passed": "From the checked signals, the AI calculated a confidence value of {score} — a {score_level} level. For automatic approval, this value must be at least {threshold}; this requirement is met.",
            "ai_validation_score_block_confidence_failed": "From the checked signals, the AI calculated a confidence value of {score} — a {score_level} level. For automatic approval, this value must be at least {threshold}; the result is not sufficient.",
            "ai_validation_score_block_green_sum_passed": "From the positive signals, the AI calculated a sum of {score} — a {score_level} level. For automatic approval, this value must be at least {threshold}; this requirement is met.",
            "ai_validation_score_block_green_sum_failed": "From the positive signals, the AI calculated a sum of {score} — a {score_level} level. For automatic approval, this value must be at least {threshold}; the result is not sufficient.",
            "ai_validation_score_level_risk_very_low": "very low",
            "ai_validation_score_level_risk_low": "low",
            "ai_validation_score_level_risk_acceptable": "acceptable",
            "ai_validation_score_level_risk_elevated": "elevated",
            "ai_validation_score_level_risk_high": "high",
            "ai_validation_score_level_confidence_very_low": "very low",
            "ai_validation_score_level_confidence_low": "low",
            "ai_validation_score_level_confidence_moderate": "moderate",
            "ai_validation_score_level_confidence_high": "high",
            "ai_validation_score_level_confidence_very_high": "very high",
            "ai_validation_score_level_green_sum_very_low": "very low",
            "ai_validation_score_level_green_sum_low": "low",
            "ai_validation_score_level_green_sum_moderate": "moderate",
            "ai_validation_score_level_green_sum_high": "high",
            "ai_validation_score_level_green_sum_very_high": "very high",
            "ai_validation_risk_compensated_label": "Detected risks ({ai_validation_secondary_reason_value}) were offset by the positive signals.",
            "ai_validation_positive_signals_label": "Positive signals ({ai_validation_secondary_reason_value}) were not enough to offset the risks.",
            "ai_validation_reason_and": "and",
            "ai_validation_reason_GREEN_01": "required fields are complete",
            "ai_validation_reason_GREEN_02": "the invoice matches this supplier's historical pattern",
            "ai_validation_reason_GREEN_03": "the sender email is known and matches master data",
            "ai_validation_reason_GREEN_04": "the amounts look plausible for the service",
            "ai_validation_reason_GREEN_05": "the service period is clear and without overlap",
            "ai_validation_reason_GREEN_06": "the bank details match the stored master data",
            "ai_validation_reason_RED_01": "the sender email differs from known addresses",
            "ai_validation_reason_RED_02": "the service period overlaps with existing invoices",
            "ai_validation_reason_RED_03": "the amount or inherent risk is unusually high",
            "ai_validation_reason_RED_04": "the amount rose sharply compared with earlier invoices",
            "ai_validation_reason_RED_05": "the purchase order/contract is missing or differs significantly",
            "ai_validation_reason_RED_06": "the bank details differ from master data",
            "ai_validation_failed": "The invoice was not validated.",
            "ai_validation_duplicate_invoice_label": "AI validation did not continue because a duplicate invoice was found. The invoice was forwarded to manual check.",
            "ai_validation_mandatory_fields_missing_label": "AI validation failed: The following mandatory fields are missing",
            "ai_validation_client_address_mismatch_label": "AI validation did not continue because the recognized billing address differs from the company master data. The invoice was forwarded to manual check.",
            "ai_validation_client_address_unrecognized_label": "AI validation did not continue because no sufficiently recognizable billing address was found on the invoice. The invoice was forwarded to manual check.",
            "magic_suggestions_label": "Magic suggestions applied",
            "magic_suggestions_intro_label": "Here are the fields that were automatically filled in based on previous documents from this supplier:",
            "ledger_account_label": "G/L Account",
            "cost_center_label": "Cost Center",
            "department_label": "Department",
            "cost_type_label": "Cost Type",
            "incoming_revenue_type_label": "Revenue type",
            "posting_key_label": "Posting Key",
            "tax_group_label": "Sales Tax Group",
            "tax_item_group_label": "Sales Tax Item Group",
            "d365_branch_label": "Branch",
            "d365_employee_label": "Employee",
            "d365_department_label": "D365 Department",
            "d365_area_label": "D365 Area",
            "d365_sales_channel_label": "D365 Sales Channel",
            "d365_vehicle_label": "Vehicle",
            "d365_project_label": "D365 Project",
            "supplier_iban_label": "IBAN",
            "supplier_bic_label": "BIC",
            "supplier_bank_country_label": "Bank Country",
            "supplier_bank_account_label": "Account Number",
            "supplier_bank_code_label": "Bank Code",
            "supplier_payment_method_label": "Payment Method",
            "invoice_number_label": "Invoice number",
            "duplicate_invoice_reference_label": "Duplicate invoice",
            "procurement_number_label": "Order number",
            "invoice_date_label": "Invoice date",
            "invoice_due_date_label": "Due date",
            "supplier_label": "Supplier",
            "client_label": "Company",
            "business_partner_label": "Business partner",
            "total_netto_label": "Total net",
            "total_brutto_label": "Total gross",
            "tax_label": "Tax rate",
            "positions_count_label": "Position(s)",
            "recognition_applied_data_label": "Applied or derived by liftbase",
            "contract_recognition_result_label": "Recognized contract data",
            "contract_name_label": "Contract name",
            "contract_number_label": "Contract number",
            "contract_external_number_label": "External contract number",
            "contract_date_label": "Contract date",
            "contract_supplier_label": "Supplier",
            "contract_client_label": "Company",
            "contract_category_label": "Category",
            "contract_payment_method_label": "Payment method",
            "contract_payment_direction_label": "Direction",
            "contract_payment_timing_label": "Payment timing",
            "contract_term_type_label": "Term type",
            "contract_start_date_label": "Contract start",
            "contract_end_date_label": "Contract end",
            "contract_duration_label": "Contract duration",
            "contract_renewal_type_label": "Renewal type",
            "contract_renewal_duration_label": "Renewal duration",
            "contract_notice_period_label": "Notice period",
            "contract_termination_to_label": "Termination date",
            "contract_total_net_label": "Total net",
            "contract_total_gross_label": "Total gross",
            "contract_currency_label": "Currency",
            "contract_positions_label": "Positions",
            "origin_field_client_id": "Company",
            "origin_field_supplier_id": "Supplier",
            "origin_field_business_partner_id": "Business partner",
            "origin_field_procurement_id": "Purchase order",
            "origin_field_ledger_account_id": "G/L account",
            "origin_field_cost_center_id": "Cost center",
            "origin_field_profit_center_id": "Profit center",
            "origin_field_department_id": "Department",
            "origin_field_posting_key_id": "Posting key",
            "origin_field_branch_id": "Branch",
            "origin_field_employee_id": "Employee",
            "origin_field_d365_area_id": "Area",
            "origin_field_d365_department_id": "D365 department",
            "origin_field_d365_labor_wert_id": "Labor value",
            "origin_field_d365_project_id": "Project",
            "origin_field_d365_sales_channel_id": "Sales channel",
            "origin_field_d365_vehicle_id": "Vehicle",
            "origin_field_number": "Invoice number",
            "origin_field_total_netto": "Total net",
            "origin_field_total_brutto": "Total gross",
            "origin_field_invoice_date": "Invoice date",
            "origin_field_due_date": "Due date",
            "origin_field_delivery_date": "Delivery date",
            "origin_field_currency": "Currency",
            "origin_field_tax": "Tax rate",
            "origin_field_contract_id": "Contract",
            "origin_field_cost_type_id": "Cost type",
            "origin_field_incoming_revenue_type_id": "Revenue type",
            "origin_field_discount_percentage": "Discount 1 %",
            "origin_field_discount_amount": "Discount 1 amount",
            "origin_field_discount_days": "Discount 1 days",
            "origin_field_discount_payment_date": "Discount 1 date",
            "origin_field_discount_percentage2": "Discount 2 %",
            "origin_field_discount_amount2": "Discount 2 amount",
            "origin_field_discount_days2": "Discount 2 days",
            "origin_field_discount_payment_date2": "Discount 2 date",
            "origin_field_lines": "Line items",
            "origin_field_recognized_client_id": "Recognized company",
            "origin_field_recognized_supplier_id": "Recognized supplier",
            "origin_field_recognized_business_partner_id": "Recognized business partner",
            "origin_field_supplier_iban": "Supplier IBAN",
            "origin_field_supplier_bic": "Supplier BIC",
            "origin_field_payment_bank_form_source": "Bank details source",
            "origin_reason_document_extracted": "extracted directly from the document",
            "origin_reason_from_procurement": "copied from the matched purchase order",
            "origin_reason_from_supplier_master_data": "copied from supplier master data",
            "origin_reason_from_business_partner_master_data": "copied from business partner master data",
            "origin_reason_invoice_number_extracted_from_document": "extracted directly from the document",
            "origin_reason_total_netto_extracted_from_document": "extracted directly from the document",
            "origin_reason_total_brutto_extracted_from_document": "extracted directly from the document",
            "origin_reason_invoice_date_extracted_from_document": "extracted directly from the document",
            "origin_reason_due_date_extracted_from_document": "extracted directly from the document",
            "origin_reason_delivery_date_extracted_from_document": "extracted directly from the document",
            "origin_reason_document_discount_amount_extracted_from_document": "extracted directly from the document",
            "origin_reason_document_discount_base_amount_extracted_from_document": "extracted directly from the document",
            "origin_reason_document_discount_percentage_extracted_from_document": "extracted directly from the document",
            "origin_reason_document_discount_tax_percentage_extracted_from_document": "extracted directly from the document",
            "origin_reason_client_matched_by_receiver_name_or_vat": "matched from recognized recipient name or VAT ID",
            "origin_reason_client_matched_by_supplier_name_or_vat": "matched from recognized issuer name or VAT ID",
            "origin_reason_client_from_creator_profile": "taken from uploader profile",
            "origin_reason_client_from_procurement": "copied from the matched purchase order",
            "origin_reason_supplier_matched_by_name_vat_or_iban": "matched from recognized supplier name, VAT ID, or IBAN",
            "origin_reason_business_partner_matched_by_name_vat_or_iban": "matched from recognized counterparty name, VAT ID, or IBAN",
            "origin_reason_business_partner_matched_by_receiver_name_or_vat": "matched from recognized recipient name or VAT ID",
            "origin_reason_supplier_from_single_procurement_supplier": "taken from the only supplier on the matched purchase order",
            "origin_reason_procurement_matched_by_recognized_reference": "matched from recognized order reference",
            "origin_reason_procurement_matched_by_invoice_similarity": "matched from amount, date, and line-item similarity",
            "origin_reason_procurement_matched_by_invoice_similarity_without_supplier": "matched from amount, date, and line-item similarity before supplier selection",
            "origin_reason_ledger_account_from_procurement": "copied from the matched purchase order",
            "origin_reason_cost_center_from_procurement": "copied from the matched purchase order",
            "origin_reason_cost_type_from_procurement": "copied from the matched purchase order",
            "origin_reason_profit_center_from_supplier_master_data": "copied from supplier master data",
            "origin_reason_profit_center_from_business_partner_master_data": "copied from business partner master data",
            "origin_reason_department_from_procurement": "copied from the matched purchase order",
            "origin_reason_branch_from_procurement": "copied from the matched purchase order",
            "origin_reason_employee_from_procurement": "copied from the matched purchase order",
            "origin_reason_financial_dimension_from_procurement": "copied from the matched purchase order",
            "origin_reason_ledger_account_from_supplier_master_data": "copied from supplier master data",
            "origin_reason_cost_center_from_supplier_master_data": "copied from supplier master data",
            "origin_reason_ledger_account_from_business_partner_master_data": "copied from business partner master data",
            "origin_reason_cost_center_from_business_partner_master_data": "copied from business partner master data",
            "origin_reason_posting_key_from_recognized_tax": "derived from recognized tax rate",
            "origin_reason_supplier_iban_extracted_from_document": "extracted directly from the document",
            "origin_reason_supplier_bic_extracted_from_document": "extracted directly from the document",
            "origin_reason_payment_bank_data_extracted_from_document": "set from recognized document bank details",
            "no_data_read_label": "No data recognized.",
            "supplier_external_id_export_validation": "The external ID of the supplier must be specified in the administration area. ",
            "supplier_name_export_validation": "The name of the supplier must be specified in the administration area. ",
            "recognition_was_repeated": "{user_name} repeated the document recognition.",
            "bankdata_recognized_label": "Bank details recognized from document",
            "bankdata_form_source_label": "Bank details in form – source",
            "bankdata_form_changed_label": "Bank details in form – changed",
            "bankdata_matches_masterdata_label": "Bank details in form match master data",
            "bankdata_written_back_label": "New bank details written back to master data",
            "bank_statement_auto_paid_label": "The invoice was marked as paid automatically by bank statement analysis.",
            "payment_date_label": "Payment date",
            "payment_amount_label": "Amount",
            "bank_statement_document_label": "Bank statement",
            "bank_statement_reference_label": "Reference",
            "bank_statement_match_reason_label": "Match reason",
            "bank_statement_match_reason_payment_reference": "Payment reference",
            "bank_statement_match_reason_invoice_number": "Invoice number",
            "bank_statement_match_reason_invoice_number_formatted": "Internal invoice number",
            "bank_statement_match_reason_procurement_number": "Order number",
            "bank_statement_match_reason_supplier_iban": "Supplier IBAN",
            "bank_statement_match_reason_supplier_name": "Supplier",
            "contract_id": "Contract",
            "termination_deadline": "Termination deadline",
            "recipient": "Recipient",
            "error": "Error"
        }
    },
    "login": {
        "email": {
            "title": "Sign in",
            "instructions": "Please enter your email address to sign in.",
            "punchin_instructions": "To complete the process, you need to log in and start the order approval process.",
            "tenant": "Tenant",
            "place_holder": "Email Address",
            "last_used_emails": "Recently used email addresses",
            "delete_last_used_emails": "Delete \"Recently used\"",
            "has_no_account": "Don't have an account yet?",
            "login_link_via_email": "Receive login link via email",
            "finish_login_title": "Complete Login",
            "finish_login_instructions": "You will now receive an email with a login link and a login code. Click the link or enter the six-character code to complete the login. <br><br>The login email was sent to <br><b>{email}</b><br> and should arrive shortly. Please check your spam folder if necessary.",
            "code_instructions": "Alternatively, enter the six-character code from the email:",
            "code_label": "Login code",
            "code_digit_label": "Code character {index}",
            "code_invalid": "The code is incorrect, expired, or has already been used. Please request a new login email.",
            "resend_code": "Send a new login email",
            "forgot_passwort": {
                "title": "Forgot password",
                "login_via_email": "Passwordless login",
                "instructions": "liftbase does not use passwords. Continue with SSO or an email login link, or use the separate passkey button."
            },
            "no_email": "No email",
            "no_email_validation": "Please enter your email address to login.",
            "check_email_title": "Check Email",
            "check_email_message": "Please check your email inbox now and click on the login link or enter the login code."
        },
        "integration": {
            "title": "Connecting integration",
            "instructions": "liftbase is completing the authorization. You will be redirected shortly.",
            "retry": "The connection could not be continued. Please try again.",
            "retry_button": "Reconnect"
        },
        "auto": {
            "login": "Log in",
            "passkey_retry": "Passkey login failed. You can try the passkey button again or continue with SSO or email.",
            "status": {
                "discover": "Checking available login methods...",
                "passkey": "Trying passkey login...",
                "saml": "Trying login with {provider}...",
                "email": "Sending login link and code via email...",
                "code": "Checking login code..."
            }
        },
        "or": "or",
        "saml": {
            "login": "Continue with {provider}",
            "error": "SSO login failed. Please try again.",
            "error_expired": "SSO session expired. Please start login again.",
            "error_mismatch": "The SSO account does not match your email."
        },
        "passkey": {
            "title": "Login with Passkey",
            "login": "Login with passkey",
            "what_is": {
                "title": "What are passkeys?",
                "first": "Login without waiting for email",
                "second": "With your fingerprint, your face or PIN",
                "third": "Set up now in a few steps in your profile"
            },
            "error": "Passkey login failed. Try the passkey button again or continue with SSO or email."
        }
    },
    "languages": {
        "de": "German",
        "en": "English",
        "it": "Italian",
        "cz": "Czech",
        "sk": "Slovak"
    },
    "translation-component": {
        "repeated": "You cannot select the same language multiple times.",
        "language_empty": "You must select the language.",
        "translation_empty": "You must enter the text for this selected language.",
        "both_empty": "You must enter both the language and the text.",
        "language": "Language",
        "no_translation": "There is no text registered for this language.",
        "at_least_one_required": "You must provide at least one name.",
        "text_without_translation": "Without Translation"
    },
    "mailbox": {
        "invoice_lines_group_by_tax": "Group items by tax rate",
        "invoice_lines_group_by_tax_hint": "When enabled, recognized lines are grouped by tax rate (e.g., Sum 19% tax).",
        "ai_validation_mode": "AI validation",
        "ai_validation_mode_none": "No AI validation",
        "ai_skip_to_ready_for_export": "Enable and move to \"Ready for Export\"",
        "ai_skip_to_ready_for_export_hint": "When enabled, the invoice will be moved directly to \"Ready for Export\" status after AI recognition, provided no approval steps are required.",
        "ai_validation_advisory": "Enable and keep status unchanged",
        "ai_validation_advisory_hint": "When enabled, imported invoices are validated by AI, the result is written to the timeline, and score details are shown without skipping the normal workflow.",
        "description": "Mailbox",
        "description_plural": "Mailboxes",
        "name": "Name",
        "username": "Username",
        "password": "Password",
        "host": "Host",
        "port": "Port",
        "smtp_host": "SMTP Host",
        "smtp_port": "SMTP Port",
        "smtp_username": "SMTP Email / Username",
        "smtp_password": "SMTP Password",
        "tab_general": "General",
        "tab_import": "Invoice Import",
        "tab_supplier_communication": "Supplier Communication",
        "tab_historical_import": "Historical E-mails",
        "section_identity": "Mailbox & Protocol",
        "section_assignment": "Assignment",
        "section_incoming": "Mailbox Access",
        "section_processing": "Processing",
        "section_outgoing": "Outgoing",
        "section_historical_import": "Import Historical E-mails",
        "protocol": "Protocol",
        "ms365": "Microsoft 365",
        "ms365_type": "Microsoft 365 Type",
        "ms365_enterprise_app": "MS365 Enterprise App",
        "app_tenant_id": "Tenant ID",
        "app_client_id": "Client ID",
        "client_secret": "Client Secret",
        "folder": "Folder",
        "mailbox": "MailBox",
        "period_in_days": "Period in Days",
        "period_in_days_column": "Period (days)",
        "period_in_days_tooltip": "Age of emails in days",
        "remove_mailbox_msg": "Are you sure you want to remove this mailbox?",
        "remove_mailbox_btn": "Remove",
        "import_invoices_automatically": "Invoices import active",
        "use_for_supplier_communication": "Supplier communication active",
        "use_for_supplier_communication_hint": "If enabled, this mailbox is used to process replies from supplier communications.",
        "supplier_communication_bcase_types": "Supplier communication document types",
        "supplier_communication_bcase_types_hint": "Select the document types for which this mailbox can be used in supplier communication.",
        "supplier_communication_bcase_types_placeholder": "Select one or more document types",
        "import_mode": "Import mode",
        "import_mode_per_attachment": "Create one invoice per email attachment",
        "import_mode_ai_classified_per_attachment": "Import only attachments classified as invoices by AI",
        "import_mode_per_email": "Create one invoice per email",
        "last_import_errors": "Latest import errors",
        "show_import_errors": "Show {count} errors",
        "no_import_errors": "No import errors",
        "check_connection_btn": "Check Connection",
        "connectivity_success_msg": "Connection established successfully.",
        "connectivity_error_msg": "Connection could not be established. Please check your credentials.",
        "connectivity_graph_client_secret_read_access_denied_msg": "Microsoft Graph denied access to this mailbox.<br><br>Please check in Azure that:<ul style='margin:8px 0;padding-left:20px;text-align:left'><li>the Enterprise App has the required Application Permissions:<br><b>Mail.Read</b>, <b>Mail.ReadBasic.All</b>, <b>Mail.ReadWrite</b></li><li>Admin Consent was granted</li><li>the app is allowed to access this mailbox</li></ul>",
        "connectivity_graph_client_secret_access_denied_msg": "Microsoft Graph denied access to this mailbox.<br><br>Please check in Azure that:<ul style='margin:8px 0;padding-left:20px;text-align:left'><li>the Enterprise App has the required Application Permissions:<br><b>Mail.Read</b>, <b>Mail.ReadBasic.All</b>, <b>Mail.ReadWrite</b>, <b>Mail.Send</b></li><li>Admin Consent was granted</li><li>the app is allowed to access this mailbox</li></ul>",
        "connectivity_graph_access_denied_msg": "Microsoft Graph denied access to this mailbox. Please reconnect the mailbox and check whether the user has access to this mailbox.",
        "save_and_connect_btn": "Save and Connect",
        "disconnect_btn": "Disconnect",
        "disconnect_success_msg": "Connection disconnected successfully.",
        "historical_import_info_title": "Import historical supplier communication",
        "historical_import_info": "Import e-mails from this mailbox as communication history. Existing e-mail and invoice imports remain separate.",
        "historical_import_period": "Period",
        "historical_import_range_separator": "to",
        "historical_import_start": "Start date",
        "historical_import_end": "End date",
        "historical_import_invoice_warning_title": "No invoices will be created",
        "historical_import_invoice_warning": "Historical e-mails are stored as communication records. Invoice attachments are not sent through invoice recognition.",
        "historical_import_long_period_confirm": "You selected {days} days. Importing a long period can take a while and create many communication records. Do you want to continue?",
        "historical_import_long_period_title": "Confirm long period",
        "historical_import_include_attachments": "Import communication attachments",
        "historical_import_attachment_limit": "Maximum attachment size (MB)",
        "historical_import_attachment_skipped": "Attachments skipped because of the size limit: {count}",
        "historical_import_preview_btn": "Preview import",
        "historical_import_preview_title": "Import preview",
        "historical_import_preview_processing_title": "Preparing import preview",
        "historical_import_preview_processing_description": "Messages and supplier matches are being checked. Large mailboxes can take a few minutes.",
        "historical_import_preview_processing_elapsed": "Running for {seconds}s",
        "historical_import_authentication_error_title": "Sign-in to the e-mail provider failed",
        "historical_import_authentication_error_description": "The e-mail provider rejected the sign-in for this mailbox. Please check the credentials. Google accounts with two-step verification require an app password.",
        "historical_import_edit_connection_btn": "Edit mailbox details",
        "historical_import_edit_connection_title": "Check mailbox connection",
        "historical_import_edit_connection_description": "Correct the connection details and test them again. The password is not displayed for security reasons.",
        "historical_import_password_placeholder": "Leave empty to keep the existing value",
        "historical_import_save_connection_to_master_data": "Save changes to master data",
        "historical_import_test_and_retry_btn": "Test and try again",
        "historical_import_connection_settings_error": "The mailbox details could not be loaded.",
        "historical_import_connection_test_failed": "The connection could not be established. Please check the details.",
        "historical_import_folder_error_title": "Configured e-mail folder was not found",
        "historical_import_folder_error_description": "The folder configured for this mailbox is not available at the e-mail provider. Please check the folder name in the mailbox configuration.",
        "historical_import_client_missing_error_title": "Assign a company to this mailbox first",
        "historical_import_client_missing_error_description": "Historical invoice onboarding needs the company that owns the mailbox so imported invoices can be assigned correctly.",
        "historical_import_client_required_error_title": "Select a company for this import",
        "historical_import_client_required_error_description": "This mailbox is not assigned to a company. Select a company before starting the preview or import.",
        "historical_import_client_invalid_error_title": "Company could not be used",
        "historical_import_client_invalid_error_description": "The selected company is not available. Please select a valid company.",
        "historical_invoice_onboarding_client_missing_title": "No company is assigned to this mailbox",
        "historical_invoice_onboarding_client_missing_description": "You can choose a fixed company or let invoice recognition determine the company for each invoice.",
        "historical_invoice_onboarding_client_selection_title": "Company for the import",
        "historical_invoice_onboarding_client_selection_description": "Choose which company the imported invoices should be assigned to.",
        "historical_invoice_onboarding_settings_title": "Import settings",
        "historical_invoice_onboarding_settings_description": "Choose the period and the maximum attachment size.",
        "historical_invoice_onboarding_full_recognition": "Use AI to check eligible attachments and fully recognize invoices",
        "historical_invoice_onboarding_full_recognition_cost_title": "Full invoice recognition creates costs",
        "historical_invoice_onboarding_full_recognition_cost_description": "Eligible attachments are checked with AI first. Only documents identified as invoices are fully processed; AI-checked documents incur costs.",
        "historical_invoice_onboarding_full_recognition_gift_title": "Full invoice recognition as a welcome gift",
        "historical_invoice_onboarding_full_recognition_gift_description": "Eligible attachments are checked with AI and fully recognized. At most 30 invoices are processed to get you started.",
        "historical_invoice_onboarding_economic_recognition_title": "Economic master-data recognition",
        "historical_invoice_onboarding_economic_recognition_alert_title": "Build master data at lower cost",
        "historical_invoice_onboarding_economic_recognition_description": "Every invoice attachment is evaluated locally to create or match company and supplier master data. No AI costs arise.",
        "historical_invoice_onboarding_preview_recognition_documents": "Estimated AI checks: {count}",
        "historical_invoice_onboarding_preview_recognition_unit_price": "Current billing price: {price} per successfully recognized invoice",
        "historical_invoice_onboarding_preview_recognition_cost": "Estimated cost: {cost}",
        "historical_invoice_onboarding_preview_recognition_cost_with_margin": "Safety estimate with a {margin}% buffer: up to {cost} (the buffer is not charged)",
        "historical_invoice_onboarding_recognition_cost_confirm_title": "Start paid invoice recognition?",
        "historical_invoice_onboarding_recognition_cost_confirm": "For the selected period, {emails} e-mails were found and are still being checked for import. Of these, approximately {invoices} may be invoices for AI recognition. This results in an estimated total of up to {cost}. The estimate includes a {margin}% safety buffer; only the actual current billing price is charged. Would you like to continue?",
        "historical_invoice_onboarding_analysis_limited_with_recognition": "The analysis and recognition estimate are based on the first {count} emails. The final count can differ.",
        "historical_invoice_onboarding_recognition_requested": "Documents sent for recognition: {count}",
        "historical_invoice_onboarding_recognition_skipped": "Documents evaluated locally for master data: {count}",
        "historical_invoice_onboarding_clients_created": "Companies created: {count}",
        "historical_invoice_onboarding_clients_matched": "Companies matched: {count}",
        "historical_invoice_onboarding_suppliers_created": "Suppliers created: {count}",
        "historical_invoice_onboarding_suppliers_matched": "Suppliers matched: {count}",
        "historical_invoice_onboarding_master_data_conflicts": "Master-data conflicts: {count}",
        "historical_invoice_onboarding_master_data_review_title": "Some master data requires review",
        "historical_invoice_onboarding_master_data_review_description": "{pending} invoices need an assignment. Review the affected invoices below and enter the company or supplier name when no matching entry was found.",
        "historical_invoice_onboarding_master_data_conflicts_title": "{count} master-data conflicts require review",
        "historical_invoice_onboarding_master_data_conflicts_description": "Open the imported invoices and check the assignments. Once you have reviewed them, you can acknowledge this message.",
        "historical_invoice_onboarding_master_data_conflicts_reviewed_btn": "Mark conflicts as reviewed",
        "historical_invoice_onboarding_master_data_conflicts_reviewed_success": "The master-data conflicts were marked as reviewed.",
        "historical_invoice_onboarding_master_data_conflicts_reviewed_error": "The master-data conflicts could not be acknowledged.",
        "historical_invoice_onboarding_master_data_review_btn": "Review master data",
        "historical_invoice_onboarding_master_data_review_card_title": "Open master data assignments",
        "historical_invoice_onboarding_master_data_review_card_description": "The company or supplier could not be assigned automatically for these invoices. You can enter the name directly here.",
        "historical_invoice_onboarding_recognition_mode": "Recognition mode",
        "historical_invoice_onboarding_recognition_mode_economic": "Economic master-data recognition",
        "historical_invoice_onboarding_recognition_mode_full": "Full invoice recognition",
        "historical_invoice_onboarding_item_recognition": "Recognition",
        "historical_invoice_onboarding_item_result": "Result",
        "historical_invoice_onboarding_item_show_result": "View result",
        "historical_invoice_onboarding_item_result_dialog_title": "Invoice recognition result",
        "historical_invoice_onboarding_item_invoice_fallback": "Invoice #{id}",
        "historical_invoice_onboarding_item_open_invoice": "Open invoice",
        "historical_invoice_onboarding_item_client": "Company",
        "historical_invoice_onboarding_item_supplier": "Supplier",
        "historical_invoice_onboarding_item_not_assigned": "Not assigned",
        "historical_invoice_onboarding_item_invoice": "Invoice",
        "historical_invoice_onboarding_manual_client_btn": "Create company",
        "historical_invoice_onboarding_manual_supplier_btn": "Create supplier",
        "historical_invoice_onboarding_manual_name_title": "Create master data manually",
        "historical_invoice_onboarding_manual_name_title_client": "Create new company",
        "historical_invoice_onboarding_manual_name_title_supplier": "Create new supplier",
        "historical_invoice_onboarding_manual_name_description": "No unambiguous entry was found. Enter the name for the {type} and save it so the invoice can be assigned.",
        "historical_invoice_onboarding_manual_name_invoice_context_title": "Recognized invoice data",
        "historical_invoice_onboarding_manual_name_apply_title": "Apply to other open invoices ({count})",
        "historical_invoice_onboarding_manual_name_apply_all_btn": "Select all invoices",
        "historical_invoice_onboarding_manual_name_apply_description": "The following open invoices do not yet have an assignment for this master-data field. Review the selection and assign the new entry only to the matching invoices.",
        "historical_invoice_onboarding_manual_name_label": "Name",
        "historical_invoice_onboarding_manual_name_placeholder": "Enter a name",
        "historical_invoice_onboarding_manual_name_save": "Save and assign",
        "historical_invoice_onboarding_manual_name_save_bulk": "Save and assign to {count} invoices",
        "historical_invoice_onboarding_manual_name_success": "The master data was created and assigned to the invoice.",
        "historical_invoice_onboarding_manual_name_bulk_success": "The master data was created and assigned to {count} invoices.",
        "historical_invoice_onboarding_manual_name_partial_success": "The master data was created and assigned to {assigned} of {requested} invoices. {skipped} invoices were skipped because they were already assigned.",
        "historical_invoice_onboarding_manual_name_no_assignment": "No invoice was assigned. The selected invoices were already assigned.",
        "historical_invoice_onboarding_manual_name_error": "The master data could not be saved.",
        "historical_import_error": "Error",
        "historical_invoice_onboarding_target_client": "Company for the import",
        "historical_invoice_onboarding_mailbox_client_question": "This mailbox is assigned to “{client}”. Use this company for the import?",
        "historical_invoice_onboarding_mailbox_client_question_prefix": "This mailbox is assigned to",
        "historical_invoice_onboarding_mailbox_client_question_client": "“{client}”",
        "historical_invoice_onboarding_mailbox_client_question_suffix": "Use this company for the import?",
        "historical_invoice_onboarding_use_mailbox_client": "Yes, use this company",
        "historical_invoice_onboarding_choose_other_client": "No, choose another company",
        "historical_invoice_onboarding_use_recognition": "Determine company from the invoice",
        "historical_invoice_onboarding_recognition_title": "Company will be determined automatically",
        "historical_invoice_onboarding_recognition_description": "The invoice recognition uses the recipient name and VAT ID. Invoices without a clear match remain available for review.",
        "historical_invoice_onboarding_preview_recognition": "Company: determined from invoice recognition",
        "historical_invoice_onboarding_preview_client": "Target company: {client}",
        "historical_import_inactive_error_title": "Mailbox is disabled",
        "historical_import_inactive_error_description": "Enable this mailbox in its configuration before starting the historical invoice import.",
        "historical_import_historical_invoice_onboarding_failed_error_title": "Historical invoice import failed",
        "historical_import_historical_invoice_onboarding_failed_error_description": "The import could not be completed. Please check the mailbox configuration and try again.",
        "historical_import_preview_total": "Messages found: {count}",
        "historical_import_preview_limited": "Preview is limited to the first {count} messages.",
        "historical_import_preview_ambiguous": "Ambiguous suppliers: {count}",
        "historical_import_preview_unassigned": "Without supplier: {count}",
        "historical_import_previously_processed": "Already processed and excluded: {count}",
        "historical_import_preview_no_eligible": "All messages in the selected period have already been processed and were excluded.",
        "historical_import_incremental_btn": "Import new messages",
        "historical_import_continue_background_btn": "Continue in background",
        "historical_import_cancel_btn": "Cancel import",
        "import_close_confirm_title": "Import is still running",
        "import_close_confirm_message": "The import has not finished yet. Do you want to close this dialog? You can continue the import in the background or cancel it.",
        "import_close_confirm_stay_btn": "Stay in dialog",
        "historical_import_retry_btn": "Resume import",
        "historical_import_retry_failed_btn": "Retry failed parts",
        "historical_invoice_onboarding_finished_btn": "Done",
        "historical_invoice_onboarding_close_btn": "Close",
        "historical_import_match_status": "Supplier match",
        "historical_import_match_matched": "Matched",
        "historical_import_match_ambiguous": "Ambiguous",
        "historical_import_match_none": "Unassigned",
        "historical_import_history_title": "Import history",
        "historical_import_latest_summary": "Last import: {date} · {status} · {count} e-mails",
        "historical_import_previous_attention": "The last import has the status “{status}”.",
        "historical_import_show_history": "Show import history",
        "historical_import_hide_history": "Hide import history",
        "historical_import_active_selection_locked": "The active import must finish before viewing another run.",
        "historical_import_history_period": "Period",
        "historical_import_history_status": "Status",
        "historical_import_history_processed": "Processed",
        "historical_import_history_duration": "Duration",
        "historical_import_duration_seconds": "{count}s",
        "historical_import_duration_minutes_seconds": "{minutes}m {seconds}s",
        "historical_import_start_btn": "Start historical import",
        "historical_import_status_title": "Import status",
        "historical_import_status_pending": "Queued",
        "historical_import_status_running": "Running",
        "historical_import_status_finalizing": "Completing master data",
        "historical_import_status_completed": "Completed",
        "historical_invoice_onboarding_status_completed": "Last import completed",
        "historical_import_status_failed": "Failed",
        "historical_import_status_cancelled": "Cancelled",
        "historical_import_processed": "Processed: {processed} of {total}",
        "historical_import_eta": "Estimated remaining: {duration}",
        "historical_import_created": "Created: {count}",
        "historical_import_matched": "Matched to supplier: {count}",
        "historical_import_skipped": "Skipped: {count}",
        "historical_import_failed": "Failed: {count}",
        "historical_import_messages_title": "Imported historical e-mails",
        "historical_import_messages_selected_title": "E-mails from import on {date}",
        "historical_import_show_all_messages": "Show all imported e-mails",
        "historical_import_show_messages": "Show e-mails",
        "historical_import_hide_messages": "Hide e-mails",
        "historical_import_refresh": "Refresh",
        "historical_import_no_messages": "No historical e-mails imported yet.",
        "historical_import_subject": "Subject",
        "historical_import_sender": "Sender",
        "historical_import_date": "Date",
        "historical_import_supplier": "Supplier",
        "tab_invoice_onboarding": "Invoice onboarding",
        "tab_procurement_onboarding": "Order onboarding",
        "section_procurement_onboarding": "Historical orders",
        "procurement_onboarding_info": "Import past orders as read-only history and use recognized data for master data.",
        "historical_procurement_onboarding_initial_hint_title": "Build your first master data from orders",
        "historical_procurement_onboarding_initial_hint": "The company, suppliers and contacts can be derived from the order mailbox.",
        "historical_procurement_onboarding_confirmed_client": "Confirm company",
        "historical_procurement_onboarding_confirmed_client_placeholder": "Enter the confirmed company name",
        "historical_procurement_onboarding_candidate_evidence": "Candidate found in {count} emails (confidence: {confidence}%). Confirm or correct the company name before importing.",
        "historical_procurement_onboarding_client_required": "Confirm the company before starting the initial import.",
        "historical_procurement_onboarding_period": "Period",
        "historical_procurement_onboarding_mode": "Import mode",
        "historical_procurement_onboarding_economic": "Economic (without AI)",
        "historical_procurement_onboarding_ai": "AI analysis",
        "historical_procurement_onboarding_economic_title": "Economic extraction",
        "historical_procurement_onboarding_economic_hint": "Uses sender, subject, email body and structured text attachments. Limited to the last 30 days.",
        "historical_procurement_onboarding_gift_title": "AI onboarding gift",
        "historical_procurement_onboarding_gift_hint": "Free during initial onboarding. Up to 50 emails or 30 attachments, whichever is reached first.",
        "historical_procurement_onboarding_ai_cost_title": "AI analysis is chargeable",
        "historical_procurement_onboarding_ai_cost_hint": "The estimate is confirmed before import and retained separately in the import cost history.",
        "historical_procurement_onboarding_preview": "Import preview",
        "historical_procurement_onboarding_preview_emails": "Emails checked: {count}",
        "historical_procurement_onboarding_preview_documents": "Estimated AI documents: {count}",
        "historical_procurement_onboarding_preview_cost": "Estimated cost: {cost}",
        "historical_procurement_onboarding_progress": "Processed: {processed}; historical orders created: {imported}; failed: {failed}",
        "historical_procurement_onboarding_analyse": "Analyse",
        "historical_procurement_onboarding_start": "Start import",
        "historical_procurement_onboarding_cost_confirm_title": "Start chargeable order import?",
        "historical_procurement_onboarding_cost_confirm": "Estimated AI cost: {cost}. Continue?",
        "historical_procurement_onboarding_cost_history": "AI import cost history",
        "historical_procurement_onboarding_cost_history_entry": "Estimate: {estimate}; actual: {actual}",
        "historical_procurement_insufficient_order_evidence": "No reliable order evidence was found.",
        "historical_procurement_client_confirmation_required": "Company confirmation is required.",
        "historical_procurement_supplier_review_required": "Supplier needs manual review.",
        "section_invoice_onboarding": "Onboarding from historical invoice mailbox",
        "invoice_onboarding_info": "Imports historical invoice attachments without changing e-mails in the mailbox. Previously processed sources are excluded.",
        "historical_invoice_onboarding_period": "Invoice onboarding period",
        "historical_invoice_onboarding_start": "Start historical invoice onboarding",
        "historical_invoice_onboarding_analysis_btn": "Import analysis",
        "historical_invoice_onboarding_analysis_again_btn": "New import analysis",
        "historical_invoice_onboarding_start_again": "Start import again",
        "historical_invoice_onboarding_completed_title": "The last import is complete",
        "historical_invoice_onboarding_completed_description": "You can close this dialog or select a new period and start another analysis or import.",
        "historical_invoice_onboarding_analysis_title": "Import analysis",
        "historical_invoice_onboarding_analysis_processing_title": "Preparing import analysis",
        "historical_invoice_onboarding_analysis_processing_description": "E-mails and attachments are being checked. The estimated number of recognized invoices and the expected cost are being calculated. Please wait a moment.",
        "historical_invoice_onboarding_analysis_description": "Summary of the e-mails found in the selected period and their possible processing. Individual e-mails are not shown here.",
        "historical_invoice_onboarding_analysis_limited": "The analysis is limited to the first {count} e-mails. The total includes all e-mails found in the selected period.",
        "historical_invoice_onboarding_analysis_failed_title": "Some e-mails could not be analyzed",
        "historical_invoice_onboarding_analysis_failed_description": "{failed} of {processed} checked e-mails could not be analyzed. Check the mailbox details before starting the import.",
        "historical_invoice_onboarding_long_period_confirm": "You selected {days} days. Importing historical invoices can take some time. Do you want to continue?",
        "historical_invoice_onboarding_preview_total": "E-mails found: {count}",
        "historical_invoice_onboarding_analysis_processed": "E-mails checked: {count}",
        "historical_invoice_onboarding_preview_eligible": "E-mails with invoice attachments: {count}",
        "historical_invoice_onboarding_preview_no_attachment": "Without invoice attachment: {count}",
        "historical_invoice_onboarding_preview_failed": "Not analyzed: {count}",
        "historical_invoice_onboarding_preview_failed_title": "Some e-mails could not be analyzed",
        "historical_invoice_onboarding_preview_failed_description": "{count} e-mails could not be analyzed. Check the import details before starting the import.",
        "historical_invoice_onboarding_preview_previously_imported": "Already imported for onboarding: {count}",
        "historical_invoice_onboarding_preview_empty": "No new invoice attachments were found in the selected period.",
        "historical_invoice_onboarding_imported": "Invoice e-mails imported: {count}",
        "historical_invoice_onboarding_master_data_created": "Master data created: {count}",
        "historical_invoice_onboarding_master_data_matched": "Master data matched: {count}",
        "historical_invoice_onboarding_master_data_pending": "Master data needs review: {count}",
        "historical_invoice_onboarding_history": "Onboarding history",
        "historical_invoice_onboarding_items": "E-mails from invoice onboarding on {date}",
        "historical_invoice_onboarding_no_items": "No e-mails have been processed for this invoice onboarding yet.",
        "historical_invoice_onboarding_attachments": "Invoice attachments",
        "historical_invoice_onboarding_item_imported": "Imported",
        "historical_invoice_onboarding_item_skipped": "Skipped",
        "historical_invoice_onboarding_item_failed": "Failed",
        "historical_invoice_onboarding_item_processing": "Processing"
    },
    "marketplace": {
        "description": "Marketplace",
        "description_plural": "Marketplaces",
        "name": "Name / Alias",
        "provider": "Anbieter",
        "country_code": "Land",
        "url": "URL",
        "email": "E-Mail",
        "order_url": "Bestell-URL",
        "order_auth_type": "Order authentication",
        "order_auth_type_none": "None",
        "order_auth_type_basic": "HTTP Basic Auth",
        "order_auth_username": "Username",
        "order_auth_password": "Password",
        "identity": "Identity",
        "secret": "Secret",
        "section_configuration": "Marketplace configuration",
        "section_sender_identity": "Sender / Identity",
        "section_order_authentication": "Order authentication",
        "new": "New Marketplace",
        "amazon_more_clients_info": "Multiple companies are configured in Liftbase. <br>To ensure Amazon Business invoices are assigned to the correct company, <br>please follow the instructions at <br><a href='https://liftbase.de/handbuch/einrichtung/amazon-business-mehrere-unternehmen.' target='_blank'>https://liftbase.de/handbuch/einrichtung/amazon-business-mehrere-unternehmen</a>."
    },
    "payment_options": {
        "label": "Payment method of the supplier company",
        "AUTOMATIC_DEBIT": "Via SEPA Direct Debit",
        "CREDIT_CARD": "Via Credit Card",
        "BANK_TRANSFER": "Via Bank Transfer (IBAN/BIC)",
        "BANK_TRANSFER_FOREIGN": "Foreign Bank Transfer (Account Number/Bank Code)",
        "ONLINE_PAYMENT": "Online payment services"
    },
    "errors": {
        "field_required": "A required field in the form was not provided.",
        "specific_field_required": "The field {field} is required.",
        "invalid_type": "The provided value is invalid.",
        "specific_invalid_type": "The value \"{value}\" is not valid for type {type}.",
        "unique_violation": "This value is already in use.",
        "specific_unique_violation": "There is already a record with this value in the field {field}.",
        "foreign_key_violation": "Invalid reference to another record.",
        "specific_foreign_key_violation": "The value in field {field} could not be linked to an existing record.",
        "permission_denied": "You do not have permission to perform this action.",
        "check_violation": "The entered data does not meet the system criteria.",
        "specific_check_violation": "The value in field {field} does not meet the defined rules.",
        "value_too_long": "The value exceeds the allowed length.",
        "specific_value_too_long": "The value in field {field} exceeds the allowed length.",
        "not_found": "The requested resource was not found.",
        "already_exists": "This item is already registered.",
        "validation_failed": "Data validation failed.",
        "unexpected": "Something went wrong. Please try again or contact support.",
        "specific_field_not_found": "The field {field} was not found in type {type}.",
        "expected_type_but_found": "Expected {field} of type {type}, but found {type_found}.",
        "duplicate_key_violation": "The provided value already exists and violates the unique key constraint {field}.",
        "unexpected_null_value_for_type": "Unexpected null value for type {type}.",
        "timeline_changed": "The document was modified by someone else. The page will refresh automatically. Please review the document again.",
        "timeline_locked": "The document was just modified by {name}. The page was refreshed automatically. Please review the document again.",
        "save_bcase_error": "An error occurred while saving.<br>The form could not be saved.<br>Please check your entries and try again.<br>If the problem persists, please contact support."
    },
    "onboarding": {
        "flow_option": "Configuration",
        "custom_option": "Select demo data individually",
        "custom_option_description": "Select which sample data you want to use – ideal for getting familiar with the system without entering your own data.",
        "full_option": "Use full demo data (recommended)",
        "full_option_description": "Use a complete demo data configuration to start using the system right away – no manual setup needed.",
        "none_option": "Start without demo data",
        "none_option_description": "Start with a clean environment and configure the system entirely with your own data.",
        "invoice_onboarding_option": "Import your historical invoices",
        "invoice_onboarding_option_description": "Connect an existing invoice mailbox and start with real documents instead of demo data.",
        "invoice_onboarding_mailbox_step": "Invoice mailbox",
        "invoice_onboarding_mailbox_step_title": "Choose an invoice mailbox",
        "invoice_onboarding_mailbox_step_description": "Choose an existing mailbox or set up a new one to start the import.",
        "invoice_onboarding_import_step": "Historical invoices",
        "invoice_onboarding_mailbox": "Invoice mailbox",
        "invoice_onboarding_mailbox_placeholder": "Select mailbox",
        "invoice_onboarding_mailbox_default_folder": "INBOX",
        "invoice_onboarding_use_existing_mailbox": "Use an existing mailbox",
        "invoice_onboarding_use_existing_mailbox_description": "Select a mailbox that is already configured for the import.",
        "invoice_onboarding_existing_mailboxes_title": "We found invoice mailboxes that are already configured.",
        "invoice_onboarding_existing_mailboxes_description": "Would you like to use one of them or set up a new mailbox?",
        "invoice_onboarding_create_mailbox": "Set up a new mailbox",
        "invoice_onboarding_create_mailbox_description": "Connect a new mailbox and start the import.",
        "invoice_onboarding_mailbox_setup_step": "Connect mailbox",
        "invoice_onboarding_mailbox_setup_title": "Connect invoice mailbox",
        "invoice_onboarding_mailbox_setup_description": "Enter only the mailbox access details. You can complete further settings later.",
        "invoice_onboarding_mailbox_setup_hint_title": "Your access details are stored securely",
        "invoice_onboarding_mailbox_setup_hint_description": "Read access to the selected folder is sufficient for historical invoices.",
        "invoice_onboarding_mailbox_setup_name_placeholder": "e.g. Invoices",
        "invoice_onboarding_mailbox_setup_protocol_imap": "IMAP access details",
        "invoice_onboarding_mailbox_setup_protocol_imap_description": "For Gmail, GMX, IONOS and other IMAP mailboxes.",
        "invoice_onboarding_mailbox_setup_protocol_ews": "Microsoft Exchange (EWS)",
        "invoice_onboarding_mailbox_setup_protocol_ews_description": "Sign in with your Microsoft 365 user account.",
        "invoice_onboarding_mailbox_setup_protocol_graph": "Microsoft 365 (Microsoft Graph)",
        "invoice_onboarding_mailbox_setup_protocol_graph_description": "Connect an individual user account through Microsoft Graph.",
        "invoice_onboarding_mailbox_setup_protocol_ms365": "Microsoft 365 – enterprise application",
        "invoice_onboarding_mailbox_setup_protocol_ms365_description": "For centrally managed access with tenant ID, app ID and secret.",
        "invoice_onboarding_mailbox_setup_connect_title": "Microsoft 365 sign-in required",
        "invoice_onboarding_mailbox_setup_connect_description": "After saving, the Microsoft sign-in opens in a new window. Then return to this onboarding.",
        "invoice_onboarding_mailbox_setup_host_placeholder": "e.g. imap.your-domain.com",
        "invoice_onboarding_mailbox_setup_save": "Save mailbox and continue",
        "invoice_onboarding_mailbox_setup_save_and_connect": "Save and connect to Microsoft 365",
        "invoice_onboarding_mailbox_setup_saved": "Mailbox has been set up.",
        "invoice_onboarding_no_mailbox": "No active invoice mailbox is configured yet",
        "invoice_onboarding_no_mailbox_description": "Set up an invoice mailbox first to import historical invoices.",
        "invoice_onboarding_configure_mailbox": "Configure mailbox",
        "btn_start": "Let’s go!",
        "btn_finish": "Get started!",
        "select_client": "Please select the companies you want to work with.",
        "select_cost_center": "Please select the cost centers you want to work with.",
        "select_department": "Please select the departments you want to work with.",
        "select_ledger_account": "Please select the ledger accounts you want to work with.",
        "select_posting_key": "Please select the tax keys you want to work with.",
        "select_supplier": "Please select the suppliers you want to work with.",
        "select_product": "Please select the products you want to work with.",
        "general_config": "Please enter the most important basic settings.",
        "profile_config": "Enter important profile information – for faster processes and easier orders."
    },
    "contract": {
        "description": "Contract",
        "name": "Description",
        "contract_date": "Contract date",
        "contract_number_formatted": "CT-number",
        "contract_number": "Contract number",
        "category": "Category",
        "status": "Status",
        "type": "Type",
        "notes": "Note",
        "payment_method": "Payment method",
        "payment_direction": "Direction",
        "external_contract_number": "External contract number",
        "responsible_id": "Responsible",
        "recurring_invoice": "Recurring invoice",
        "start_date": "Start date",
        "end_date": "End date",
        "duration": "Duration",
        "min_duration": "Minimum contract duration",
        "duration_unit_type": "Duration unit",
        "renewal_type": "Renewal type",
        "renewal_duration": "Renewal duration",
        "renewal_duration_unit_type": "Renewal unit",
        "notice_period": "Notice period",
        "notice_period_unit_type": "Notice period unit",
        "termination_special_right": "Special termination right",
        "termination_deadline": "Termination deadline",
        "next_possible_contract_end": "Next possible end date",
        "terminated_on": "Terminated on",
        "termination_to": "Termination to",
        "reminder_date": "Reminder date",
        "reminder_duration": "Reminder before cancellation date",
        "reminder_unit_type": "Cancellation reminder time unit",
        "term_type": "Term type",
        "termination_to_options": {
            "none": "None",
            "day": "Day",
            "year_end": "Year end",
            "half_year_end": "Half year end",
            "quarter_end": "Quarter end",
            "month_end": "Month end",
            "week_end": "Week end"
        },
        "duration_unit_type_options": {
            "month": "Month(s)",
            "quarter": "Quarter",
            "semester": "Half year",
            "year": "Year(s)",
            "week": "Week(s)"
        },
        "renewal_type_options": {
            "auto": "Automatically renewed",
            "none": "No renewal",
            "once": "One-time renewal",
            "manual": "Renewed manually"
        },
        "payment_timing": "Payment timing",
        "payment_timing_options": {
            "advance": "Advance",
            "postpaid": "Postpaid",
            "midterm": "Midterm"
        },
        "usage_type": "Usage frequency",
        "usage_type_options": {
            "usage_based": "Usage based",
            "monthly": "Monthly",
            "quarterly": "Quarterly",
            "semiannually": "Semi-annually",
            "yearly": "Yearly"
        },
        "category_options": {
            "service": "Service",
            "subscription": "Subscription",
            "license": "License",
            "maintenance": "Maintenance",
            "consulting": "Consulting",
            "leasing": "Leasing",
            "rental": "Rental",
            "support": "Support",
            "other": "Other"
        },
        "term_type_options": {
            "fixed": "Fixed term",
            "indefinite": "Indefinite",
            "none": "No term"
        },
        "payment_direction_options": {
            "incoming": "Incoming",
            "outgoing": "Outgoing",
            "both": "Both directions"
        },
        "ai": {
            "back": "Back",
            "add_title": "New contract",
            "add_subtitle": "Choose how you want to create the contract.",
            "manual_title": "Enter contract data",
            "manual_description": "Create the contract manually using the existing form.",
            "ai_title": "Recognize contract with AI",
            "ai_description": "Upload a PDF and review the extracted contract data.",
            "disabled": "AI is disabled for this tenant.",
            "upload_title": "Recognize contract with AI",
            "upload_subtitle": "Upload one or more PDFs. The extracted data will be shown beside the document for review.",
            "upload_info": "Drop contract PDFs here or click to select them.",
            "upload_hint": "PDF only, maximum 30 MB and 50 pages.",
            "file_invalid": "Only PDF files are supported.",
            "file_too_large": "The PDF may not be larger than 30 MB.",
            "file_size": "{size} MB",
            "select_file_preview": "Select a file to see its preview.",
            "start_recognition": "Send contracts for recognition",
            "recognition_failed": "The contract could not be recognized. Please try again.",
            "document_review_hint": "Review the extracted fields before saving.",
            "document_loading": "Loading document…",
            "new_upload": "New upload",
            "document_preview_failed": "The document preview could not be loaded. You can still review and save the extracted data.",
            "client_review": "The document names “{client}” as the client. Please verify the selected company.",
            "persistence_failed": "The contract was created, but the PDF and AI analysis could not be saved yet.",
            "retry_save": "Retry saving"
        },
        "statuses": {
            "active": "Active",
            "inactive": "Inactive",
            "declined": "Cancelled",
            "expired": "Expired",
            "pending": "Pending",
            "recognition": "Recognition",
            "completed": "Signed",
            "check": "Check",
            "clearing": "Contract Clearing"
        },
        "page": {
            "new": "New contract",
            "create_btn": "Create contract",
            "no_edit_permission": "You do not have permission to edit data. Please send the contract for clarification to make changes.",
            "before_leave_msg": "Your contract has not been saved. Are you sure you want to leave the page?",
            "no_procurement": "No orders have been recorded for this contract.",
            "no_invoice": "No invoices have been recorded for this contract.",
            "recognition_data_title": "Recognition raw data",
            "no_recognition_data": "No data recognized.",
            "no_permission_create_contract": "You do not have permission to create a new contract.",
            "period": "Period",
            "no_invoice_for_period": "No invoices for this period.",
            "confirm_before_leave_msg": "Your contract has not been saved. Are you sure you want to leave the page?",
            "reminder_tooltip": "On this day, we will remind you about this contract by email.",
            "tour": {
                "description": "",
                "save_btn": ""
            },
            "validation": {
                "client_id_required": "Please select a company.",
                "department_id_required": "Please select a department.",
                "department_id_required_client_missing": "Select company first.",
                "cost_center_id_required": "Please select a cost center.",
                "cost_center_id_required_filters_missing": "Select company and department first.",
                "cost_center_id_required_department_missing": "Select department first.",
                "cost_center_id_required_client_missing": "Select company first."
            }
        },
        "reminder_type": {
            "contract_end": "Contract end",
            "cancellation_notice": "Cancellation notice",
            "invoice_missing": "Missing invoice",
            "custom": "Custom"
        },
        "procurements": {
            "quantity_ordered": "Ordered",
            "quantity_received": "Received"
        },
        "documents": "Documents"
    },
    "contract_line": {
        "title": "Contract item",
        "new_title": "New contract item",
        "name": "Description",
        "type": "Type",
        "type_options": {
            "service": "Service",
            "product": "Product",
            "license": "License",
            "maintenance": "Maintenance",
            "subscription": "Subscription",
            "other": "Other"
        },
        "item_number": "Item no.",
        "quantity": "Quantity",
        "total": "Total",
        "image_url": "Image URL",
        "webshop_url": "Shop URL",
        "offer_number": "Offer number",
        "offer_date": "Offer date",
        "usage_type": "Usage frequency",
        "add_btn": "Add new item",
        "delete_btn": "Remove contract item",
        "edit_btn": "Edit contract item",
        "confirm_before_delete_msg": "Are you sure you want to permanently delete this item?",
        "confirm_before_delete_title": "Delete item",
        "confirm_before_delete_btn": "Delete"
    },
    "contract_term": {
        "title": "Contract term",
        "add_btn": "Add new contract term",
        "delete_btn": "Remove contract term",
        "edit_btn": "Edit contract term",
        "section_duration": "Duration",
        "section_renewal": "Renewal",
        "section_termination": "Termination",
        "section_reminder": "Reminder",
        "section_term_type": "Term type",
        "term_type_indefinite": "Indefinite contracts have no renewal",
        "show_termination_fields_msg": "Extended contracts can be terminated at the end of the term as follows.",
        "do_not_show_termination_fields_msg": "Fixed-term contracts have a fixed end date and can only be terminated early with special rights.",
        "no_termination_possible_msg": "Contract end reached, termination not possible.",
        "no_renewal_msg": "Indefinite contracts have no renewal"
    },
    "copy_contract_dialog": {
        "title": "Copy data",
        "title_select_contract": "Copy contract data",
        "select_contract": "Select a contract.",
        "message": "Do you want to transfer some data from the contract to this purchase request?",
        "overwrite_checkbox": "Overwrite existing data in the form.",
        "confirm_btn": "Confirm"
    },
    "custom_field": {
        "description": "Custom field",
        "label": "Label",
        "type": "Field type",
        "multilingual": "Multilingual",
        "export_enabled": "Use for export",
        "export_field_name": "Name in {export_name} export",
        "bcase_type": "Document type",
        "bcase_types": {
            "default_value": "Default value",
            "required": "Required field",
            "readonly": "Readonly",
            "show_in_search": "Search field",
            "show_in_export": "Export field",
            "show_in_column_dialog": "Column dialog",
            "show_in_api": "API",
            "order": "Order",
            "visible_in_step_types": "Show in steps",
            "all_steps": "All steps"
        },
        "tooltip": "Tooltip",
        "default_value": "Default value",
        "field_key": "API name",
        "type_options": {
            "text": "Text",
            "textarea": "Multiline text",
            "number": "Number",
            "currency": "Currency",
            "checkbox": "Checkbox",
            "radio": "Selection (radio)",
            "enum": "Dropdown list",
            "date": "Date",
            "html": "Rich Text (HTML)"
        },
        "page": {
            "new_title": "New field",
            "tab_general": "General",
            "tab_options": "Options",
            "tab_validation": "Validation",
            "tab_labels": "Labels",
            "tab_tooltips": "Tooltips",
            "tab_permissions": "Permission groups",
            "tab_clients": "Companies",
            "tab_bcase_types": "Linked document types",
            "tab_bcase_description": "Additional fields",
            "validation": {
                "label_required": "Please enter a label.",
                "field_key_required": "Please enter an API name.",
                "export_field_name_required": "Please enter an export field name."
            },
            "options": {
                "repeated": "You cannot enter the same option more than once.",
                "required_fields": "You must provide the label and the option ID.",
                "language_empty": "You must select a language.",
                "at_least_one_required": "You must provide at least one option."
            }
        }
    },
    "custom_field_label": {
        "description": "Labels"
    },
    "ai_access_request": {
        "title": "Request AI access",
        "headline": "Get more from your data",
        "intro": "With AI access enabled, you can use intelligent features that reduce routine work and speed up your processes.",
        "benefit_recognition_title": "Recognize documents automatically",
        "benefit_recognition_description": "Capture and process invoices and relevant content faster.",
        "benefit_data_title": "Build better master data",
        "benefit_data_description": "Reliably assign companies, suppliers, and document content.",
        "benefit_workflow_title": "Reach results faster",
        "benefit_workflow_description": "Spend less time on manual work and more on important tasks.",
        "description": "AI is not enabled for this tenant yet. Send a request to our sales team to activate access.",
        "action": "Request access",
        "requested": "Your request was sent to the sales team.",
        "already_requested": "A request for this area has already been sent today."
    },
    "custom_field_tooltip": {
        "description": "Tooltips"
    },
    "custom_field_option": {
        "description": "Options"
    },
    "custom_field_bcase_type": {
        "description": "Linked document types",
        "visible_in_step_types": "Show in steps"
    },
    "bcase_custom_field": {
        "description": "Additional fields"
    }
}
